webpackJsonp([1],{

/***/ "../config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-extend-native */
if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__("../node_modules/promise/lib/rejection-tracking.js").enable()
  window.Promise = __webpack_require__("../node_modules/promise/lib/es6-extensions.js")
}

// fetch() polyfill for making API calls.
__webpack_require__("../node_modules/whatwg-fetch/fetch.js")

__webpack_require__("../config/smoothscroll-polyfill.js").polyfill()

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__("../node_modules/object-assign/index.js")

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }

      var o = Object(this)

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0

      // 3. If len is 0, return false.
      if (len === 0) {
        return false
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true
        }
        k++
      }

      // 8. Return false
      return false
    },
  })
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
  }
}

if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0 //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ')
    if (this.length > targetLength) {
      return String(this)
    } else {
      targetLength = targetLength - this.length
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length) //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this)
    }
  }
}


/***/ }),

/***/ "../config/smoothscroll-polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  /*
   * aliases
   * w: window global object
   * d: document
   */
  var w = window;
  var d = document;

  /**
   * indicates if a the current browser is made by Microsoft
   * @method isMicrosoftBrowser
   * @param {String} userAgent
   * @returns {Boolean}
   */
  function isMicrosoftBrowser(userAgent) {
    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
  }

   // polyfill
  function polyfill() {
    // return if scroll behavior is supported and polyfill is not forced
    // if ('scrollBehavior' in d.documentElement.style
    //   && w.__forceSmoothScrollPolyfill__ !== true) {
    //   return;
    // }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now = w.performance && w.performance.now
      ? w.performance.now.bind(w.performance)
      : Date.now;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (firstArg === null
        || typeof firstArg !== 'object'
        || firstArg.behavior === undefined
        || firstArg.behavior === 'auto'
        || firstArg.behavior === 'instant') {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions '
        + firstArg.behavior
        + ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
      }

      if (axis === 'X') {
        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : (w.scrollX || w.pageXOffset),
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : (w.scrollY || w.pageYOffset)
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : (w.scrollX || w.pageXOffset),
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : (w.scrollY || w.pageYOffset)
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
             ? arguments[1]
             : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value couldn\'t be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object'
              ? ~~arguments[0]
              : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined
              ? ~~arguments[1]
              : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined
            ? true
            : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top - 70
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());

/***/ }),

/***/ "../node_modules/medium-editor/dist/css/medium-editor.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/raw-loader/index.js!./media/svg/format_bold.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z\"/></svg>"

/***/ }),

/***/ "../node_modules/raw-loader/index.js!./media/svg/format_italic.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z\"/></svg>"

/***/ }),

/***/ "../node_modules/raw-loader/index.js!./media/svg/format_list_bulleted.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z\"/></svg>"

/***/ }),

/***/ "../node_modules/raw-loader/index.js!./media/svg/format_list_numbered.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z\"/></svg>"

/***/ }),

/***/ "../node_modules/raw-loader/index.js!./media/svg/insert_link.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z\"/></svg>"

/***/ }),

/***/ "./api/HttpError.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HttpError = function (_Error) {
  _inherits(HttpError, _Error);

  function HttpError(message, status) {
    _classCallCheck(this, HttpError);

    var _this = _possibleConstructorReturn(this, _Error.call(this, message));

    _this.message = message;
    _this.status = status;
    _this.name = _this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    _this.stack = new Error().stack;
    return _this;
  }

  return HttpError;
}(Error);

/* harmony default export */ __webpack_exports__["a"] = (HttpError);

/***/ }),

/***/ "./api/addUpload.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_data__ = __webpack_require__("./state/types/data.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var mapFields = {
  products: 'logo',
  users: 'picture',
  contacts: 'picture'
};

var convertFileToBase64 = function convertFileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = function () {
      return resolve({ src: reader.result, title: file.title, rawFile: file.rawFile });
    };
    reader.onerror = reject;
  });
};

var addUploadFeature = function addUploadFeature(requestHandler) {
  return function (type, resource, params) {
    if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_data__["x" /* UPDATE */] || type === __WEBPACK_IMPORTED_MODULE_0__state_types_data__["b" /* CREATE */]) {
      if (mapFields[resource]) {
        var field = mapFields[resource];
        if (params.data[field] && Array.isArray(params.data[field]) && params.data[field].length) {
          var _params$data = params.data,
              image = _params$data[field],
              data = _objectWithoutProperties(_params$data, [field]);

          var newImage = image.filter(function (p) {
            return p.rawFile instanceof File;
          }).shift();

          return convertFileToBase64(newImage).then(function (base64Image) {
            var _extends2;

            return requestHandler(type, resource, _extends({}, params, {
              data: _extends({}, data, (_extends2 = {}, _extends2[field] = { src: base64Image.src, title: base64Image.title }, _extends2))
            }));
          });
        }
      } else if (resource === 'newsletters') {
        if (typeof params.data.status === 'boolean') {
          params.data.status = params.data.status ? 'processed' : 'in-progress';
        }
        if (params.data.data.length) {
          var found = params.data.data.find(function (x) {
            return x.type === 'Card / Image' || x.type === 'Card / Image + Text' || x.type === 'Card / Image + Text (no CTA)' || x.type === 'Card / Akademie + header';
          });
          if (found) {
            var promises = [];
            params.data.data.forEach(function (item) {
              if ((item.type === 'Card / Image' || item.type === 'Card / Image + Text' || item.type === 'Card / Image + Text (no CTA)' || item.type === 'Card / Akademie + header') && item.image && item.image.rawFile instanceof File) {
                promises.push(convertFileToBase64(item.image));
              }
            });
            return Promise.all(promises).then(function (values) {
              var newParams = Object.assign({}, params);
              newParams.data.data.forEach(function (item) {
                if ((item.type === 'Card / Image' || item.type === 'Card / Image + Text' || item.type === 'Card / Image + Text (no CTA)' || item.type === 'Card / Akademie + header') && item.image && item.image.rawFile instanceof File) {
                  var base64Image = values.find(function (x) {
                    return x.rawFile === item.image.rawFile;
                  });
                  item.image = { src: base64Image.src, title: base64Image.title };
                }
              });
              return requestHandler(type, resource, newParams);
            });
          }
        }
      }
    }

    return requestHandler(type, resource, params);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (addUploadFeature);

/***/ }),

/***/ "./api/authClient.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_auth__ = __webpack_require__("./state/types/auth.js");


/* harmony default export */ __webpack_exports__["a"] = (function (type, params) {
  if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["c" /* LOGIN */]) {
    var email = params.email,
        password = params.password;

    var request = new Request("https://newsletter.elovade.com" + '/api/auth', {
      method: 'POST',
      body: JSON.stringify({ email: email, password: password }),
      credentials: 'include',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });
    return fetch(request).then(function (response) {
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      return response.json();
    }).then(function (res) {
      localStorage.setItem('token', res.token);
      return res;
    });
  }
  if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["g" /* LOGOUT */]) {
    localStorage.removeItem('token');
    return Promise.resolve();
  }
  if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["d" /* LOGIN_FAILURE */]) {
    var status = params.status;

    return status === 401 || status === 403 ? Promise.reject() : Promise.resolve();
  }
  if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["a" /* CHECK */]) {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  }
  return Promise.reject('Unknown method');
});

/***/ }),

/***/ "./api/fetch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return queryParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HttpError__ = __webpack_require__("./api/HttpError.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var fetchJson = function fetchJson(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var requestHeaders = options.headers || new Headers({
    Accept: 'application/json'
  });
  if (!requestHeaders.has('Content-Type') && !(options && options.body && options.body instanceof FormData)) {
    requestHeaders.set('Content-Type', 'application/json');
  }
  if (options.user && options.user.authenticated && options.user.token) {
    requestHeaders.set('Authorization', 'Bearer ' + options.user.token);
  }
  return fetch(url, _extends({}, options, { headers: requestHeaders, credentials: 'include' })).then(function (response) {
    return response.text().then(function (text) {
      return {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text
      };
    });
  }).then(function (_ref) {
    var status = _ref.status,
        statusText = _ref.statusText,
        headers = _ref.headers,
        body = _ref.body;

    var json = void 0;
    try {
      json = JSON.parse(body);
    } catch (e) {}
    if (status < 200 || status >= 300) {
      return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__HttpError__["a" /* default */](json && json.message || statusText, status));
    }
    return { status: status, headers: headers, body: body, json: json };
  });
};

var queryParameters = function queryParameters(data) {
  return Object.keys(data).map(function (key) {
    return [key, data[key]].map(encodeURIComponent).join('=');
  }).join('&');
};

/***/ }),

/***/ "./api/simple.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__("./api/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_data__ = __webpack_require__("./state/types/data.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var apiUrl = "https://newsletter.elovade.com" + '/api';

  var convertRESTRequestToHTTP = function convertRESTRequestToHTTP(type, resource, params) {
    var url = '';
    var token = localStorage.getItem('token');
    var options = _extends({}, token && { user: { authenticated: true, token: token }, credentials: 'include' });
    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["i" /* GET_LIST */]:
        {
          var _ref = params.pagination || { page: false, perPage: false },
              page = _ref.page,
              _ref$perPage = _ref.perPage,
              perPage = _ref$perPage === undefined ? 10 : _ref$perPage;

          var _ref2 = params.sort || { field: false, order: false },
              field = _ref2.field,
              order = _ref2.order;

          var query = _extends({}, field && order && { sort: JSON.stringify([field, order.split('/').pop()]) }, page && { offset: (page - 1) * perPage, limit: perPage }, params.filter && { filter: JSON.stringify(params.filter) });
          url = apiUrl + '/' + resource + '?' + Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["b" /* queryParameters */])(query);
          break;
        }
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["s" /* GET_ONE */]:
        url = apiUrl + '/' + resource + '/' + params.id;
        break;
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["v" /* GET_SIMPLE */]:
        url = apiUrl + '/' + resource;
        break;
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["l" /* GET_MANY */]:
        {
          var _query = {
            filter: JSON.stringify({ id: params.ids })
          };
          url = apiUrl + '/' + resource + '?' + Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["b" /* queryParameters */])(_query);
          break;
        }
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["n" /* GET_MANY_REFERENCE */]:
        {
          var _extends2;

          var _params$pagination = params.pagination,
              _page = _params$pagination.page,
              _perPage = _params$pagination.perPage;
          var _params$sort = params.sort,
              _field = _params$sort.field,
              _order = _params$sort.order;

          var _query2 = {
            sort: JSON.stringify([_field, _order]),
            range: JSON.stringify([(_page - 1) * _perPage, _page * _perPage - 1]),
            filter: JSON.stringify(_extends({}, params.filter, (_extends2 = {}, _extends2[params.target] = params.id, _extends2)))
          };
          url = apiUrl + '/' + resource + '?' + Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["b" /* queryParameters */])(_query2);
          break;
        }
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["x" /* UPDATE */]:
        url = apiUrl + '/' + resource + '/' + params.id;
        options.method = 'PUT';
        options.body = JSON.stringify(params.data);
        break;
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["b" /* CREATE */]:
        url = apiUrl + '/' + resource;
        options.method = 'POST';
        options.body = JSON.stringify(params.data);
        break;
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["e" /* DELETE */]:
        url = apiUrl + '/' + resource + '/' + params.id;
        options.method = 'DELETE';
        break;
      default:
        throw new Error('Unsupported fetch action type ' + type);
    }
    return { url: url, options: options };
  };

  var convertHTTPResponseToREST = function convertHTTPResponseToREST(response, type, resource, params) {
    var json = response.json;

    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["i" /* GET_LIST */]:
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["n" /* GET_MANY_REFERENCE */]:
        var total = response.json && (response.json.pagination && response.json.pagination.rowCount || response.json.total) || json[resource].length;

        return {
          data: json[resource],
          total: parseInt(total, 10)
        };
      case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["b" /* CREATE */]:
        return { data: _extends({}, params.data, { id: json.id }) };
      default:
        return { data: json };
    }
  };

  return function (type, resource, params) {
    var _convertRESTRequestTo = convertRESTRequestToHTTP(type, resource, params),
        url = _convertRESTRequestTo.url,
        options = _convertRESTRequestTo.options;

    return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* fetchJson */])(url, options).then(function (response) {
      return convertHTTPResponseToREST(response, type, resource, params);
    });
  };
});

/***/ }),

/***/ "./helpers/chainFunction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chain;
function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
}

/***/ }),

/***/ "./helpers/classNames.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = classNames;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwn = {}.hasOwnProperty;

function classNames() {
  var theme = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  var classes = [];
  var i = args.length - 1;

  if (i === 0 && typeof args[0] === 'string') {
    return theme[args[0]];
  }

  for (; i >= 0; i--) {
    var arg = args[i];
    if (!arg) continue;

    var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

    if (argType === 'string' || argType === 'number') {
      classes.push(theme[arg]);
    } else if (Array.isArray(arg)) {
      classes.push(classNames.apply(undefined, [theme].concat(arg)));
    } else if (argType === 'object') {
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(theme[key]);
        }
      }
    }
  }

  return classes.join(' ');
}

/***/ }),

/***/ "./helpers/cloneReactChildren.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneReactChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function cloneReactChildren(children, props) {
  if (children == null || Array.isArray(children)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props);
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, props);
}

/***/ }),

/***/ "./helpers/domEvents.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitionProperties__ = __webpack_require__("./helpers/transitionProperties.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  getMousePosition: function getMousePosition(event) {
    return {
      x: event.pageX - (window.scrollX || window.pageXOffset),
      y: event.pageY - (window.scrollY || window.pageYOffset)
    };
  },
  getTouchPosition: function getTouchPosition(event) {
    return {
      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
    };
  },
  pauseEvent: function pauseEvent(event) {
    event.stopPropagation();
    event.preventDefault();
  },
  addEventsToDocument: function addEventsToDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.addEventListener(key, eventMap[key], false);
    });
  },
  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.removeEventListener(key, eventMap[key], false);
    });
  },
  targetIsDescendant: function targetIsDescendant(event, parent) {
    var node = event.target;
    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }
    return false;
  },
  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
    element.addEventListener(__WEBPACK_IMPORTED_MODULE_0__transitionProperties__["b" /* default */].end, fn);
    return true;
  },
  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
    element.removeEventListener(__WEBPACK_IMPORTED_MODULE_0__transitionProperties__["b" /* default */].end, fn);
    return true;
  }
});

/***/ }),

/***/ "./helpers/fastDeepEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  if (a === b) return true;

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
    var arrA = isArray(a);
    var arrB = isArray(b);
    var i = void 0;
    var length = void 0;
    var key = void 0;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date;
    var dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp;
    var regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
}
/* unused harmony default export */ var _unused_webpack_default_export = (equal);

/***/ }),

/***/ "./helpers/generateUUID.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateUUID;
function generateUUID() {
  var d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}

/***/ }),

/***/ "./helpers/linkTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var linkTypes = ['play', 'info', 'event', 'download', 'webinar', 'brochure'];

/* harmony default export */ __webpack_exports__["a"] = (linkTypes);

/***/ }),

/***/ "./helpers/objectEquals.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectEquals;
function objectEquals(x, y) {
  if (x === null || x === undefined || y === null || y === undefined) {
    return x === y;
  }

  if (x.constructor !== y.constructor) {
    return false;
  }

  if (x instanceof Function) {
    return x === y;
  }

  if (x instanceof RegExp) {
    return x === y;
  }
  if (x === y || x.valueOf() === y.valueOf()) {
    return true;
  }
  if (Array.isArray(x) && x.length !== y.length) {
    return false;
  }

  if (x instanceof Date) {
    return false;
  }

  if (!(x instanceof Object)) {
    return false;
  }
  if (!(y instanceof Object)) {
    return false;
  }

  var p = Object.keys(x);
  return Object.keys(y).every(function (i) {
    return p.indexOf(i) !== -1;
  }) && p.every(function (i) {
    return objectEquals(x[i], y[i]);
  });
}

/***/ }),

/***/ "./helpers/pad.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pad;
function pad(num) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

  var s = num + '';
  while (s.length < size) {
    s = '0' + s;
  }return s;
}

/***/ }),

/***/ "./helpers/removeEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var isObject = function isObject(obj) {
  return obj && Object.prototype.toString.call(obj) === '[object Object]';
};
var isEmpty = function isEmpty(obj) {
  return obj instanceof Date ? false : obj === '' || obj === null || Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["d" /* shallowEqual */])(obj, {});
};

var removeEmpty = function removeEmpty(object) {
  return Object.keys(object).reduce(function (acc, key) {
    var _extends2;

    var child = object[key];

    if (isObject(object[key])) {
      child = removeEmpty(object[key]);
    }

    return isEmpty(child) ? acc : _extends({}, acc, (_extends2 = {}, _extends2[key] = child, _extends2));
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (removeEmpty);

/***/ }),

/***/ "./helpers/removeKey.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var removeKey = function removeKey(target, path) {
  return Object.keys(target).reduce(function (acc, key) {
    if (key !== path) {
      var _Object$assign;

      return Object.assign({}, acc, (_Object$assign = {}, _Object$assign[key] = target[key], _Object$assign));
    }

    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (removeKey);

/***/ }),

/***/ "./helpers/transitionProperties.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transform */
/* unused harmony export transitionProperty */
/* unused harmony export transitionTiming */
/* unused harmony export transitionDelay */
/* unused harmony export transitionDuration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return transitionEnd; });
/* unused harmony export animationName */
/* unused harmony export animationDuration */
/* unused harmony export animationTiming */
/* unused harmony export animationDelay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEnd; });
var _getTransitionPropert = getTransitionProperties(),
    prefix = _getTransitionPropert.prefix,
    transitionEnd = _getTransitionPropert.transitionEnd,
    animationEnd = _getTransitionPropert.animationEnd;

var transform = prefix + '-transform';
var transitionProperty = prefix + '-transition-property';
var transitionDuration = prefix + '-transition-duration';
var transitionDelay = prefix + '-transition-delay';
var transitionTiming = prefix + '-transition-timing-function';

var animationName = prefix + '-animation-name';
var animationDuration = prefix + '-animation-duration';
var animationTiming = prefix + '-animation-delay';
var animationDelay = prefix + '-animation-timing-function';



/* harmony default export */ __webpack_exports__["b"] = ({
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
});

function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),

/***/ "./helpers/websocket.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReconnectingWebSocket = function () {
  function ReconnectingWebSocket(url, protocols, options) {
    var _this2 = this;

    _classCallCheck(this, ReconnectingWebSocket);

    if (!('WebSocket' in window)) {
      throw new Error('Websocket not supported in browser, please use more modern browser!');
    }

    var settings = {
      debug: false,

      automaticOpen: true,

      reconnectInterval: 1000,

      maxReconnectInterval: 30000,

      reconnectDecay: 1.5,

      timeoutInterval: 2000,

      maxReconnectAttempts: null,

      binaryType: 'blob'
    };
    if (!options) {
      options = {};
    }

    for (var key in settings) {
      if (typeof options[key] !== 'undefined') {
        this[key] = options[key];
      } else {
        this[key] = settings[key];
      }
    }

    this.url = url;

    this.reconnectAttempts = 0;

    this.readyState = WebSocket.CONNECTING;

    this.protocol = null;

    var self = this;
    var forcedClose = false;
    var timedOut = false;
    var eventTarget = document.createElement('div');

    eventTarget.addEventListener('open', function (event) {
      self.onopen(event);
    });
    eventTarget.addEventListener('close', function (event) {
      self.onclose(event);
    });
    eventTarget.addEventListener('connecting', function (event) {
      self.onconnecting(event);
    });
    eventTarget.addEventListener('message', function (event) {
      self.onmessage(event);
    });
    eventTarget.addEventListener('error', function (event) {
      self.onerror(event);
    });

    this.addEventListener = eventTarget.addEventListener.bind(eventTarget);
    this.removeEventListener = eventTarget.removeEventListener.bind(eventTarget);
    this.dispatchEvent = eventTarget.dispatchEvent.bind(eventTarget);

    function generateEvent(s, args) {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(s, false, false, args);
      return evt;
    }

    this.open = function (reconnectAttempt) {
      var _this = this;

      this.ws = new WebSocket(self.url, protocols || []);
      this.ws.binaryType = this.binaryType;

      if (reconnectAttempt) {
        if (this.maxReconnectAttempts && this.reconnectAttempts > this.maxReconnectAttempts) {
          return;
        }
      } else {
        eventTarget.dispatchEvent(generateEvent('connecting'));
        this.reconnectAttempts = 0;
      }

      if (self.debug || ReconnectingWebSocket.debugAll) {
        console.debug('ReconnectingWebSocket', 'attempt-connect', self.url);
      }

      var localWs = this.ws;
      var timeout = setTimeout(function () {
        if (self.debug || ReconnectingWebSocket.debugAll) {
          console.debug('ReconnectingWebSocket', 'connection-timeout', self.url);
        }
        timedOut = true;
        localWs.close();
        timedOut = false;
      }, self.timeoutInterval);

      this.ws.onopen = function (event) {
        clearTimeout(timeout);
        if (self.debug || ReconnectingWebSocket.debugAll) {
          console.debug('ReconnectingWebSocket', 'onopen', self.url);
        }
        self.protocol = _this.ws.protocol;
        self.readyState = WebSocket.OPEN;
        self.reconnectAttempts = 0;
        var e = generateEvent('open');
        e.isReconnect = reconnectAttempt;
        reconnectAttempt = false;
        eventTarget.dispatchEvent(e);
      };

      this.ws.onclose = function (event) {
        clearTimeout(timeout);
        _this.ws = null;
        if (forcedClose) {
          self.readyState = WebSocket.CLOSED;
          eventTarget.dispatchEvent(generateEvent('close'));
        } else {
          self.readyState = WebSocket.CONNECTING;
          var e = generateEvent('connecting');
          e.code = event.code;
          e.reason = event.reason;
          e.wasClean = event.wasClean;
          eventTarget.dispatchEvent(e);
          if (!reconnectAttempt && !timedOut) {
            if (self.debug || ReconnectingWebSocket.debugAll) {
              console.debug('ReconnectingWebSocket', 'onclose', self.url);
            }
            eventTarget.dispatchEvent(generateEvent('close'));
          }

          var timeoutTime = self.reconnectInterval * Math.pow(self.reconnectDecay, self.reconnectAttempts);
          timeout = setTimeout(function () {
            self.reconnectAttempts++;
            self.open(true);
          }, timeoutTime > self.maxReconnectInterval ? self.maxReconnectInterval : timeoutTime);
        }
      };

      this.ws.onmessage = function (event) {
        if (self.debug || ReconnectingWebSocket.debugAll) {
          console.debug('ReconnectingWebSocket', 'onmessage', self.url, event.data);
        }
        var e = generateEvent('message');
        e.data = event.data;
        eventTarget.dispatchEvent(e);
      };

      this.ws.onerror = function (event) {
        if (self.debug || ReconnectingWebSocket.debugAll) {
          console.debug('ReconnectingWebSocket', 'onerror', self.url, event);
        }
        eventTarget.dispatchEvent(generateEvent('error'));
      };
    };

    if (this.automaticOpen == true) {
      this.open(false);
    }

    this.send = function (data) {
      if (_this2.ws) {
        if (self.debug || ReconnectingWebSocket.debugAll) {
          console.debug('ReconnectingWebSocket', 'send', self.url, data);
        }
        return _this2.ws.send(data);
      } else {
        throw new Error('INVALID_STATE_ERR : Pausing to reconnect websocket');
      }
    };

    this.close = function (code, reason) {
      if (typeof code == 'undefined') {
        code = 1000;
      }
      forcedClose = true;
      if (_this2.ws) {
        _this2.ws.close(code, reason);
      }
    };

    this.refresh = function () {
      if (_this2.ws) {
        _this2.ws.close();
      }
    };
  }

  ReconnectingWebSocket.prototype.onopen = function onopen(event) {};

  ReconnectingWebSocket.prototype.onclose = function onclose(event) {};

  ReconnectingWebSocket.prototype.onconnecting = function onconnecting(event) {};

  ReconnectingWebSocket.prototype.onmessage = function onmessage(event) {};

  ReconnectingWebSocket.prototype.onerror = function onerror(event) {};

  return ReconnectingWebSocket;
}();

ReconnectingWebSocket.debugAll = false;

ReconnectingWebSocket.CONNECTING = WebSocket.CONNECTING;
ReconnectingWebSocket.OPEN = WebSocket.OPEN;
ReconnectingWebSocket.CLOSING = WebSocket.CLOSING;
ReconnectingWebSocket.CLOSED = WebSocket.CLOSED;

/* harmony default export */ __webpack_exports__["a"] = (ReconnectingWebSocket);

/***/ }),

/***/ "./i18n/TranslationProvider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_polyglot__ = __webpack_require__("../node_modules/node-polyglot/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messages__ = __webpack_require__("./i18n/messages.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var withI18nContext = Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["e" /* withContext */])({
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}, function (_ref) {
  var locale = _ref.locale,
      _ref$messages = _ref.messages,
      messages = _ref$messages === undefined ? {} : _ref$messages;

  var userMessages = messages[locale] || {};
  var polyglot = new __WEBPACK_IMPORTED_MODULE_2_node_polyglot___default.a({
    locale: locale,
    phrases: _extends({}, __WEBPACK_IMPORTED_MODULE_5__messages__["a" /* default */], userMessages)
  });

  return {
    locale: locale,
    translate: polyglot.t.bind(polyglot)
  };
});

var TranslationProvider = function TranslationProvider(_ref2) {
  var children = _ref2.children;
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
};

TranslationProvider.propTypes = {
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  messages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};

var mapStateToProps = function mapStateToProps(state) {
  return { locale: state.locale };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps), withI18nContext)(TranslationProvider));

/***/ }),

/***/ "./i18n/TranslationUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolveBrowserLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./i18n/index.js");


var resolveBrowserLocale = function resolveBrowserLocale() {
  var _window$navigator = window.navigator,
      language = _window$navigator.language,
      browserLanguage = _window$navigator.browserLanguage,
      userLanguage = _window$navigator.userLanguage;

  return (language || browserLanguage || userLanguage || __WEBPACK_IMPORTED_MODULE_0__index__["a" /* DEFAULT_LOCALE */]).split('-')[0];
};

/***/ }),

/***/ "./i18n/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_LOCALE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TranslationUtils__ = __webpack_require__("./i18n/TranslationUtils.js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messages__ = __webpack_require__("./i18n/messages.js");
/* unused harmony reexport englishMessages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate__ = __webpack_require__("./i18n/translate.js");
/* unused harmony reexport translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TranslationProvider__ = __webpack_require__("./i18n/TranslationProvider.js");
/* unused harmony reexport TranslationProvider */
var DEFAULT_LOCALE = 'en';







/***/ }),

/***/ "./i18n/messages.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: {
    action: {
      delete: 'Delete',
      show: 'Show',
      list: 'List',
      save: 'Save',
      create: 'Create',
      edit: 'Edit',
      cancel: 'Cancel',
      refresh: 'Refresh',
      add_filter: 'Add filter',
      remove_filter: 'Remove this filter'
    },
    auth: {
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      sign_in_error: 'Authentication failed, please retry',
      logout: 'Logout',
      forgot: 'Forgot your password?'
    },
    boolean: {
      true: 'Yes',
      false: 'No'
    },
    page: {
      list: '%{name}',
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      create: 'Create %{name}',
      delete: 'Delete %{name} #%{id}'
    },
    input: {
      image: {
        upload_several: 'Drop some files to upload, or click to select one.',
        upload_single: 'Drop a file to upload, or click to select it.'
      }
    },
    message: {
      yes: 'Yes',
      no: 'No',
      are_you_sure: 'Are you sure ?',
      about: 'About'
    },
    navigation: {
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      no_results: 'No results',
      next: 'Next',
      prev: 'Prev'
    },
    notification: {
      updated: 'Element updated',
      created: 'Element created',
      deleted: 'Element deleted',
      item_doesnt_exist: 'Element does not exist'
    },
    validation: {
      required: 'Required'
    }
  },
  app: {
    status: {
      'in-progress': 'In progress',
      processed: 'Processed'
    }
  }
});

/***/ }),

/***/ "./i18n/translate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");



var translate = function translate(BaseComponent) {
  var TranslatedComponent = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* getContext */])({
    translate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    locale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  })(BaseComponent);

  TranslatedComponent.defaultProps = BaseComponent.defaultProps;

  return TranslatedComponent;
};

/* harmony default export */ __webpack_exports__["a"] = (translate);

/***/ }),

/***/ "./icons/Add.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  { fill: 'none' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0 40h40V0H0z' }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'currentColor', d: 'M26.5 12c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h11zm.5 12.5v-11a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5zM25.5 27a.5.5 0 0 1 0 1h-12c-.827 0-1.5-.673-1.5-1.5v-12a.5.5 0 0 1 1 0v12a.5.5 0 0 0 .5.5h12zm-1-9a.5.5 0 0 1 0 1H22v2.5a.5.5 0 0 1-1 0V19h-2.5a.5.5 0 0 1 0-1H21v-2.5a.5.5 0 0 1 1 0V18h2.5z' })
);

var Add = function Add(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Add);

/***/ }),

/***/ "./icons/AddCircle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm28.4 21.6v-3.2h-6.8v-6.8h-3.2v6.8h-6.8v3.2h6.8v6.8h3.2v-6.8h6.8z m-8.4-18.2c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z' })
);

var AddCircle = function AddCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AddCircle);

/***/ }),

/***/ "./icons/ArrowDropDown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm10 15h20l-10 10z' })
);

var ArrowDropDown = function ArrowDropDown(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
        _extends({ viewBox: '0 0 40 40' }, props),
        _ref
    );
};

/* harmony default export */ __webpack_exports__["a"] = (ArrowDropDown);

/***/ }),

/***/ "./icons/CheckBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm16.6 28.4l15-15-2.3-2.5-12.7 12.7-5.9-5.9-2.3 2.3z m15-23.4c1.9 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.5 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.5-3.4 3.4-3.4h23.2z' })
);

var CheckBox = function CheckBox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CheckBox);

/***/ }),

/***/ "./icons/CheckBoxOutlineBlank.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm31.6 5q1.4 0 2.4 1t1 2.4v23.2q0 1.4-1 2.4t-2.4 1h-23.2q-1.4 0-2.4-1t-1-2.4v-23.2q0-1.4 1-2.4t2.4-1h23.2z m0 3.4h-23.2v23.2h23.2v-23.2z' })
);

var MdCheckBoxOutlineBlank = function MdCheckBoxOutlineBlank(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MdCheckBoxOutlineBlank);

/***/ }),

/***/ "./icons/Delete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M21,17.5 L21,24.5 C21,24.776 21.224,25 21.5,25 C21.776,25 22,24.776 22,24.5 L22,17.5 C22,17.224 21.776,17 21.5,17 C21.224,17 21,17.224 21,17.5 Z M24,26.5 C24,26.776 23.776,27 23.5,27 L16.5,27 C16.224,27 16,26.776 16,26.5 L16,15 L17.5,15 L22.5,15 L24,15 L24,26.5 Z M18,13.5 C18,13.224 18.224,13 18.5,13 L21.5,13 C21.776,13 22,13.224 22,13.5 L22,14 L18,14 L18,13.5 Z M24.5,14 L23,14 L23,13.5 C23,12.673 22.327,12 21.5,12 L18.5,12 C17.673,12 17,12.673 17,13.5 L17,14 L15.5,14 L13.5,14 C13.224,14 13,14.224 13,14.5 C13,14.776 13.224,15 13.5,15 L15,15 L15,26.5 C15,27.327 15.673,28 16.5,28 L23.5,28 C24.327,28 25,27.327 25,26.5 L25,15 L26.5,15 C26.776,15 27,14.776 27,14.5 C27,14.224 26.776,14 26.5,14 L24.5,14 Z M18,17.5 L18,24.5 C18,24.776 18.224,25 18.5,25 C18.776,25 19,24.776 19,24.5 L19,17.5 C19,17.224 18.776,17 18.5,17 C18.224,17 18,17.224 18,17.5 Z' })
);

var Delete = function Delete(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Delete);

/***/ }),

/***/ "./icons/Edit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M20.46 25.247l-.323 1.616 1.616-.323 4.98-4.98a.904.904 0 0 0 .267-.644.903.903 0 0 0-.267-.643.914.914 0 0 0-1.293-.006l-4.98 4.98zM22 27h.01H22zm-2.5 1a.499.499 0 0 1-.49-.598l.5-2.5a.506.506 0 0 1 .136-.255l5.087-5.087a1.911 1.911 0 0 1 2.701 0A1.9 1.9 0 0 1 28 20.916c0 .51-.199.99-.56 1.35l-5.087 5.088a.506.506 0 0 1-.255.137l-2.5.5A.55.55 0 0 1 19.5 28zm-2-2h-4c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h7.086c.401 0 .778.156 1.061.44l1.914 1.914c.283.283.439.66.439 1.06V17.5a.5.5 0 0 1-1 0v-2.086a.503.503 0 0 0-.146-.353l-1.915-1.915a.495.495 0 0 0-.353-.146H13.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1z' })
);

var Edit = function Edit(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Edit);

/***/ }),

/***/ "./icons/HasSort.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
    d: 'M8,16.7928932 L10,16.7928932 L12,14.7928932 L14,16.7928932 L16,16.7928932 L12.3535534,13.1464466 L12.3535534,13.1464466 C12.1582912,12.9511845 11.8417088,12.9511845 11.6464466,13.1464466 L8,16.7928932 Z',
    transform: 'matrix(1 0 0 -1 0 29.793)'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M8,11 L10,11 L12,9 L14,11 L16,11 L12.3535534,7.35355339 L12.3535534,7.35355339 C12.1582912,7.15829124 11.8417088,7.15829124 11.6464466,7.35355339 L8,11 Z' })
);

var HasSort = function HasSort(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 24 24' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (HasSort);

/***/ }),

/***/ "./icons/Icon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var IconBase = function IconBase(_ref, _ref2) {
  var _ref2$reactIconBase = _ref2.reactIconBase,
      reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      width = _ref.width,
      height = _ref.height,
      props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);

  var computedSize = size || reactIconBase.size || '1em';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

IconBase.contextTypes = {
  reactIconBase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(IconBase.propTypes)
};

/* harmony default export */ __webpack_exports__["a"] = (IconBase);

/***/ }),

/***/ "./icons/Mail.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
      d: 'M0.309,10.538 L23.15,1.104 L8.621,14.695 L0.319,11.466 C0.128,11.392 0.002,11.21 7.21644966e-16,11.007 C-0.002,10.801 0.12,10.616 0.309,10.538 Z M9.01,15.7 L23.966,1.71 L19.988,20.105 C19.955,20.261 19.851,20.39 19.707,20.455 C19.57,20.518 19.401,20.517 19.259,20.437 L13.219,17.116 L9.932,22.752 C9.841,22.908 9.674,23 9.5,23 C9.221,23 9,22.774 9,22.5 L9,15.69 L9.01,15.7 Z',
      fill: '#FFFFFF',
      fillRule: 'nonzero'
    })
  )
);

var Mail = function Mail(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 24 24' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Mail);

/***/ }),

/***/ "./icons/MailDownload.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M26,13.6693675 L21.1513,17.3763 C20.6913,17.7953 20.1033,18.0073 19.5103,18.0073 C18.9073,18.0073 18.3003,17.7883 17.8163,17.3483 L13,13.6699909 L13,21.5 C13,21.776 13.224,22 13.5,22 L17.5,22 C17.776,22 18,22.224 18,22.5 C18,22.776 17.776,23 17.5,23 L13.5,23 C12.673,23 12,22.327 12,21.5 L12,13.5 C12,12.673 12.673,12 13.5,12 L25.5,12 C26.327,12 27,12.673 27,13.5 L27,18 C27,18.276 26.776,18.5 26.5,18.5 C26.224,18.5 26,18.276 26,18 L26,13.6693675 Z M25.2281521,13 L13.7710619,13 L18.4563,16.5813 C19.0663,17.1343 19.9353,17.1333 20.5103,16.6093 L25.2281521,13 Z M24,24.292 L24.646,23.646 C24.842,23.451 25.158,23.451 25.354,23.646 C25.549,23.842 25.549,24.158 25.354,24.354 L23.854,25.854 C23.756,25.951 23.628,26 23.5,26 C23.436,26 23.372,25.98775 23.31175,25.963375 C23.2515,25.939 23.195,25.9025 23.146,25.854 L21.646,24.354 C21.451,24.158 21.451,23.842 21.646,23.646 C21.842,23.451 22.158,23.451 22.354,23.646 L23,24.292 L23,21.5 C23,21.224 23.224,21 23.5,21 C23.776,21 24,21.224 24,21.5 L24,24.292 Z M23.5,28 C21.019,28 19,25.981 19,23.5 C19,21.019 21.019,19 23.5,19 C25.981,19 28,21.019 28,23.5 C28,25.981 25.981,28 23.5,28 Z M23.5,20 C21.57,20 20,21.57 20,23.5 C20,25.43 21.57,27 23.5,27 C25.43,27 27,25.43 27,23.5 C27,21.57 25.43,20 23.5,20 Z' })
);

var MailDownload = function MailDownload(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MailDownload);

/***/ }),

/***/ "./icons/Remove.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M20,12 C24.411,12 28,15.589 28,20 C28,24.411 24.411,28 20,28 C15.589,28 12,24.411 12,20 C12,15.589 15.589,12 20,12 Z M20,27 C23.86,27 27,23.86 27,20 C27,16.14 23.86,13 20,13 C16.14,13 13,16.14 13,20 C13,23.86 16.14,27 20,27 Z M23.8535,16.1465 C24.0485,16.3415 24.0485,16.6585 23.8535,16.8535 L20.7075,20.0005 L23.8535,23.1465 C24.0485,23.3415 24.0485,23.6585 23.8535,23.8535 C23.7555,23.9515 23.6275,24.0005 23.4995,24.0005 C23.3725,24.0005 23.2445,23.9515 23.1465,23.8535 L19.9995,20.7075 L16.8535,23.8535 C16.7555,23.9515 16.6275,24.0005 16.4995,24.0005 C16.3725,24.0005 16.2445,23.9515 16.1465,23.8535 C15.9515,23.6585 15.9515,23.3415 16.1465,23.1465 L19.2925,20.0005 L16.1465,16.8535 C15.9515,16.6585 15.9515,16.3415 16.1465,16.1465 C16.3415,15.9515 16.6585,15.9515 16.8535,16.1465 L19.9995,19.2925 L23.1465,16.1465 C23.3415,15.9515 23.6585,15.9515 23.8535,16.1465 Z' })
);

var Remove = function Remove(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Remove);

/***/ }),

/***/ "./icons/RemoveCircle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  { fill: 'none' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0 40h40V0H0z' }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: 'currentColor', d: 'M20 12c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 15c3.86 0 7-3.14 7-7s-3.14-7-7-7-7 3.14-7 7 3.14 7 7 7zm3.854-10.854a.5.5 0 0 1 0 .707L20.707 20l3.146 3.146a.5.5 0 0 1-.707.707L20 20.707l-3.146 3.146a.5.5 0 1 1-.707-.707L19.293 20l-3.146-3.146a.5.5 0 0 1 .707-.707L20 19.293l3.146-3.146a.5.5 0 0 1 .707 0z' })
);

var RemoveCircle = function RemoveCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RemoveCircle);

/***/ }),

/***/ "./icons/Sort.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
    d: 'M8.20710678,15 L15.7928932,15 L15.7928932,15 C16.0690356,15 16.2928932,14.7761424 16.2928932,14.5 C16.2928932,14.3673918 16.2402148,14.2402148 16.1464466,14.1464466 L12.3535534,10.3535534 L12.3535534,10.3535534 C12.1582912,10.1582912 11.8417088,10.1582912 11.6464466,10.3535534 L7.85355339,14.1464466 L7.85355339,14.1464466 C7.65829124,14.3417088 7.65829124,14.6582912 7.85355339,14.8535534 C7.94732158,14.9473216 8.07449854,15 8.20710678,15 Z',
    transform: 'matrix(1 0 0 -1 0 25)'
  })
);

var MdSort = function MdSort(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 24 24' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MdSort);

/***/ }),

/***/ "./icons/TriangleLeft.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm12.5 20l15 15v-30l-15 15z' })
);

var GoTriangleLeft = function GoTriangleLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GoTriangleLeft);

/***/ }),

/***/ "./icons/TriangleRight.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'm12.5 5l15 15-15 15v-30z' })
);

var GoTriangleRight = function GoTriangleRight(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GoTriangleRight);

/***/ }),

/***/ "./icons/UserOff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__("./icons/Icon.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'g',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { id: 'user-off-a', d: 'M23.5,26.9992 C21.57,26.9992 20,25.4292 20,23.4992 C20,21.5702 21.57,19.9992 23.5,19.9992 C25.43,19.9992 27,21.5702 27,23.4992 C27,25.4292 25.43,26.9992 23.5,26.9992 M23.5,18.9992 C21.019,18.9992 19,21.0182 19,23.4992 C19,25.9802 21.019,27.9992 23.5,27.9992 C25.981,27.9992 28,25.9802 28,23.4992 C28,21.0182 25.981,18.9992 23.5,18.9992 M19.227,19.5582 C19.335,19.3042 19.216,19.0102 18.962,18.9022 C18.34,18.6372 17.681,18.5022 17.005,18.5012 L17.002,18.5012 C14.246,18.5012 12.002,20.7442 12,23.5002 C12,23.7772 12.224,24.0002 12.5,24.0002 L12.5,24.0002 C12.776,24.0002 13,23.7772 13,23.5012 C13.001,21.2952 14.796,19.5012 17.002,19.5012 L17.005,19.5012 C17.545,19.5022 18.072,19.6102 18.571,19.8222 C18.824,19.9302 19.119,19.8122 19.227,19.5582 M25.354,21.6452 C25.158,21.4502 24.842,21.4502 24.646,21.6452 L23.5,22.7912 L22.354,21.6452 C22.158,21.4502 21.842,21.4502 21.646,21.6452 C21.451,21.8402 21.451,22.1572 21.646,22.3522 L22.793,23.4992 L21.646,24.6452 C21.451,24.8402 21.451,25.1572 21.646,25.3532 C21.744,25.4502 21.872,25.4992 22,25.4992 C22.128,25.4992 22.256,25.4502 22.354,25.3532 L23.5,24.2062 L24.646,25.3532 C24.744,25.4502 24.872,25.4992 25,25.4992 C25.128,25.4992 25.256,25.4502 25.354,25.3532 C25.549,25.1572 25.549,24.8402 25.354,24.6452 L24.207,23.4992 L25.354,22.3522 C25.549,22.1572 25.549,21.8402 25.354,21.6452 M17,13.0002 C18.241,13.0002 19.25,14.0102 19.25,15.2502 C19.25,16.4912 18.241,17.5002 17,17.5002 C15.759,17.5002 14.75,16.4912 14.75,15.2502 C14.75,14.0102 15.759,13.0002 17,13.0002 M17,18.5002 C18.792,18.5002 20.25,17.0422 20.25,15.2502 C20.25,13.4582 18.792,12.0002 17,12.0002 C15.208,12.0002 13.75,13.4582 13.75,15.2502 C13.75,17.0422 15.208,18.5002 17,18.5002' })
);

var User = function User(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */],
    _extends({ viewBox: '0 0 40 40' }, props),
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "./index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_fonts_css__ = __webpack_require__("./styles/fonts.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_store__ = __webpack_require__("./state/store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Main__ = __webpack_require__("./view/Main/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Theme_ThemeProvider__ = __webpack_require__("./ui/Theme/ThemeProvider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_DevError_ErrorBoundary__ = __webpack_require__("./ui/DevError/ErrorBoundary.js");













var isProduction = "production" === 'production';
var rootElement = document.getElementById('root');

var renderApplication = function renderApplication(ApplicationComponent) {
  if (isProduction) {
    Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"],
      { store: __WEBPACK_IMPORTED_MODULE_4__state_store__["a" /* store */] },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Theme_ThemeProvider__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApplicationComponent, null)
      )
    ), rootElement);
  } else {
    console.log('rendering application');
    var AppContainer = __webpack_require__("../node_modules/react-hot-loader/index.js").AppContainer;

    var noHoist = {};

    Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      AppContainer,
      noHoist,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__ui_DevError_ErrorBoundary__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"],
          { store: __WEBPACK_IMPORTED_MODULE_4__state_store__["a" /* store */] },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__ui_Theme_ThemeProvider__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApplicationComponent, null)
          )
        )
      )
    ), rootElement);
  }
};

renderApplication(__WEBPACK_IMPORTED_MODULE_5__view_Main__["default"]);

if (!isProduction && module.hot) {
  module.hot.accept('./view/Main', function () {
    var NewApp = __webpack_require__("./view/Main/index.js").default;

    renderApplication(NewApp);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./media/el-logo.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAAAuCAYAAADN2j7vAAAAAXNSR0IArs4c6QAADZZJREFUeAHtm3uU1VUVx+/AACIgBGLyUEeUyBIRwVYaIYIIAiWKtRJTXoKiEWj90UqUp6W1SAhzLSudYkUEAfLSGiMZCQQUeYRQLEFAAUFQXg7xdPp8f9xz15lzf797B7zzuOuevdZ3zj577/Pa5+z9O7/fzMRinrwHssQDpVCWTDWj06yR0d58Z94D3gMZ94AP0oy71HfoPZBZD/ggzaw/fW/eAxn3gA/SjLvUd+g9kFkP+CDNrD99b94DGfeAD9KMu9R36D2QWQ/4IM2sP31v3gMZ90B+7IdFJ0J7zYutiE3pcVOozgu9B7wHKs0D+bFYaa3Q0Urz0HnyHvAeqGoP+OtuVe+AH997II0HfJCmcZBXew9UtQd8kFb1DvjxvQfSeMAHaRoHebX3QFV7ID+Wl7c6dBKlpTtjj7zaMVRXbmH9jbFnbvyfa84/M9RD1tiVO/XTeXl5u42MNi3gw5JKCXafGLuwkrZNkZ8XprNkR+jnoOrYy1ZtwugQdofDFLSrg/yiMF2IrJR+dkoesrb96JL8FtJHIKJ9c5ialv4E7fda9TIs9rURfLGMMBbbSZvQ/zLBXh8Rmzn2u7D/zJEFVey1Tzo7N4OWoAHQXm4HC2i3h9JTOT2QF2n3aNGNsVOlyyP15VHUqNE+NvnWda4pmzgQWaErd+r72MzEgafNx+ijAvsouiVgAm1WOf0oCF5F1t2VO/UptB0lGfY9Kf7m6O2qksIKMJE2K42CdhpDY5WHPqNtEFi0O0CDRlajvujmW/VIlraXotwG7AT2KfWL6aMkrCFtbkD+hqMbg/14RxZUsb8KZpOja4r9fkcm3/VHNha0dnXx+knK2WAk7fdF2ISK6VuJLfrMhrbKfqG9sdm8mvOZfG9QzD5ek4GFhD5RrH6VLDTeCsZ72JJXBTuQQd19rI/srrOczBjWouR0TkTbWuCPNJ4OogJUfdcCd4NV2Cv4PaXxgLu5acyrvfo8Zjihkmf5Kw5b20oeMxiOcfVUGRQxdpQ8wjwI9On0WRBlkEb+a/T3pbGx1ZdTmc942jNPKTxQXf5gQde9Sc48Q69qlo2eYLpq6jD+wJK3s/gothjFYkf5plXPs3ixx4ECUe9+w4CudIb0ftcLbABbwGhgaCjMZaZCqTGL4/XQ97m4rrxFVwwLIow7EwCXczvUVdgld31GrxvCbNp1ot0xI6SMsg9MsL8F5kHLXqyutT8FerJqL78GngIdgCE9cR8DjxtBJkvm1YD+9H5+HF5P8M6gJdgBNiH/iDKUsP8SimuBkoj2dSX2wZ7F+5Jc30OS9hF9XXT56I5QJhH6egh1dddrml4R5F+9w1+hOrQZ3dozLB0ZporLg0zqybOcwx7arGGB/6bd/UBOEzU5U6T8ufwsx5ND36VH4XXGlEO1iYbai8FGAZFYB3Y9qdtBWnyW46rbVDTYUZZSNwGlcgAYC1ySXRQpiJ4F8qmhVPaysROT6qdBH9b6qipxWow/bobXu/xXwXvgOVAIKoqU/H/GuMWU08DFQIHZDJxEPpFS3zES60OmV4U/gduBkrMSjJLXe+gGYvsv+E7gNaBXijnAJX0XaYv9tdivt5XIlCx2gblgMPXOlL8HrcCHQImlIfKVlBpvcw2YbKerWYAJUK3lnUpY0H5njMQmO/IKq7KJ+tB0pzOAgsumAdiZoLXl6fghtBuSzkh67JQUv+nYzuRw2QEaqJHpyTIM9AatqU8CKb/MBw0/348raT4T6GndgPGaU2rOfwXjwHdAQKylIcwyoCDsCxpiL1slFQVQETYdKJcCnYE+oAyhb4lAty6didvKKM9U5CuNMxdbPTn1gXItaMFYlwDtq2yUUPQ6UK+6BGlzJvOmg8QTicmG0WPYK6sp4xjS1UPZMR0pg7njaWPSEu2+jdH1jmGZbOnoKqran47t5LSdug6isr+hApguppKmLHL0z7JWHch0pGuse46ej2rEIXwDvAK0V5VBdzPIEMYrBMGvtSiVGAYCBd5wYGgEjAKyCzbzQeBLyk3IuoItYDz105T6+t4LH7lr74n8CFBiCAtSBbb0/wBKVnXAMPrcSxkQvBLFINAGdMkPpFX/QxN1D/7WNNO6LkQ/A9maELkraoZAsEkZLIrqsBnqV22U4WySw39rCyqJd590s9jcQ8xTT7BvWXPQZi+x6lHsvSiU8FrFDZQA9H6aLlBdf6i5DnWC6GMOlRsSgmRGAWEHS7LFuUvW0vcCtzkyXXcVKF2kg9cZHAleQJd0G0N2Apsn0Jsn4Fx47YGSlPxmSIG5GLwE9CHuAtoeNkpK7c3LyPSe3ABeQV4fHAI2LafyNChxs4BtlI38PUx6G4v/XoYnrytje+AeSDm2Nw5XZq40Yn3tGMxNUrPiEzClmU+/+GEw9ajyAIp+4JhlUAA/HaQ6J7Use8MeNUy8bExpEmNYGdaH08U5V99O0VJPr4vi+isoLwQL4/WwYilCnQXduhSICr7ElRc/66F3C3gFFAFR9zNFkAj0ZLwSKMBFi8BJoGv0d4ESRUCcqZPgJ6C4ujxJTzAzN3ttPzPdyJ/T4m3k2LtAq7ilFvoiC/4nC9wXl7nFHgS7HaGbyRx1UnUykjGMYWfJJKMKEgx2+t3KPMxhXIDuODAbfj683rteBCmJPtbht4cwsm17UtdtIYo+ClG0RrY+RB4l2hWlyID8wxR9nEJXI64352ciPhidoo2u6fpDET1ZFWR6Mhr7b8BfAHSd161mObyerHOASLZKggriGDbrsbkddgqYCY5QX0WpdkXoV1BWm6+7+hOzdNcqzdcmXZGCjMTCJqBQVtSBFNUFynCFqoSQrjTGsSHqJJEcOwvcZ2nU/1irXiksa63NQLox2NQM+TZLYA6eEenKaweekSeV+KWQvm5AMdRSJj6uWDLDrjWMVd4JbwfpVOovxfV6rfl+nDfFRsNUYSm/ipaCsMQTKPmhwHwrXtH564+/LsVv78Mroa2DNw+Al6mPBIZ0ZhR8JUYA/3f4NvSh898NyPejwBhkehr3qy5PUuZy7sRCP2VBcmyB1cslFp8J9lE6uQ00jXema4uSgA5kZVJfBmviDKjkVODI7Gon/HMlftpiC1PwI9C1Bx1T2AQq+txB3xuotLVsRyF7Hl1wWCnN9U7vfi9YdmKD654jq4qqSXILme/ick5AX2b1MUrB9xzQ+VBgGhL/C9Z8DaWCWE9avccmEWO+jVCQj2pRPAieAb+sLkHagIkp29t0jInPsAUOX5s29ZA1B2pbAGw6aFccvl3IePrl9irHLlFF9zFtlOGmJ4Sx2B3IfoRukiXLBNuNft1A1O92N9P54HMcYADtHi9PW8bRRw29QqwBjcvR5ilsbL9cQH0lfdxBX+bg1UQ2HLj7rK+uh5BXNW1lAkoYN4PQIGU9l6FT4OldcRE4ikxPwj6U8yjbgYdAQOg3Id9ORcGrIC0FC0FA6HS7WIZdmfNDXfOYir4T5W3VJUgvZDLudUzvk6mCNJVO7w3KclGkzCfYpPeCyCCVIc77M467F1bXGkNPIVuFbpkRZKAcEdLHA4xzFHl3R6cvy8G7iyO/m/qtlmwA7fUOLd+kJez0hOyPod6faqRp8Bf094Belt0l8Kvp4z+UB0BrYG4hsAHt5We5EkfcvsIK1nuYuU5jgOGUUb+/fQS9blD2XuuW8DvQD3wC3DOkoFaQ7gJLGEe+sGko401BfsoWxvm6KtM5P6RdtRcpW93Pot/9HDNVH1Gka0iJpVSim4mjL7JkFcUOpGN7z/SurKz+BxfIfw5sUtB0tQXpePrUO9G4ctgp8JUUlobYXoXsRuAGqG46PRhDrynVhXQjkH/1V2WXmknB54MfUx8JxjFn+5a2CJluCU8AvW+eprRJSU7r7w0U0Db9hoqS1wv038go4GuCB6gruAvtDTc22VrKOcpaPXFUYUUtgr530Pdop//m1Gfg2Ir0Zx5jDHLGnc183MxsTF6H2W4q8dJt76hDqxOQ6qClJOZxGINuQIc13fVVV8TraLOestoQ89nCZL4O6oAt7OcbYAm83q2fBE8DBXKCaKOAfQ3oNqjz55La6ynZAMyzlbRdTP1h0Bd8wFgrgGQabyqYjM14bXw4jV1SP3bgtLLgudMXGm2Mje141O2AiWhBrVy5Uz/FBNcYGW06wOup5ZKCU1fj3djrLp9EtG2DsGGSoqxAfwv8vkTYy/bLllr/+/mWqaNX5uxo6lb5DnYlpo7dV+C1OYY+QB98TDECldhFrc0203VJycCmbfSntYcS/V6BoomlPI69PvvXR6a5JQj5m4mKw2CvNbhnYQ1tdPiSCHv5rwe4CbQA54O94L9gHu02Up410W8pbaPPrNMj5tcj0rmQ75IIfUuE+nXKaluJvC71XqAt0JnbAoqx206ZRPF+tDcbsNGHpDKE/moE+ejWlVHEK+j13t8bKCY03g6gD1jymSfvgezxAIe5NHtmm7mZVuT1LHOz9D15D+SwB3yQ5vDm+6Vnhwd8kGbHPvlZ5rAHfJDm8Ob7pWeHB3yQZsc++VnmsAd8kObw5vulZ4cHfJBmxz75WeawB3yQ5vDm+6Vnhwd8kGbHPvlZ5rAHfJDm8Ob7pWeHB3yQZsc++VnmsAd8kObw5vulZ4cHfJBmxz75WeawB/4Pj1c10S4aQLYAAAAASUVORK5CYII="

/***/ }),

/***/ "./media/icon-brochure.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./media/icon-download.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./media/icon-event.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAIAAABt+uBvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAxNJREFUeNrsnL+OqkAUxhUNnQ08ACYmVFZUFMbCB/ApfCxfw8rOyoqKRqrlATQxFCYkxvutc0PuZWZlGQZ2Dd9XGOYQZ878PMP8cZjh4/EYmFCe58fjMUkSXPu+H4ahbduDrtRe6ZYpFwv/IFwgOehQ7ZVuDFDhnzLZttor3RpQBERABERABERABERAlELD0lwMY9A0TS+XS5ZlvQIxmUwcx/E8D1M5NaDz+Xw4HPDZ85BxXXe5XOLzP0AIHNBhgyoERiKUrCJ2COVfFY3JEgkSUTL6BITGxeeOUsACOGP0WfK9IAjm83mtRbntdluybDabzirTsPQ8z+M4jqKoZAecMXp0mQ7Uq2BBKIgqlxgBjiWPdxA7/WxTcsUBx1Li7CcgZcU51eBcjIDeA1BpjldKtq32SjcGKAzDwi3x32aXgNorfWywC1g+9VMdUEul8xlEQAREQAREQAREQH2VYqAor84xgigCIiACIqB36cW6/D/rt0nuwRlBbGIEREAEREAEREAcKNaVeAvy4+MDF7ZtT6fTJi9CpmkaRZHY6+a6bhAEnuf9BscsbSd2u12SJLgQSVzDIpJ1he/u9/tiJyAukNR7a9CsY/qA8BPJOxth0XhZNMsy5S5SGDU2sxt0rBEgBHAt++vGpXGrA8eaNrFado2szObWdRP76pmn8Sx88RWDuXX9kEbXUMv+Qi96K42OzKBjjQCh4yxe9ygEi8bGnMlkoty2AiNu/aBjQqP1el0yfWeT9Gg0ms1mt9sNHc39fkcAI7larfQi2X3qer0iQ5FcLBbIUKc+zRyT95LrDxTN7lnynjKSlVnHONUgIAIiIAIiIAIiIAKiCIiAWhAX7duJIC7aV4iL9hXion11JNeya2Q14KJ95Ve4aP8pLtpXiIv21eKi/bcaGhftORcjIAKiCKg5IO1R+btLWXFLHozFcdxPQHLFAcdyHEceLEG9iiNUVtS6ZAec4el04kmcXwmjTcv3fXnyQokZD+BYghNxKMPnby8mTlAmkRId0bB44LaiZSkO3C7EI9tLJ+j9EWAAJXhw9SnfhGkAAAAASUVORK5CYII="

/***/ }),

/***/ "./media/icon-info.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./media/icon-play.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./media/icon-webinar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAIAAABt+uBvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABH1JREFUeNrsnDFX6jAUxzGH41t0gUUnXOgii0xMOjk5MelHZGPiCzAxwdKJLnaSxUknF9+f5p3ax01LkJLcJrmDFi2c5nfu/96bS5Kz7+/vVol9fX29vb2lafrx8YGLllt2fX19eXnZ6/VwcX5+XnbbmRIQ0MSZ4aLluoHOIDMlJgUgcFkulz6g2cE0HA6BqQoQoCwWi/V63fLVoii6v78vBTSdTt/f31t+W7fbfXp6yuUm8n/M5/NABwYIkFH+sp3HnTJlIcj3+/1uZi5RgCVJoszOQNHpdGQ82koMoWcymdCojCwIQQKQw/4CQJAO6hgas19eXvBzKzFlzoK/jMdjt+lIfWCYVBwAAizbGIQrKi74TjFQOZ/gMVgMmQoNcMTr6yt1HyjLEzo5o53sLp0IcMRms6Fe57yylFqjowYcQeMTcpafCZ4OHHAEzXMupfNDS0Sa44TOfd4C+q+SDqa0ACgACoACIJvWNjN1TtNU1hMoxnq9XoMS5ckBLRaLOI6LlQUmgVEUjUajRsxmTgtoPp8r20z4I6Y5yh6wRzFonVnZf2X/ezqdMv9C6YSAkiTRCU+z2QyOxvZLlBNKTN81OCvOaJpH/mqc4owCenx8VPbuOCvOdKGIOuj5+RlqqsjxUNxkMikWB95V0gA0Ho8boThrUw0IrRGKszwX4684FpNVzorjMptnqzhe7Q59xRlbZ8GxH6SjOLgS/cLKF0A6igOj1WrlLyAdxZlZCdeAlmuF4gxEomb0pP9kphRag9sddVnFqlsDiyxYA0JZiPqwTEdRFBl4BqaA9i5IRti+u7vzFNDelexla8LcB1StKWlIZ6PRyAwdRoB0FvlbWXXbboqmBoMBCiLzz9YOmmIKiK2mWADirCnLgPhryiagsrUMrDRlE1B1ZcxEU+YAwRE0e+ysNGUOUL/f3wuI/46rEwLCbDvNrFmaMhqDHh4elMUOZ00ZBSS3Gd3e3iZJIlN7t9uVGzxbDTETWazR+13DOukAKAAKgAKgZgEysyiAoSkHLmiZ795ZSppGBw44gpazOivknTQ6cMARV1dXFKSHTqQcNeCIm5sburiE8+aJUxgGiyHTeRLgCPmLhqvZbOYJo7L1atJ1tllMubcNc0v+e5VqUZby3K38u/9/R3TFcVw8dmknkmP+LQ/VcymjA03ZAUvSaX4OWMrjjs/HuxWteNSbKDLz9lCKogECUOQvwzGBu76zE5HDQZM/UXn/QZPFGLZarZSHUzmJBhkdOUuZhc6qD7sFo81mIw/Vcy/WwFArK0tlLUD1Gs2Sw8z2vnGZWVmWsdDuMNZM0Eya9DaTDRlzgGhJ1ul0dN54cXFhsSEjbLmPbCb8zoNMOpEhQJ+fn3QGo/92ejP9wGYDoqI4aGZHbzamMmseRCPLQWHINQ+iIeNIibkWg6gijvQgpyR2TAqruNmdPatHpjC7iUxY0dcvmpO2ElltczE+vaR6T5CrzYP4dNrwGGX9dZuAWPUha3yYsLrDFCAzW2zNP0xtgBAXmTCSQbquT/srwAA4TA3Q3c7idQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./media/svg/block-akademie-header.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement(
    "g",
    { transform: "translate(24 170)" },
    _react2.default.createElement("rect", { width: "56", height: "12", y: "38", fill: "#B1BCCA", rx: "4" }),
    _react2.default.createElement("path", { fill: "#DFE2E5", d: "M1 0h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z" })
  ),
  _react2.default.createElement(
    "g",
    { transform: "translate(24 104)" },
    _react2.default.createElement("rect", { width: "56", height: "12", y: "38", fill: "#B1BCCA", rx: "4" }),
    _react2.default.createElement("path", { fill: "#DFE2E5", d: "M1 0h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z" })
  ),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M24 24h162v64H24z" }),
  _react2.default.createElement("path", { fill: "#B1BCCA", d: "M125.07 71H86.12c-1.07 0-1.44-.95-.82-1.83l11.26-16.16c.6-.88 1.72-1.03 2.48-.27L101.3 55c.75.76 1.92.69 2.6-.13l5.46-6.66c.68-.82 1.73-.78 2.33.1l14.2 20.85c.61.88.24 1.84-.83 1.84zm-2.56-20a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-akademie.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("rect", { width: "56", height: "12", x: "24", y: "91", fill: "#B1BCCA", rx: "4" }),
  _react2.default.createElement("rect", { width: "56", height: "12", x: "24", y: "194", fill: "#B1BCCA", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M25 24h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 11h110a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 51h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 11h110a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-image.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M24 75h162v100H24z" }),
  _react2.default.createElement("path", { fill: "#B1BCCA", d: "M125.07 140H86.12c-1.07 0-1.44-.95-.82-1.83l11.26-16.16c.6-.88 1.72-1.03 2.48-.27l2.27 2.26c.75.76 1.92.69 2.6-.13l5.46-6.66c.68-.82 1.73-.78 2.33.1l14.2 20.85c.61.88.24 1.84-.83 1.84zm-2.56-20a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-img+text.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("rect", { width: "56", height: "12", x: "24", y: "205", fill: "#B1BCCA", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M25 136h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM24 24h162v100H24z" }),
  _react2.default.createElement("path", { fill: "#B1BCCA", d: "M125.07 89H86.12c-1.07 0-1.44-.95-.82-1.83l11.26-16.16c.6-.88 1.72-1.03 2.48-.27L101.3 73c.75.76 1.92.69 2.6-.13l5.46-6.66c.68-.82 1.73-.78 2.33.1l14.2 20.85c.61.88.24 1.84-.83 1.84zm-2.56-20a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-infothek.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M50 53h135a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H50a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 12h135a1 1 0 0 1 1 1v-.69 2-.3a1 1 0 0 1-1 .99H50a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 17h135a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H50a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 12h135a1 1 0 0 1 1 1v-.69 2-.3a1 1 0 0 1-1 .99H50a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 17h135a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H50a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 12h135a1 1 0 0 1 1 1v-.69 2-.3a1 1 0 0 1-1 .99H50a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 17h135a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H50a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 12h135a1 1 0 0 1 1 1v-.69 2-.3a1 1 0 0 1-1 .99H50a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 17h135a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H50a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 12h135a1 1 0 0 1 1 1v-.69 2-.3a1 1 0 0 1-1 .99H50a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM32.5 69a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0 29a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0 29a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0 29a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0 29a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zM25 24h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 11h110a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-text-cta.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("rect", { width: "56", height: "12", x: "24", y: "194", fill: "#B1BCCA", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M25 24h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 11h110a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 18h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/block-text.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M25 24h130a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 11h110a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm0 14h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 18h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/close.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("path", { d: "M0 40h40V0H0z" }),
  _react2.default.createElement("path", { fill: "#7F8FA4", d: "M20.7 20L31.86 8.85a.5.5 0 1 0-.7-.7L20 19.29 8.85 8.15a.5.5 0 0 0-.7.7L19.29 20 8.15 31.15a.5.5 0 0 0 .35.85.5.5 0 0 0 .35-.15L20 20.71l11.15 11.14a.5.5 0 0 0 .7 0 .5.5 0 0 0 0-.7L20.71 20z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/icon-add.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("path", { d: "M0 0h69v69H0z" }),
  _react2.default.createElement("path", { fill: "#0275D8", d: "M34.5 66A31.53 31.53 0 0 1 3 34.5 31.53 31.53 0 0 1 34.5 3 31.53 31.53 0 0 1 66 34.5 31.53 31.53 0 0 1 34.5 66m0-66A34.54 34.54 0 0 0 0 34.5C0 53.52 15.48 69 34.5 69S69 53.52 69 34.5A34.54 34.54 0 0 0 34.5 0m18 33H36V16.5a1.5 1.5 0 0 0-3 0V33H16.5a1.5 1.5 0 0 0 0 3H33v16.5a1.5 1.5 0 0 0 3 0V36h16.5a1.5 1.5 0 0 0 0-3" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "69", height: "69", viewBox: "0 0 69 69" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/icon-lock.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement("path", { d: "M16 0a6.7 6.7 0 0 0-5.31 2.4A8.64 8.64 0 0 0 9 7.9V9h3V7.9c0-1.57.4-2.81 1.03-3.62C13.67 3.48 14.54 3 16 3c1.46 0 2.33.45 2.97 1.25.64.8 1.03 2.06 1.03 3.66V9h3V7.9c0-2.09-.53-4.04-1.72-5.53A6.62 6.62 0 0 0 16 0zM9 10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3zm7 5a2 2 0 0 1 1 3.72V21a1 1 0 0 1-2 0v-2.28A2 2 0 0 1 16 15z" });

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ viewBox: "0 0 26 26", width: "24", height: "24" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/img-text-no-cta.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "none", fillRule: "evenodd" },
  _react2.default.createElement("rect", { width: "210", height: "250", fill: "#FFF", rx: "4" }),
  _react2.default.createElement("path", { fill: "#DFE2E5", d: "M25 136h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h160a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm0 9h120a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H25a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM24 24h162v100H24z" }),
  _react2.default.createElement("path", { fill: "#B1BCCA", d: "M125.07 89H86.12c-1.07 0-1.44-.95-.82-1.83l11.26-16.16c.6-.88 1.72-1.03 2.48-.27L101.3 73c.75.76 1.92.69 2.6-.13l5.46-6.66c.68-.82 1.73-.78 2.33.1l14.2 20.85c.61.88.24 1.84-.83 1.84zm-2.56-20a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "210", height: "250", viewBox: "0 0 210 250" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/logo.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement(
  "g",
  { fill: "#0275D8" },
  _react2.default.createElement("path", { d: "M9 32h23V9H9zM0 9h9V0H0z" })
);

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 32 32" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/mail-layout.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement("path", { d: "M17.5 12c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm.5 5.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5zm-.5 3.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm.5 5.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5zM26.5 12c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm.5 5.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5zm-.5 3.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4zm.5 5.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5z" });

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/mail-setup.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement("path", { d: "M26.5 17c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-8c0-.83.67-1.5 1.5-1.5h13zm.5 9.5v-8a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5zM13.5 16a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zm1.5-2a.5.5 0 0 1 0-1h10a.5.5 0 0 1 0 1H15zm0 10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 0 1H15zm5.5 1a.5.5 0 0 1 0 1H15a.5.5 0 1 1 0-1h5.5zm4.5-6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-2 3h2v-2h-2v2z" });

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./media/svg/mail-use.svg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var _ref2 = _react2.default.createElement("path", { fill: "#7F8FA4", d: "M23.44 26.17l2.16-11.52-5.96 7.85 1.75 2.33 1.16 1.55a.5.5 0 0 0 .51.19.5.5 0 0 0 .38-.4zm-4.64-.15l1.47-1-1.5-2.02H18v2.6c0 .2.1.36.27.45a.5.5 0 0 0 .52-.03zM14 22h4.77l5.88-7.74-10.91 6.82a.5.5 0 0 0-.22.56.5.5 0 0 0 .48.36zm12-8.64c.46.34.69.9.58 1.47l-2.16 11.53a1.5 1.5 0 0 1-2.67.62l-.88-1.17-1.51 1.04A1.5 1.5 0 0 1 17 25.6V23H14a1.5 1.5 0 0 1-1.44-1.09 1.5 1.5 0 0 1 .65-1.68l11.1-6.95a1.5 1.5 0 0 1 1.65.04l.02.01s0 .02.02.03z", fillRule: "evenodd" });

exports.default = function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return _react2.default.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    _ref2
  );
};

/***/ }),

/***/ "./state/actions/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return userLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userAuthenticated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_auth__ = __webpack_require__("./state/types/auth.js");


var userLogin = function userLogin(payload, pathName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["c" /* LOGIN */],
    payload: payload,
    meta: { auth: true, pathName: pathName }
  };
};

var userCheck = function userCheck(payload, pathName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["a" /* CHECK */],
    payload: payload,
    meta: { auth: true, pathName: pathName }
  };
};

var userLogout = function userLogout() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["g" /* LOGOUT */],
    meta: { auth: true }
  };
};

var userAuthenticated = function userAuthenticated() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["b" /* CHECK_PASSED */]
  };
};

/***/ }),

/***/ "./state/actions/data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return crudGetList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return crudGetOne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return crudCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return crudUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return crudDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return crudGetSimple; });
/* unused harmony export crudGetMany */
/* unused harmony export crudGetMatching */
/* unused harmony export crudGetManyReference */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return downloadTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("../node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_data__ = __webpack_require__("./state/types/data.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var crudGetList = function crudGetList(resource, pagination, sort, filter) {
  var cancelPrevious = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["i" /* GET_LIST */],
    payload: { pagination: pagination, sort: sort, filter: filter },
    meta: { resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["i" /* GET_LIST */], cancelPrevious: cancelPrevious }
  };
};

var crudGetOne = function crudGetOne(resource, id) {
  var cancelPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["s" /* GET_ONE */],
    payload: { id: id },
    meta: { resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["s" /* GET_ONE */], cancelPrevious: cancelPrevious }
  };
};

var crudCreate = function crudCreate(resource, data, redirectTo) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var message = _ref.message,
      meta = _objectWithoutProperties(_ref, ['message']);

  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["b" /* CREATE */],
    payload: { data: data, redirectTo: redirectTo, message: message },
    meta: _extends({ resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["b" /* CREATE */], cancelPrevious: false }, meta)
  };
};


var crudUpdate = function crudUpdate(resource, id, data, previousData, redirectTo) {
  var _ref2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  var message = _ref2.message,
      meta = _objectWithoutProperties(_ref2, ['message']);

  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["x" /* UPDATE */],
    payload: { id: id, data: data, previousData: previousData, redirectTo: redirectTo, message: message },
    meta: _extends({ resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["x" /* UPDATE */], cancelPrevious: false }, meta)
  };
};


var crudDelete = function crudDelete(resource, id, redirectTo, _ref3) {
  var message = _ref3.message,
      meta = _objectWithoutProperties(_ref3, ['message']);

  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["e" /* DELETE */],
    payload: { id: id, redirectTo: redirectTo, message: message },
    meta: { resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["e" /* DELETE */], cancelPrevious: false }
  };
};



var crudGetSimple = function crudGetSimple(resource) {
  var cancelPrevious = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["v" /* GET_SIMPLE */],
    payload: {},
    meta: { resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["v" /* GET_SIMPLE */], cancelPrevious: false }
  };
};

var crudGetMany = function crudGetMany(resource, ids) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["l" /* GET_MANY */],
    payload: { ids: ids },
    meta: { resource: resource, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["l" /* GET_MANY */], cancelPrevious: false }
  };
};

var crudGetMatching = function crudGetMatching(reference, relatedTo, pagination, sort, filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["q" /* GET_MATCHING */],
    payload: { pagination: pagination, sort: sort, filter: filter },
    meta: { resource: reference, relatedTo: relatedTo, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["i" /* GET_LIST */], cancelPrevious: false }
  };
};

var crudGetManyReference = function crudGetManyReference(reference, target, id, relatedTo, pagination, sort, filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["n" /* GET_MANY_REFERENCE */],
    payload: { target: target, id: id, pagination: pagination, sort: sort, filter: filter },
    meta: { resource: reference, relatedTo: relatedTo, fetch: __WEBPACK_IMPORTED_MODULE_1__state_types_data__["n" /* GET_MANY_REFERENCE */], cancelPrevious: false }
  };
};

var checkTemplate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["a" /* CHECK_TEMPLATE */]);
var downloadTemplate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["h" /* DOWNLOAD_TEMPLATE */]);

/***/ }),

/***/ "./state/actions/editing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editingStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editingEnded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notifyServerEditingEnded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editCommitted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return userDisconnected; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("../node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_editing__ = __webpack_require__("./state/types/editing.js");



var editingStarted = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_editing__["b" /* EDITING_STARTED */], undefined, function () {
  return {
    resource: 'newsletters',
    update: true
  };
});

var editingEnded = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_editing__["a" /* EDITING_ENDED */], undefined, function () {
  return {
    resource: 'newsletters',
    update: true
  };
});

var notifyServerEditingEnded = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_editing__["d" /* NOTIFY_SERVER_EDITING_ENDED */]);

var editCommitted = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_editing__["c" /* EDIT_COMMITTED */], undefined, function () {
  return {
    resource: 'newsletters',
    update: true
  };
});

var userDisconnected = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_editing__["e" /* USER_DISCONNECTED */], undefined, function () {
  return {
    resource: 'newsletters',
    update: true
  };
});

/***/ }),

/***/ "./state/actions/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeListParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_list__ = __webpack_require__("./state/types/list.js");


var changeListParams = function changeListParams(resource, params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_list__["a" /* CHANGE_LIST_PARAMS */],
    payload: params,
    meta: { resource: resource }
  };
};

/***/ }),

/***/ "./state/actions/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_modal__ = __webpack_require__("./state/types/modal.js");


function showModal(payload) {
  return { type: __WEBPACK_IMPORTED_MODULE_0__state_types_modal__["b" /* SHOW_MODAL */], payload: payload };
}

function hideModal() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__state_types_modal__["a" /* HIDE_MODAL */] };
}

/***/ }),

/***/ "./state/actions/notification.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hideNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_notification__ = __webpack_require__("./state/types/notification.js");


var showNotification = function showNotification(id, text) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { timeout: 3000, type: 'info', button: {} };
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_notification__["b" /* SHOW_NOTIFICATION */],
    payload: { id: id, text: text, data: data }
  };
};

var hideNotification = function hideNotification(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__state_types_notification__["a" /* HIDE_NOTIFICATION */],
    payload: { id: id }
  };
};

/***/ }),

/***/ "./state/actions/pageflip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pageFlipStop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("../node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_pageflip__ = __webpack_require__("./state/types/pageflip.js");



var pageFlipStop = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_pageflip__["a" /* STOP */]);

/***/ }),

/***/ "./state/actions/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routeDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return routeNewslettersNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return routeNewslettersEdit; });
/* unused harmony export routeComponents */
/* unused harmony export routeComponentsNew */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routeComponentsEdit; });
/* unused harmony export routeProducts */
/* unused harmony export routeProductsNew */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return routeProductsEdit; });
/* unused harmony export routeUsers */
/* unused harmony export routeUsersNew */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return routeUsersEdit; });
/* unused harmony export routeContacts */
/* unused harmony export routeContactsNew */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return routeContactsEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return routeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return routeReset; });
/* unused harmony export routeRegister */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("../node_modules/redux-actions/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_routes__ = __webpack_require__("./state/types/routes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var goToPage = function goToPage(type, query, payload) {
  return _extends({
    type: type
  }, query && { meta: query }, payload && { payload: payload });
};

var routeDashboard = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["g" /* ROUTE_DASHBOARD */]);
var routeNewslettersNew = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["j" /* ROUTE_NEWSLETTERS_NEW */]);
var routeNewslettersEdit = function routeNewslettersEdit(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */],
    payload: { id: id }
  };
};

var routeComponents = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["a" /* ROUTE_COMPONENTS */]);
var routeComponentsNew = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["c" /* ROUTE_COMPONENTS_NEW */]);
var routeComponentsEdit = function routeComponentsEdit(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_routes__["b" /* ROUTE_COMPONENTS_EDIT */],
    payload: { id: id }
  };
};

var routeProducts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["k" /* ROUTE_PRODUCTS */]);
var routeProductsNew = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["m" /* ROUTE_PRODUCTS_NEW */]);
var routeProductsEdit = function routeProductsEdit(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_routes__["l" /* ROUTE_PRODUCTS_EDIT */],
    payload: { id: id }
  };
};

var routeUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["p" /* ROUTE_USERS */]);
var routeUsersNew = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["r" /* ROUTE_USERS_NEW */]);
var routeUsersEdit = function routeUsersEdit(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_routes__["q" /* ROUTE_USERS_EDIT */],
    payload: { id: id }
  };
};

var routeContacts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["d" /* ROUTE_CONTACTS */]);
var routeContactsNew = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["f" /* ROUTE_CONTACTS_NEW */]);
var routeContactsEdit = function routeContactsEdit(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__state_types_routes__["e" /* ROUTE_CONTACTS_EDIT */],
    payload: { id: id }
  };
};

var routeLogin = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["h" /* ROUTE_LOGIN */]);
var routeReset = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["o" /* ROUTE_RESET */]);
var routeRegister = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__state_types_routes__["n" /* ROUTE_REGISTER */]);

/***/ }),

/***/ "./state/callbacks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_editing__ = __webpack_require__("./state/actions/editing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("./state/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_types_routes__ = __webpack_require__("./state/types/routes.js");






/* harmony default export */ __webpack_exports__["a"] = ({
  onBeforeChange: function onBeforeChange(dispatch, getState, action) {
    var state = getState();
    var allowed = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* isAllowed */])(action.type, state);

    if (!allowed) {
      var _action = Object(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__["redirect"])({ type: __WEBPACK_IMPORTED_MODULE_4__state_types_routes__["h" /* ROUTE_LOGIN */] });
      dispatch(_action);
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__state_actions_notification__["b" /* showNotification */])(0, 'You must be logged in to access Elovade Newsletter!'));
    }

    if (state.location.type === __WEBPACK_IMPORTED_MODULE_4__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */] && action.type !== __WEBPACK_IMPORTED_MODULE_4__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */]) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_editing__["d" /* notifyServerEditingEnded */])(state.location.payload.id));
    }
  },
  onAfterChange: function onAfterChange(dispatch, getState) {}
});

/***/ }),

/***/ "./state/enhancers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistState__ = __webpack_require__("./state/enhancers/persistState.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__persistState__["a"]; });



/***/ }),

/***/ "./state/enhancers/persistState.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isarray__ = __webpack_require__("../node_modules/lodash.isarray/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isarray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isarray__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function getSubset(obj, paths) {
  var subset = {};

  paths.forEach(function (key) {
    var slice = obj[key];
    if (slice) subset[key] = slice;
  });

  return subset;
}

function merge(initialState, persistedState) {
  return persistedState ? _extends({}, initialState, persistedState) : initialState;
}

function slicer(paths) {
  switch (typeOf(paths)) {
    case 'void':
      return function (state) {
        return state;
      };
    case 'string':
      return function (state) {
        return getSubset(state, [paths]);
      };
    case 'array':
      return function (state) {
        return getSubset(state, paths);
      };
    default:
      return console.error('Invalid paths argument, should be of type String, Array or Void');
  }
}

function typeOf(thing) {
  if (!thing) return 'void';

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isarray___default()(thing)) {
    if (!thing.length) return 'void';
    return 'array';
  }

  return typeof thing === 'undefined' ? 'undefined' : _typeof(thing);
}

function persistState(paths) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'redux';

  var serialize = JSON.stringify;
  var deserialize = JSON.parse;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
        enhancer = initialState;
        initialState = undefined;
      }

      var persistedState = void 0;
      var finalInitialState = void 0;

      try {
        persistedState = deserialize(localStorage.getItem(key));
        finalInitialState = merge(initialState, persistedState);
      } catch (e) {
        console.warn('Failed to retrieve initial state from localStorage:', e);
      }

      var store = next(reducer, finalInitialState, enhancer);
      var slicerFn = slicer(paths);

      store.subscribe(function () {
        var state = store.getState();
        var subset = slicerFn(state);

        try {
          localStorage.setItem(key, serialize(subset));
        } catch (e) {
          console.warn('Unable to persist state to localStorage:', e);
        }
      });

      return store;
    };
  };
}

/***/ }),

/***/ "./state/reducers/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_auth__ = __webpack_require__("./state/types/auth.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultState = {
  user: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["f" /* LOGIN_SUCCESS */]:
      return _extends({}, previousState, { user: payload.user });
    case __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["g" /* LOGOUT */]:
    case __WEBPACK_IMPORTED_MODULE_0__state_types_auth__["d" /* LOGIN_FAILURE */]:
      return defaultState;
    default:
      return previousState;
  }
});

/***/ }),

/***/ "./state/reducers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resettableAppReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_routes__ = __webpack_require__("./state/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_reducers_auth__ = __webpack_require__("./state/reducers/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_reducers_locale__ = __webpack_require__("./state/reducers/locale.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_reducers_rest__ = __webpack_require__("./state/reducers/rest.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui__ = __webpack_require__("./state/reducers/ui.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_resources__ = __webpack_require__("./state/resources.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_types_auth__ = __webpack_require__("./state/types/auth.js");














var appReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  auth: __WEBPACK_IMPORTED_MODULE_3__state_reducers_auth__["a" /* default */],
  rest: Object(__WEBPACK_IMPORTED_MODULE_5__state_reducers_rest__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__state_resources__["a" /* default */]),
  location: __WEBPACK_IMPORTED_MODULE_2__state_routes__["d" /* reducer */],
  form: __WEBPACK_IMPORTED_MODULE_1_redux_form__["d" /* reducer */],
  locale: Object(__WEBPACK_IMPORTED_MODULE_4__state_reducers_locale__["a" /* default */])('en'),
  ui: __WEBPACK_IMPORTED_MODULE_6__ui__["a" /* default */]
});

var resettableAppReducer = function resettableAppReducer(state, action) {
  return appReducer(action.type !== __WEBPACK_IMPORTED_MODULE_8__state_types_auth__["g" /* LOGOUT */] ? state : undefined, action);
};

/***/ }),

/***/ "./state/reducers/loading.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_fetch__ = __webpack_require__("./state/types/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_auth__ = __webpack_require__("./state/types/auth.js");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var _ref = arguments[1];
  var type = _ref.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_fetch__["d" /* START */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_auth__["e" /* LOGIN_LOADING */]:
      return previousState + 1;
    case __WEBPACK_IMPORTED_MODULE_0__state_types_fetch__["b" /* END */]:
    case __WEBPACK_IMPORTED_MODULE_0__state_types_fetch__["c" /* ERROR */]:
    case __WEBPACK_IMPORTED_MODULE_0__state_types_fetch__["a" /* CANCEL */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_auth__["f" /* LOGIN_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_auth__["d" /* LOGIN_FAILURE */]:
      return Math.max(previousState - 1, 0);
    default:
      return previousState;
  }
});

/***/ }),

/***/ "./state/reducers/locale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_index__ = __webpack_require__("./i18n/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_locale__ = __webpack_require__("./state/types/locale.js");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var initialLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__i18n_index__["a" /* DEFAULT_LOCALE */];
  return function () {
    var previousLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialLocale;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_1__state_types_locale__["a" /* CHANGE_LOCALE */]:
        return payload;
      default:
        return previousLocale;
    }
  };
});

/***/ }),

/***/ "./state/reducers/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = modals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_modal__ = __webpack_require__("./state/types/modal.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  params: {},
  visible: false
};

function modals() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var _ref = action || {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_modal__["b" /* SHOW_MODAL */]:
      return _extends({}, state, {
        params: payload,
        visible: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__state_types_modal__["a" /* HIDE_MODAL */]:
      return initialState;

    default:
      return state;
  }
}

/***/ }),

/***/ "./state/reducers/notification.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_notification__ = __webpack_require__("./state/types/notification.js");


var defaultState = {
  queue: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  var queue = void 0;
  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_notification__["b" /* SHOW_NOTIFICATION */]:
      queue = previousState.queue.slice();
      queue.push({ id: payload.id, text: payload.text, data: payload.data });
      return { queue: queue };

    case __WEBPACK_IMPORTED_MODULE_0__state_types_notification__["a" /* HIDE_NOTIFICATION */]:
      queue = previousState.queue.filter(function (snack) {
        return snack.id !== payload.id;
      });
      return { queue: queue };

    default:
      return previousState;
  }
});

/***/ }),

/***/ "./state/reducers/pageflip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_pageflip__ = __webpack_require__("./state/types/pageflip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_routesMap__ = __webpack_require__("./state/routesMap.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { animated: false, dir: '' };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_pageflip__["a" /* STOP */]:
      return _extends({}, state, { animated: false });
    default:
      if (!action.meta || !action.meta.location) {
        return state;
      }

      var type = action.type;
      var prevType = action.meta.location.prev.type;

      if (!prevType || type === prevType) {
        return state;
      }
      return _extends({}, state, {
        animated: true,
        dir: __WEBPACK_IMPORTED_MODULE_1__state_routesMap__["b" /* routesIndex */].indexOf(type) > __WEBPACK_IMPORTED_MODULE_1__state_routesMap__["b" /* routesIndex */].indexOf(prevType) ? 'next' : 'back'
      });
  }
});

/***/ }),

/***/ "./state/reducers/references/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__oneToMany__ = __webpack_require__("./state/reducers/references/oneToMany.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleValues__ = __webpack_require__("./state/reducers/references/possibleValues.js");




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  oneToMany: __WEBPACK_IMPORTED_MODULE_1__oneToMany__["a" /* default */],
  possibleValues: __WEBPACK_IMPORTED_MODULE_2__possibleValues__["a" /* default */]
}));

/***/ }),

/***/ "./state/reducers/references/oneToMany.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIds */
/* unused harmony export getReferences */
/* unused harmony export getReferencesByIds */
/* unused harmony export nameRelatedTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_data__ = __webpack_require__("./state/types/data.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _extends2;

  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_data__["p" /* GET_MANY_REFERENCE_SUCCESS */]:
      return _extends({}, previousState, (_extends2 = {}, _extends2[meta.relatedTo] = payload.data.map(function (record) {
        return record.id;
      }), _extends2));
    default:
      return previousState;
  }
});

var getIds = function getIds(state, relatedTo) {
  return state.rest.references.oneToMany[relatedTo];
};

var getReferences = function getReferences(state, reference, relatedTo) {
  var ids = getIds(state, relatedTo);
  if (typeof ids === 'undefined') return undefined;
  return ids.map(function (id) {
    return state.rest[reference].data[id];
  }).filter(function (r) {
    return typeof r !== 'undefined';
  }).reduce(function (prev, record) {
    prev[record.id] = record;
    return prev;
  }, {});
};

var getReferencesByIds = function getReferencesByIds(state, reference, ids) {
  if (ids.length === 0) return {};
  return ids.map(function (id) {
    return state.rest[reference].data[id];
  }).filter(function (r) {
    return typeof r !== 'undefined';
  }).reduce(function (prev, record) {
    prev[record.id] = record;
    return prev;
  }, {});
};

var nameRelatedTo = function nameRelatedTo(reference, id, resource, target) {
  return resource + '_' + reference + '@' + target + '_' + id;
};

/***/ }),

/***/ "./state/reducers/references/possibleValues.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPossibleReferences */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_data__ = __webpack_require__("./state/types/data.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _extends2;

  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_data__["r" /* GET_MATCHING_SUCCESS */]:
      return _extends({}, previousState, (_extends2 = {}, _extends2[meta.relatedTo] = payload.data.map(function (record) {
        return record.id;
      }), _extends2));
    default:
      return previousState;
  }
});

var getPossibleReferences = function getPossibleReferences(state, referenceSource, reference) {
  var selectedIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var possibleValues = state.rest.references.possibleValues[referenceSource] ? Array.from(state.rest.references.possibleValues[referenceSource]) : [];
  selectedIds.forEach(function (id) {
    return possibleValues.some(function (value) {
      return value == id;
    }) || possibleValues.unshift(id);
  });
  return possibleValues.map(function (id) {
    return state.rest[reference].data[id];
  }).filter(function (r) {
    return typeof r !== 'undefined';
  });
};

/***/ }),

/***/ "./state/reducers/resource/data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__ = __webpack_require__("./state/types/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_types_data__ = __webpack_require__("./state/types/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_types_editing__ = __webpack_require__("./state/types/editing.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var cacheDuration = 10 * 60 * 1000;
var addRecords = function addRecords() {
  var newRecords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var oldRecords = arguments[1];

  var newRecordsById = newRecords.reduce(function (prev, record) {
    prev[record.id] = record;
    return prev;
  }, {});
  var now = new Date();
  var newRecordsFetchedAt = newRecords.reduce(function (prev, record) {
    prev[record.id] = now;
    return prev;
  }, {});

  var latestValidDate = new Date();
  latestValidDate.setTime(latestValidDate.getTime() - cacheDuration);
  var oldValidRecordIds = oldRecords.fetchedAt ? Object.keys(oldRecords.fetchedAt).filter(function (id) {
    return oldRecords.fetchedAt[id] > latestValidDate;
  }) : [];
  var oldValidRecords = oldValidRecordIds.reduce(function (prev, id) {
    prev[id] = oldRecords[id];
    return prev;
  }, {});
  var oldValidRecordsFetchedAt = oldValidRecordIds.reduce(function (prev, id) {
    prev[id] = oldRecords.fetchedAt[id];
    return prev;
  }, {});

  var records = _extends({}, oldValidRecords, newRecordsById);
  Object.defineProperty(records, 'fetchedAt', {
    value: _extends({}, oldValidRecordsFetchedAt, newRecordsFetchedAt)
  });
  return records;
};

var initialState = {};
Object.defineProperty(initialState, 'fetchedAt', { value: {} });

var updateRecord = function updateRecord(payload, oldRecords) {
  var _newRecordsById, _newRecordsFetchedAt;

  var now = new Date();
  var newRecordsById = (_newRecordsById = {}, _newRecordsById[payload.nlData.id] = _extends({}, oldRecords[payload.nlData.id], payload.nlData), _newRecordsById);
  var newRecordsFetchedAt = (_newRecordsFetchedAt = {}, _newRecordsFetchedAt[payload.nlData.id] = now, _newRecordsFetchedAt);
  var oldRecordsIds = oldRecords.fetchedAt ? Object.keys(oldRecords.fetchedAt) : [];
  var oldRecordsFetchedAt = oldRecordsIds.reduce(function (prev, id) {
    prev[id] = oldRecords.fetchedAt[id];
    return prev;
  }, {});

  var records = _extends({}, oldRecords, newRecordsById);
  Object.defineProperty(records, 'fetchedAt', {
    value: _extends({}, oldRecordsFetchedAt, newRecordsFetchedAt)
  });
  return records;
};

var updateRecords = function updateRecords(payload, oldRecords) {
  var oldRecordsIds = oldRecords.fetchedAt ? Object.keys(oldRecords.fetchedAt) : [];
  var oldRecordsFetchedAt = oldRecordsIds.reduce(function (prev, id) {
    prev[id] = oldRecords.fetchedAt[id];
    return prev;
  }, {});
  var updatedRecordsIds = oldRecordsIds.filter(function (rec) {
    return oldRecords[rec].edited_by && oldRecords[rec].edited_by.id === payload.userId;
  });
  var updatedRecords = updatedRecordsIds.reduce(function (prev, id) {
    prev[id] = _extends({}, oldRecords[id], { edited_lock: false });
    return prev;
  }, {});

  var records = _extends({}, oldRecords, updatedRecords);
  Object.defineProperty(records, 'fetchedAt', {
    value: _extends({}, oldRecordsFetchedAt)
  });
  return records;
};

/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  return function () {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref = arguments[1];
    var payload = _ref.payload,
        type = _ref.type,
        meta = _ref.meta;

    if (!meta || meta.resource !== resource) {
      return previousState;
    }

    if (type === __WEBPACK_IMPORTED_MODULE_3__state_types_editing__["c" /* EDIT_COMMITTED */]) {
      return updateRecord(payload, previousState);
    } else if (type === __WEBPACK_IMPORTED_MODULE_3__state_types_editing__["e" /* USER_DISCONNECTED */]) {
      return updateRecords(payload, previousState);
    } else if (type === __WEBPACK_IMPORTED_MODULE_3__state_types_editing__["b" /* EDITING_STARTED */]) {
      var data = {
        nlData: {
          id: payload.newsletterId,
          edited_by: payload.user,
          edited_lock: true,
          edited_at: __WEBPACK_IMPORTED_MODULE_0_moment___default()().toISOString()
        }
      };
      return updateRecord(data, previousState);
    } else if (type === __WEBPACK_IMPORTED_MODULE_3__state_types_editing__["a" /* EDITING_ENDED */]) {
      var _data = {
        nlData: {
          id: payload,
          edited_lock: false,
          edited_at: __WEBPACK_IMPORTED_MODULE_0_moment___default()().toISOString()
        }
      };
      return updateRecord(_data, previousState);
    }

    if (!meta.fetchResponse || meta.fetchStatus !== __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["b" /* END */]) {
      return previousState;
    }
    switch (meta.fetchResponse) {
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["i" /* GET_LIST */]:
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["l" /* GET_MANY */]:
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["n" /* GET_MANY_REFERENCE */]:
        return addRecords(payload.data, previousState);
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["s" /* GET_ONE */]:
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["x" /* UPDATE */]:
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["b" /* CREATE */]:
        return addRecords([payload.data], previousState);
      case __WEBPACK_IMPORTED_MODULE_2__state_types_data__["v" /* GET_SIMPLE */]:
        return payload.data;
      default:
        return previousState;
    }
  };
});

var getRecord = function getRecord(state, id) {
  return state[id];
};

/***/ }),

/***/ "./state/reducers/resource/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__("./state/reducers/resource/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list__ = __webpack_require__("./state/reducers/resource/list/index.js");




/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    data: Object(__WEBPACK_IMPORTED_MODULE_1__data__["a" /* default */])(resource, options),
    list: Object(__WEBPACK_IMPORTED_MODULE_2__list__["a" /* default */])(resource, options)
  });
});

/***/ }),

/***/ "./state/reducers/resource/list/ids.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_data__ = __webpack_require__("./state/types/data.js");


/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  return function () {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload,
        requestPayload = _ref.requestPayload,
        meta = _ref.meta;

    if (!meta || meta.resource !== resource) {
      return previousState;
    }
    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_0__state_types_data__["k" /* GET_LIST_SUCCESS */]:
        return Array.from(new Set(payload.data.map(function (record) {
          return record.id;
        })));
      case __WEBPACK_IMPORTED_MODULE_0__state_types_data__["g" /* DELETE_SUCCESS */]:
        {
          var index = previousState.findIndex(function (el) {
            return el == requestPayload.id;
          });
          if (index === -1) {
            return previousState;
          }
          return [].concat(previousState.slice(0, index), previousState.slice(index + 1));
        }
      default:
        return previousState;
    }
  };
});

var getIds = function getIds(state) {
  return state;
};

/***/ }),

/***/ "./state/reducers/resource/list/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ids__ = __webpack_require__("./state/reducers/resource/list/ids.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__params__ = __webpack_require__("./state/reducers/resource/list/params.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__total__ = __webpack_require__("./state/reducers/resource/list/total.js");





/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
    ids: Object(__WEBPACK_IMPORTED_MODULE_1__ids__["a" /* default */])(resource, options),
    params: Object(__WEBPACK_IMPORTED_MODULE_2__params__["a" /* default */])(resource, options),
    total: Object(__WEBPACK_IMPORTED_MODULE_3__total__["a" /* default */])(resource, options)
  });
});

/***/ }),

/***/ "./state/reducers/resource/list/params.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_list__ = __webpack_require__("./state/types/list.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  function addSilentDefault(obj) {
    Object.defineProperty(obj, 'default', {
      value: _extends({}, options.defaultParams)
    });
    return obj;
  }
  var initialState = addSilentDefault(options.defaultParams || {});

  return function () {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload,
        meta = _ref.meta;

    if (meta && meta.resource !== resource) {
      return previousState;
    } else if (meta && meta.location && meta.query) {
      return addSilentDefault(_extends({}, previousState, meta.query));
    }
    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_0__state_types_list__["a" /* CHANGE_LIST_PARAMS */]:
        return addSilentDefault(payload);
      default:
        return previousState;
    }
  };
});

/***/ }),

/***/ "./state/reducers/resource/list/queryReducer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var oppositeOrder = function oppositeOrder(direction) {
  return direction === __WEBPACK_IMPORTED_MODULE_0__state_types_query__["e" /* SORT_DESC */] ? __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */] : __WEBPACK_IMPORTED_MODULE_0__state_types_query__["e" /* SORT_DESC */];
};

/* harmony default export */ __webpack_exports__["a"] = (function (previousState, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_0__state_types_query__["c" /* SET_SORT */]:
      if (payload === previousState.sort) {
        return _extends({}, previousState, {
          order: oppositeOrder(previousState.order),
          page: 1
        });
      }

      return _extends({}, previousState, {
        sort: payload,
        order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */],
        page: 1
      });

    case __WEBPACK_IMPORTED_MODULE_0__state_types_query__["b" /* SET_PAGE */]:
      return _extends({}, previousState, { page: payload });

    case __WEBPACK_IMPORTED_MODULE_0__state_types_query__["a" /* SET_FILTER */]:
      {
        return _extends({}, previousState, { page: 1, filter: payload });
      }

    default:
      return previousState;
  }
});

/***/ }),

/***/ "./state/reducers/resource/list/total.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_data__ = __webpack_require__("./state/types/data.js");


/* harmony default export */ __webpack_exports__["a"] = (function (resource, options) {
  return function () {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload,
        meta = _ref.meta;

    if (!meta || meta.resource !== resource) {
      return previousState;
    }
    if (type === __WEBPACK_IMPORTED_MODULE_0__state_types_data__["k" /* GET_LIST_SUCCESS */]) {
      return payload.total;
    }
    return previousState;
  };
});

/***/ }),

/***/ "./state/reducers/rest.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__("./state/reducers/resource/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__("./state/reducers/loading.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__references__ = __webpack_require__("./state/reducers/references/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__saving__ = __webpack_require__("./state/reducers/saving.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/* harmony default export */ __webpack_exports__["a"] = (function (resources) {
  var resourceReducers = {};
  resources.forEach(function (resource) {
    resourceReducers[resource.name] = Object(__WEBPACK_IMPORTED_MODULE_1__resource__["a" /* default */])(resource.name, resource.options);
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])(_extends({}, resourceReducers, {
    references: __WEBPACK_IMPORTED_MODULE_3__references__["a" /* default */],
    saving: __WEBPACK_IMPORTED_MODULE_4__saving__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_2__loading__["a" /* default */]
  }));
});

/***/ }),

/***/ "./state/reducers/saving.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_data__ = __webpack_require__("./state/types/data.js");




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["b" /* CREATE */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["x" /* UPDATE */]:
      return { redirect: payload.redirectTo };

    case __WEBPACK_IMPORTED_MODULE_0_redux_form__["b" /* actionTypes */].SET_SUBMIT_FAILED:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["d" /* CREATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["c" /* CREATE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["z" /* UPDATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__state_types_data__["y" /* UPDATE_FAILURE */]:
      return false;
    default:
      return previousState;
  }
});

/***/ }),

/***/ "./state/reducers/ui.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notification__ = __webpack_require__("./state/reducers/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_reducers_modal__ = __webpack_require__("./state/reducers/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_reducers_pageflip__ = __webpack_require__("./state/reducers/pageflip.js");





var uiReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  pageflip: __WEBPACK_IMPORTED_MODULE_3__state_reducers_pageflip__["a" /* default */],
  notification: __WEBPACK_IMPORTED_MODULE_1__notification__["a" /* default */],
  modal: __WEBPACK_IMPORTED_MODULE_2__state_reducers_modal__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (uiReducer);

/***/ }),

/***/ "./state/resources.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_static_newsletters__ = __webpack_require__("./state/static/newsletters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_static_products__ = __webpack_require__("./state/static/products.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_static_contacts__ = __webpack_require__("./state/static/contacts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_static_components__ = __webpack_require__("./state/static/components.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_static_users__ = __webpack_require__("./state/static/users.js");






/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'statistics',
  options: {}
}, {
  name: 'newsletters',
  options: { defaultParams: __WEBPACK_IMPORTED_MODULE_0__state_static_newsletters__["a" /* default */], relationToOne: ['products', 'contacts'] }
}, {
  name: 'products',
  options: { defaultParams: __WEBPACK_IMPORTED_MODULE_1__state_static_products__["a" /* default */] }
}, {
  name: 'contacts',
  options: { defaultParams: __WEBPACK_IMPORTED_MODULE_2__state_static_contacts__["a" /* default */] }
}, {
  name: 'components',
  options: { defaultParams: __WEBPACK_IMPORTED_MODULE_3__state_static_components__["a" /* default */] }
}, {
  name: 'users',
  options: { defaultParams: __WEBPACK_IMPORTED_MODULE_4__state_static_users__["a" /* default */] }
}]);

/***/ }),

/***/ "./state/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return middleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enhancer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialDispatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__("../node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("../node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_routesMap__ = __webpack_require__("./state/routesMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_callbacks__ = __webpack_require__("./state/callbacks.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__state_routesMap__["a"]; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var history = __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()();

var _connectRoutes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__["connectRoutes"])(history, __WEBPACK_IMPORTED_MODULE_3__state_routesMap__["a" /* default */], _extends({
  querySerializer: __WEBPACK_IMPORTED_MODULE_2_qs___default.a
}, __WEBPACK_IMPORTED_MODULE_4__state_callbacks__["a" /* default */])),
    reducer = _connectRoutes.reducer,
    middleware = _connectRoutes.middleware,
    enhancer = _connectRoutes.enhancer,
    initialDispatch = _connectRoutes.initialDispatch;



/***/ }),

/***/ "./state/routesMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routesIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Dashboard__ = __webpack_require__("./view/Dashboard/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Dashboard_editNewsletter__ = __webpack_require__("./view/Dashboard/editNewsletter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Products__ = __webpack_require__("./view/Products/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Products_newProduct__ = __webpack_require__("./view/Products/newProduct.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Products_editProduct__ = __webpack_require__("./view/Products/editProduct.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_Users__ = __webpack_require__("./view/Users/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Users_editUser__ = __webpack_require__("./view/Users/editUser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_Users_newUser__ = __webpack_require__("./view/Users/newUser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_Components__ = __webpack_require__("./view/Components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_Contacts__ = __webpack_require__("./view/Contacts/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_Contacts_editContact__ = __webpack_require__("./view/Contacts/editContact.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_Contacts_newContact__ = __webpack_require__("./view/Contacts/newContact.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_Login__ = __webpack_require__("./view/Login/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__view_Login_Reset__ = __webpack_require__("./view/Login/Reset.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__state_sagas_statistics__ = __webpack_require__("./state/sagas/statistics.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__state_sagas_build__ = __webpack_require__("./state/sagas/build.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__state_types_routes__ = __webpack_require__("./state/types/routes.js");
var _routesMap;





























var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  'Register'
);

var Register = function Register() {
  return _ref;
};

var routesMap = (_routesMap = {}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["g" /* ROUTE_DASHBOARD */]] = {
  name: 'Newsletters',
  path: '/',
  resource: 'newsletters',
  role: 'admin',
  saga: __WEBPACK_IMPORTED_MODULE_16__state_sagas_statistics__["a" /* default */],
  view: __WEBPACK_IMPORTED_MODULE_2__view_Dashboard__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["j" /* ROUTE_NEWSLETTERS_NEW */]] = {
  hidden: true,
  name: 'New Newsletter',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["g" /* ROUTE_DASHBOARD */],
  path: '/newsletters/new/:step(build|content|add)?',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["g" /* ROUTE_DASHBOARD */],
  relations: ['products', 'contacts'],
  saga: __WEBPACK_IMPORTED_MODULE_17__state_sagas_build__["a" /* default */],
  view: __WEBPACK_IMPORTED_MODULE_3__view_Dashboard_editNewsletter__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */]] = {
  hidden: true,
  name: 'Edit Newsletter',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["g" /* ROUTE_DASHBOARD */],
  path: '/newsletters/:id/:step(build|content|add)?',
  resource: 'newsletters',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["g" /* ROUTE_DASHBOARD */],
  relations: ['products', 'contacts'],
  saga: __WEBPACK_IMPORTED_MODULE_17__state_sagas_build__["a" /* default */],
  view: __WEBPACK_IMPORTED_MODULE_3__view_Dashboard_editNewsletter__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["a" /* ROUTE_COMPONENTS */]] = {
  action: { label: 'Add new component', target: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["c" /* ROUTE_COMPONENTS_NEW */] },
  name: 'Components',
  path: '/components',
  resource: 'components',
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_10__view_Components__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["c" /* ROUTE_COMPONENTS_NEW */]] = {
  name: 'Add new',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["a" /* ROUTE_COMPONENTS */],
  path: '/components/new',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["a" /* ROUTE_COMPONENTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_10__view_Components__["b" /* editComponents */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["b" /* ROUTE_COMPONENTS_EDIT */]] = {
  name: 'Edit',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["a" /* ROUTE_COMPONENTS */],
  path: '/components/:id',
  resource: 'components',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["a" /* ROUTE_COMPONENTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_10__view_Components__["b" /* editComponents */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["k" /* ROUTE_PRODUCTS */]] = {
  action: { label: 'Add new product', target: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["m" /* ROUTE_PRODUCTS_NEW */] },
  name: 'Products',
  path: '/products',
  resource: 'products',
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_4__view_Products__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["m" /* ROUTE_PRODUCTS_NEW */]] = {
  name: 'Add new',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["k" /* ROUTE_PRODUCTS */],
  path: '/products/new',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["k" /* ROUTE_PRODUCTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_5__view_Products_newProduct__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["l" /* ROUTE_PRODUCTS_EDIT */]] = {
  name: 'Edit',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["k" /* ROUTE_PRODUCTS */],
  path: '/products/:id',
  resource: 'products',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["k" /* ROUTE_PRODUCTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_6__view_Products_editProduct__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["d" /* ROUTE_CONTACTS */]] = {
  action: { label: 'Add new contact', target: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["f" /* ROUTE_CONTACTS_NEW */] },
  name: 'Contacts',
  path: '/contacts',
  resource: 'contacts',
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_11__view_Contacts__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["f" /* ROUTE_CONTACTS_NEW */]] = {
  name: 'New contact',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["d" /* ROUTE_CONTACTS */],
  path: '/contacts/new',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["d" /* ROUTE_CONTACTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_13__view_Contacts_newContact__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["e" /* ROUTE_CONTACTS_EDIT */]] = {
  name: 'Edit',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["d" /* ROUTE_CONTACTS */],
  path: '/contacts/:id',
  resource: 'contacts',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["d" /* ROUTE_CONTACTS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_12__view_Contacts_editContact__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["p" /* ROUTE_USERS */]] = {
  action: { label: 'Add new user', target: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["r" /* ROUTE_USERS_NEW */] },
  name: 'Team',
  path: '/team',
  resource: 'users',
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_7__view_Users__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["r" /* ROUTE_USERS_NEW */]] = {
  name: 'Add new',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["p" /* ROUTE_USERS */],
  path: '/team/new',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["p" /* ROUTE_USERS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_9__view_Users_newUser__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["q" /* ROUTE_USERS_EDIT */]] = {
  name: 'Edit',
  notInMenu: true,
  parent: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["p" /* ROUTE_USERS */],
  path: '/team/:id',
  resource: 'users',
  redirectToList: __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["p" /* ROUTE_USERS */],
  role: 'admin',
  view: __WEBPACK_IMPORTED_MODULE_8__view_Users_editUser__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["n" /* ROUTE_REGISTER */]] = {
  hidden: true,
  name: 'Register',
  path: '/register',
  view: Register
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["o" /* ROUTE_RESET */]] = {
  hidden: true,
  name: 'Reset',
  path: '/reset',
  view: __WEBPACK_IMPORTED_MODULE_15__view_Login_Reset__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_18__state_types_routes__["h" /* ROUTE_LOGIN */]] = {
  hidden: true,
  name: 'Login',
  path: '/login',
  view: __WEBPACK_IMPORTED_MODULE_14__view_Login__["a" /* default */]
}, _routesMap[__WEBPACK_IMPORTED_MODULE_1_redux_first_router__["NOT_FOUND"]] = __WEBPACK_IMPORTED_MODULE_18__state_types_routes__["h" /* ROUTE_LOGIN */], _routesMap);

var routesIndex = Object.keys(routesMap);

/* harmony default export */ __webpack_exports__["a"] = (routesMap);

/***/ }),

/***/ "./state/sagas/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_types_fetch__ = __webpack_require__("./state/types/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_auth__ = __webpack_require__("./state/actions/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_types_auth__ = __webpack_require__("./state/types/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_types_routes__ = __webpack_require__("./state/types/routes.js");










/* harmony default export */ __webpack_exports__["a"] = (function (authClient) {
  var _marked = regeneratorRuntime.mark(handleAuth);

  if (!authClient) return function () {
    return null;
  };
  function handleAuth(action) {
    var type, payload, error, meta, authPayload, errorMessage;
    return regeneratorRuntime.wrap(function handleAuth$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            type = action.type, payload = action.payload, error = action.error, meta = action.meta;
            _context.t0 = type;
            _context.next = _context.t0 === __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["c" /* LOGIN */] ? 4 : _context.t0 === __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["a" /* CHECK */] ? 24 : _context.t0 === __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["g" /* LOGOUT */] ? 38 : _context.t0 === __WEBPACK_IMPORTED_MODULE_3__state_types_fetch__["c" /* ERROR */] ? 43 : 57;
            break;

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["e" /* LOGIN_LOADING */] });

          case 7:
            _context.next = 9;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["c" /* LOGIN */], payload);

          case 9:
            authPayload = _context.sent;
            _context.next = 12;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["f" /* LOGIN_SUCCESS */], payload: authPayload });

          case 12:
            _context.next = 14;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["d" /* routeDashboard */])());

          case 14:
            _context.next = 23;
            break;

          case 16:
            _context.prev = 16;
            _context.t1 = _context['catch'](4);
            _context.next = 20;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["d" /* LOGIN_FAILURE */], error: _context.t1, meta: { auth: true } });

          case 20:
            errorMessage = typeof _context.t1 === 'string' ? _context.t1 : typeof _context.t1 === 'undefined' || !_context.t1.message ? 'i18n.auth.sign_in_error' : _context.t1.message;
            _context.next = 23;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_notification__["b" /* showNotification */])(__WEBPACK_IMPORTED_MODULE_6__state_types_auth__["c" /* LOGIN */], errorMessage, { timeout: 7000, type: 'warning' }));

          case 23:
            return _context.abrupt('break', 58);

          case 24:
            _context.prev = 24;
            _context.next = 27;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["a" /* CHECK */], payload);

          case 27:
            _context.next = 29;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_auth__["a" /* userAuthenticated */])());

          case 29:
            _context.next = 37;
            break;

          case 31:
            _context.prev = 31;
            _context.t2 = _context['catch'](24);
            _context.next = 35;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["g" /* LOGOUT */]);

          case 35:
            _context.next = 37;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_1_redux_first_router__["redirect"])({ type: __WEBPACK_IMPORTED_MODULE_7__state_types_routes__["h" /* ROUTE_LOGIN */] }));

          case 37:
            return _context.abrupt('break', 58);

          case 38:
            _context.next = 40;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["g" /* LOGOUT */]);

          case 40:
            _context.next = 42;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["e" /* routeLogin */])());

          case 42:
            return _context.abrupt('break', 58);

          case 43:
            _context.prev = 43;
            _context.next = 46;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["d" /* LOGIN_FAILURE */], error);

          case 46:
            _context.next = 56;
            break;

          case 48:
            _context.prev = 48;
            _context.t3 = _context['catch'](43);
            _context.next = 52;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(authClient, __WEBPACK_IMPORTED_MODULE_6__state_types_auth__["g" /* LOGOUT */]);

          case 52:
            _context.next = 54;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["e" /* routeLogin */])());

          case 54:
            _context.next = 56;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_notification__["a" /* hideNotification */])());

          case 56:
            return _context.abrupt('break', 58);

          case 57:
            return _context.abrupt('break', 58);

          case 58:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this, [[4, 16], [24, 31], [43, 48]]);
  }
  return regeneratorRuntime.mark(function watchAuthActions() {
    return regeneratorRuntime.wrap(function watchAuthActions$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(function (action) {
              return action.meta && action.meta.auth;
            }, handleAuth), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__state_types_fetch__["c" /* ERROR */], handleAuth)]);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, watchAuthActions, this);
  });
});

/***/ }),

/***/ "./state/sagas/build.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = redirectNewBuild;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_data__ = __webpack_require__("./state/types/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
var _marked = regeneratorRuntime.mark(redirectTo),
    _marked2 = regeneratorRuntime.mark(redirectNewBuild);





function redirectTo(action) {
  return regeneratorRuntime.wrap(function redirectTo$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_routes__["a" /* goToPage */])(action.meta.redirectTo.type, null, { id: action.payload.data.id, step: 'build' }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function redirectNewBuild(action) {
  return regeneratorRuntime.wrap(function redirectNewBuild$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(function (action) {
            return (action.type === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["d" /* CREATE_SUCCESS */] || action.type === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["z" /* UPDATE_SUCCESS */]) && action.meta && action.meta.redirectTo;
          }, redirectTo);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./state/sagas/crudFetch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__ = __webpack_require__("./state/types/fetch.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var crudFetch = function crudFetch(restClient) {
  var _marked = regeneratorRuntime.mark(handleFetch);

  function handleFetch(action) {
    var type, payload, _action$meta, fetchMeta, meta, restType, response;

    return regeneratorRuntime.wrap(function handleFetch$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            type = action.type, payload = action.payload, _action$meta = action.meta, fetchMeta = _action$meta.fetch, meta = _objectWithoutProperties(_action$meta, ['fetch']);
            restType = fetchMeta;
            _context.next = 4;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: type + '_LOADING', payload: payload, meta: meta }), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["d" /* START */] })]);

          case 4:
            response = void 0;
            _context.prev = 5;
            _context.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(restClient, restType, meta.resource, payload);

          case 8:
            response = _context.sent;

            if (response.data) {
              _context.next = 11;
              break;
            }

            throw new Error('REST response must contain a data key');

          case 11:
            _context.next = 13;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({
              type: type + '_SUCCESS',
              payload: response,
              requestPayload: payload,
              meta: _extends({}, meta, { fetchResponse: restType, fetchStatus: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["b" /* END */] })
            });

          case 13:
            _context.next = 15;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["b" /* END */] });

          case 15:
            _context.next = 23;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context['catch'](5);
            _context.next = 21;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({
              type: type + '_FAILURE',
              error: _context.t0.message ? _context.t0.message : _context.t0,
              requestPayload: payload,
              meta: _extends({}, meta, { fetchResponse: restType, fetchStatus: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["c" /* ERROR */] })
            });

          case 21:
            _context.next = 23;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["c" /* ERROR */], error: _context.t0 });

          case 23:
            _context.prev = 23;
            _context.next = 26;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["c" /* cancelled */])();

          case 26:
            if (!_context.sent) {
              _context.next = 30;
              break;
            }

            _context.next = 29;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_1__state_types_fetch__["a" /* CANCEL */] });

          case 29:
            return _context.abrupt('return');

          case 30:
            return _context.finish(23);

          case 31:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this, [[5, 17, 23, 31]]);
  }

  return regeneratorRuntime.mark(function watchCrudFetch() {
    return regeneratorRuntime.wrap(function watchCrudFetch$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(function (action) {
              return action.meta && action.meta.fetch && action.meta.cancelPrevious;
            }, handleFetch), Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(function (action) {
              return action.meta && action.meta.fetch && !action.meta.cancelPrevious;
            }, handleFetch)]);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, watchCrudFetch, this);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (crudFetch);

/***/ }),

/***/ "./state/sagas/crudResponse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_types_data__ = __webpack_require__("./state/types/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selectors__ = __webpack_require__("./state/selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
var _marked = regeneratorRuntime.mark(handleResponse),
    _marked2 = regeneratorRuntime.mark(_callee);








function handleResponse(_ref) {
  var type = _ref.type,
      requestPayload = _ref.requestPayload,
      error = _ref.error,
      payload = _ref.payload;

  var sagas, redirectTo, route, _route, _route2, errorMessage;

  return regeneratorRuntime.wrap(function handleResponse$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sagas = [];
          redirectTo = void 0;
          _context.t0 = type;
          _context.next = _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["z" /* UPDATE_SUCCESS */] ? 5 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["d" /* CREATE_SUCCESS */] ? 28 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["g" /* DELETE_SUCCESS */] ? 51 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["t" /* GET_ONE_FAILURE */] ? 74 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["j" /* GET_LIST_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["m" /* GET_MANY_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["w" /* GET_SIMPLE_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["o" /* GET_MANY_REFERENCE_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["c" /* CREATE_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["y" /* UPDATE_FAILURE */] ? 84 : _context.t0 === __WEBPACK_IMPORTED_MODULE_1__state_types_data__["f" /* DELETE_FAILURE */] ? 84 : 88;
          break;

        case 5:
          if (!(requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false)) {
            _context.next = 9;
            break;
          }

          redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }];
          _context.next = 13;
          break;

        case 9:
          _context.next = 11;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_selectors__["b" /* getCurrentRoute */]);

        case 11:
          route = _context.sent;

          if (route.redirectToList) {
            redirectTo = [route.redirectToList];
          } else if (route.redirectToSingle) {
            redirectTo = [route.redirectToSingle, null, { id: payload.data.id }];
          }

        case 13:
          if (!redirectTo) {
            _context.next = 19;
            break;
          }

          _context.t1 = sagas;
          _context.next = 17;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["a" /* goToPage */].apply(undefined, redirectTo));

        case 17:
          _context.t2 = _context.sent;

          _context.t1.push.call(_context.t1, _context.t2);

        case 19:
          if (!(requestPayload.message !== false)) {
            _context.next = 25;
            break;
          }

          _context.t3 = sagas;
          _context.next = 23;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_notification__["b" /* showNotification */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["z" /* UPDATE_SUCCESS */], requestPayload.message || 'i18n.notification.updated'));

        case 23:
          _context.t4 = _context.sent;

          _context.t3.push.call(_context.t3, _context.t4);

        case 25:
          _context.next = 27;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])(sagas);

        case 27:
          return _context.abrupt('return', _context.sent);

        case 28:
          if (!(requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false)) {
            _context.next = 32;
            break;
          }

          redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }];
          _context.next = 36;
          break;

        case 32:
          _context.next = 34;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_selectors__["b" /* getCurrentRoute */]);

        case 34:
          _route = _context.sent;

          if (_route.redirectToList) {
            redirectTo = [_route.redirectToList];
          } else if (_route.redirectToSingle) {
            redirectTo = [_route.redirectToSingle, null, { id: payload.data.id }];
          }

        case 36:
          if (!redirectTo) {
            _context.next = 42;
            break;
          }

          _context.t5 = sagas;
          _context.next = 40;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["a" /* goToPage */].apply(undefined, redirectTo));

        case 40:
          _context.t6 = _context.sent;

          _context.t5.push.call(_context.t5, _context.t6);

        case 42:
          if (!(requestPayload.message !== false)) {
            _context.next = 48;
            break;
          }

          _context.t7 = sagas;
          _context.next = 46;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_notification__["b" /* showNotification */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["d" /* CREATE_SUCCESS */], requestPayload.message || 'i18n.notification.created'));

        case 46:
          _context.t8 = _context.sent;

          _context.t7.push.call(_context.t7, _context.t8);

        case 48:
          _context.next = 50;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])(sagas);

        case 50:
          return _context.abrupt('return', _context.sent);

        case 51:
          if (!(requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false)) {
            _context.next = 55;
            break;
          }

          redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }];
          _context.next = 59;
          break;

        case 55:
          _context.next = 57;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_selectors__["b" /* getCurrentRoute */]);

        case 57:
          _route2 = _context.sent;

          if (_route2.redirectToList) {
            redirectTo = [_route2.redirectToList];
          } else if (_route2.redirectToSingle) {
            redirectTo = [_route2.redirectToSingle, null, { id: payload.data.id }];
          }

        case 59:
          if (!redirectTo) {
            _context.next = 65;
            break;
          }

          _context.t9 = sagas;
          _context.next = 63;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["a" /* goToPage */].apply(undefined, redirectTo));

        case 63:
          _context.t10 = _context.sent;

          _context.t9.push.call(_context.t9, _context.t10);

        case 65:
          if (!(requestPayload.message !== false)) {
            _context.next = 71;
            break;
          }

          _context.t11 = sagas;
          _context.next = 69;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_notification__["b" /* showNotification */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["g" /* DELETE_SUCCESS */], requestPayload.message || 'i18n.notification.deleted'));

        case 69:
          _context.t12 = _context.sent;

          _context.t11.push.call(_context.t11, _context.t12);

        case 71:
          _context.next = 73;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])(sagas);

        case 73:
          return _context.abrupt('return', _context.sent);

        case 74:
          if (!requestPayload.basePath) {
            _context.next = 80;
            break;
          }

          _context.next = 77;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_notification__["b" /* showNotification */])(__WEBPACK_IMPORTED_MODULE_1__state_types_data__["t" /* GET_ONE_FAILURE */], 'i18n.notification.item_doesnt_exist', {
            type: 'warning'
          }))]);

        case 77:
          _context.t13 = _context.sent;
          _context.next = 83;
          break;

        case 80:
          _context.next = 82;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([]);

        case 82:
          _context.t13 = _context.sent;

        case 83:
          return _context.abrupt('return', _context.t13);

        case 84:
          errorMessage = typeof error === 'string' ? error : error.message || 'i18n.notification.http_error';
          _context.next = 87;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_notification__["b" /* showNotification */])(type, errorMessage, { type: 'warning' }));

        case 87:
          return _context.abrupt('return', _context.sent);

        case 88:
          _context.next = 90;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([]);

        case 90:
          return _context.abrupt('return', _context.sent);

        case 91:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["h" /* takeEvery */])(function (action) {
            return action.meta && action.meta.fetchResponse;
          }, handleResponse);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ "./state/sagas/crudSaga.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__("./state/sagas/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crudFetch__ = __webpack_require__("./state/sagas/crudFetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crudResponse__ = __webpack_require__("./state/sagas/crudResponse.js");





/* harmony default export */ __webpack_exports__["a"] = (function (restClient, authClient) {
  return regeneratorRuntime.mark(function crudSaga() {
    return regeneratorRuntime.wrap(function crudSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */])(authClient)(), Object(__WEBPACK_IMPORTED_MODULE_2__crudFetch__["a" /* default */])(restClient)(), Object(__WEBPACK_IMPORTED_MODULE_3__crudResponse__["a" /* default */])()]);

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, crudSaga, this);
  });
});

/***/ }),

/***/ "./state/sagas/root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_simple__ = __webpack_require__("./api/simple.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_addUpload__ = __webpack_require__("./api/addUpload.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_authClient__ = __webpack_require__("./api/authClient.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_sagas_crudSaga__ = __webpack_require__("./state/sagas/crudSaga.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_sagas_routes__ = __webpack_require__("./state/sagas/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_auth__ = __webpack_require__("./state/actions/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__wsSagas__ = __webpack_require__("./state/sagas/wsSagas.js");
var _marked = regeneratorRuntime.mark(checkInitialAuth);












var simpleRestClient = Object(__WEBPACK_IMPORTED_MODULE_1__api_simple__["a" /* default */])();
var enhancedRest = Object(__WEBPACK_IMPORTED_MODULE_2__api_addUpload__["a" /* default */])(simpleRestClient);
var restCall = function restCall(type, resource, params) {
  return new Promise(function (resolve) {
    return resolve(enhancedRest(type, resource, params));
  });
};

function checkInitialAuth() {
  return regeneratorRuntime.wrap(function checkInitialAuth$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__state_actions_auth__["b" /* userCheck */])());

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/* harmony default export */ __webpack_exports__["a"] = (function (initialDispatch, routesMap) {
  return regeneratorRuntime.mark(function rootSaga() {
    return regeneratorRuntime.wrap(function rootSaga$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["a" /* all */])([__WEBPACK_IMPORTED_MODULE_7__wsSagas__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__state_sagas_crudSaga__["a" /* default */])(restCall, __WEBPACK_IMPORTED_MODULE_3__api_authClient__["a" /* default */]), checkInitialAuth, Object(__WEBPACK_IMPORTED_MODULE_5__state_sagas_routes__["a" /* default */])(initialDispatch, routesMap)].map(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* fork */]));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, rootSaga, this);
  });
});

/***/ }),

/***/ "./state/sagas/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSagaWithRouting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inflection__ = __webpack_require__("../node_modules/inflection/lib/inflection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inflection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inflection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_selectors__ = __webpack_require__("./state/selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_types_data__ = __webpack_require__("./state/types/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Download__ = __webpack_require__("./ui/Download/index.js");
var _marked = regeneratorRuntime.mark(loadRelations),
    _marked2 = regeneratorRuntime.mark(getList),
    _marked3 = regeneratorRuntime.mark(onRelations),
    _marked4 = regeneratorRuntime.mark(onRest),
    _marked5 = regeneratorRuntime.mark(onDownload),
    _marked6 = regeneratorRuntime.mark(onSaga);











function loadRelations(resources, _ref) {
  var type = _ref.type,
      requestPayload = _ref.requestPayload,
      error = _ref.error,
      payload = _ref.payload;
  return regeneratorRuntime.wrap(function loadRelations$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(resources.map(function (resource) {
            var resourceId = payload.data[__WEBPACK_IMPORTED_MODULE_0_inflection___default.a.singularize(resource) + '_id'];
            return Number.isInteger(resourceId) && Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_data__["e" /* crudGetOne */])(resource, resourceId, false));
          }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getList(resource, withPaging) {
  var params;
  return regeneratorRuntime.wrap(function getList$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_selectors__["c" /* getListParams */])(resource));

        case 2:
          params = _context2.sent;
          _context2.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_data__["d" /* crudGetList */])(params[0], withPaging ? params[1] : false, params[2], params[3], false));

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function onRelations(routesMap, action) {
  var currentRoute;
  return regeneratorRuntime.wrap(function onRelations$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          currentRoute = routesMap[action.type];
          _context3.next = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(currentRoute.relations.map(function (resource) {
            return getList(resource);
          }));

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function onRest(routesMap, action) {
  var id, currentRoute;
  return regeneratorRuntime.wrap(function onRest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3__state_selectors__["a" /* getCurrentRecordId */]);

        case 2:
          id = _context4.sent;
          currentRoute = routesMap[action.type];

          if (!id) {
            _context4.next = 12;
            break;
          }

          _context4.next = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_data__["e" /* crudGetOne */])(currentRoute.resource, id));

        case 7:
          if (!currentRoute.hasOne) {
            _context4.next = 10;
            break;
          }

          _context4.next = 10;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */])(function (action) {
            return action.type === __WEBPACK_IMPORTED_MODULE_4__state_types_data__["u" /* GET_ONE_SUCCESS */] && action.meta && action.meta.resource === currentRoute.resource;
          }, loadRelations, currentRoute.hasOne);

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getList, currentRoute.resource, true);

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

var check = function check(id) {
  return fetch("https://newsletter.elovade.com" + '/api/build/check/' + id).then(function (response) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(true);
    } else {
      return Promise.reject(false);
    }
  }).catch(function (error) {
    return false;
  });
};

function onDownload(data) {
  var response;
  return regeneratorRuntime.wrap(function onDownload$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(check, data.payload);

        case 2:
          response = _context5.sent;

          if (!response) {
            _context5.next = 11;
            break;
          }

          _context5.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__state_actions_data__["h" /* downloadTemplate */])());

        case 6:
          _context5.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_notification__["b" /* showNotification */])(data.payload, 'Downloading mail template: ' + data.payload));

        case 8:
          Object(__WEBPACK_IMPORTED_MODULE_6__ui_Download__["a" /* default */])("https://newsletter.elovade.com" + '/api/build/download/' + data.payload, 'preview.html');
          _context5.next = 13;
          break;

        case 11:
          _context5.next = 13;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_notification__["b" /* showNotification */])(data.payload, 'Mail template: ' + data.payload + ' doesn\'t exists,\n         check if the record exists and has all the needed parts!'));

        case 13:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function onSaga(routesMap, action) {
  return regeneratorRuntime.wrap(function onSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(routesMap[action.type].saga, action);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function createSagaWithRouting(initialDispatch, routesMap) {
  var _marked7 = regeneratorRuntime.mark(routesRest),
      _marked8 = regeneratorRuntime.mark(routesRelations),
      _marked9 = regeneratorRuntime.mark(routesSaga),
      _marked10 = regeneratorRuntime.mark(downloadSaga);

  var routesWithSaga = Object.keys(routesMap).filter(function (route) {
    return routesMap[route].saga;
  });
  var routesWithRest = Object.keys(routesMap).filter(function (route) {
    return routesMap[route].resource;
  });
  var routesWithRelations = Object.keys(routesMap).filter(function (route) {
    return routesMap[route].relations;
  });

  function routesRest() {
    return regeneratorRuntime.wrap(function routesRest$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeLatest */])(routesWithRest, onRest, routesMap);

          case 2:
          case 'end':
            return _context7.stop();
        }
      }
    }, _marked7, this);
  }

  function routesRelations() {
    return regeneratorRuntime.wrap(function routesRelations$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeLatest */])(routesWithRelations, onRelations, routesMap);

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _marked8, this);
  }

  function routesSaga() {
    return regeneratorRuntime.wrap(function routesSaga$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeLatest */])(routesWithSaga, onSaga, routesMap);

          case 2:
          case 'end':
            return _context9.stop();
        }
      }
    }, _marked9, this);
  }

  function downloadSaga() {
    return regeneratorRuntime.wrap(function downloadSaga$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__state_types_data__["a" /* CHECK_TEMPLATE */], onDownload);

          case 2:
          case 'end':
            return _context10.stop();
        }
      }
    }, _marked10, this);
  }

  return regeneratorRuntime.mark(function sagas() {
    return regeneratorRuntime.wrap(function sagas$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(routesRest);

          case 2:
            _context11.next = 4;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(routesRelations);

          case 4:
            _context11.next = 6;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(routesSaga);

          case 6:
            _context11.next = 8;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(downloadSaga);

          case 8:
            _context11.next = 10;
            return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(initialDispatch);

          case 10:
          case 'end':
            return _context11.stop();
        }
      }
    }, sagas, this);
  });
}

/***/ }),

/***/ "./state/sagas/statistics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadStatistics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_actions_data__ = __webpack_require__("./state/actions/data.js");
var _marked = regeneratorRuntime.mark(loadStatistics);




function loadStatistics(action) {
  return regeneratorRuntime.wrap(function loadStatistics$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_1__state_actions_data__["f" /* crudGetSimple */])('statistics', true));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ "./state/sagas/wsSagas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wsSagas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__ = __webpack_require__("../node_modules/redux-saga/es/effects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__("../node_modules/redux-saga/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_selectors__ = __webpack_require__("./state/selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_editing__ = __webpack_require__("./state/actions/editing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_types_editing__ = __webpack_require__("./state/types/editing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_types_routes__ = __webpack_require__("./state/types/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_types_auth__ = __webpack_require__("./state/types/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_websocket__ = __webpack_require__("./helpers/websocket.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = regeneratorRuntime.mark(sendMessagesToWS),
    _marked2 = regeneratorRuntime.mark(startAndListenWS),
    _marked3 = regeneratorRuntime.mark(wsSagas);













var RECORD_OPENED = 'RECORD_OPENED';
var RECORD_UPDATED = 'RECORD_UPDATED';
var USER_DISCONNECTED = 'USER_DISCONNECTED';

function initWebsocket(ws, user) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* eventChannel */])(function (emitter) {
    ws.onopen = function () {
      console.log('Connected to server websocket...');
    };
    ws.onerror = function (error) {
      console.log('WebSocket error ' + error);
      console.dir(error);
    };
    ws.onmessage = function (e) {
      var msg = null;
      try {
        msg = JSON.parse(e.data);
      } catch (e) {
        console.error('Error parsing : ' + e.data);
      }
      if (msg) {
        if (user.id !== (msg.user && msg.user.id || msg.nlData && msg.nlData.edited_by.id)) {
          emitter(msg);
        }
      }
    };

    return function () {
      console.log('Socket off');
    };
  });
}

function alertServerEditingEnded(ws, action) {
  ws.send(JSON.stringify(action));
}

function sendMessagesToWS(ws) {
  return regeneratorRuntime.wrap(function sendMessagesToWS$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["i" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__state_types_editing__["d" /* NOTIFY_SERVER_EDITING_ENDED */], alertServerEditingEnded, ws);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function startAndListenWS(ws) {
  var auth, channel, msg, loc;
  return regeneratorRuntime.wrap(function startAndListenWS$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_selectors__["e" /* getLoggedUser */]);

        case 2:
          auth = _context2.sent;
          _context2.next = 5;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["b" /* call */])(initWebsocket, ws, auth.user);

        case 5:
          channel = _context2.sent;

        case 6:
          if (false) {
            _context2.next = 36;
            break;
          }

          _context2.next = 9;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(channel);

        case 9:
          msg = _context2.sent;
          _context2.next = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_selectors__["d" /* getLocation */]);

        case 12:
          loc = _context2.sent;

          if (!(msg.type === RECORD_OPENED)) {
            _context2.next = 21;
            break;
          }

          if (!(loc.type === __WEBPACK_IMPORTED_MODULE_7__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */] && msg.newsletterId && msg.newsletterId === loc.payload.id)) {
            _context2.next = 17;
            break;
          }

          _context2.next = 17;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__state_actions_modal__["b" /* showModal */])({
            title: 'Editing finished',
            content: 'User ' + msg.user.full_name + ' has taken over editing of the newsletter.',
            sticky: true,
            hideClose: true,
            buttonActions: [{ label: 'Ok', action: __WEBPACK_IMPORTED_MODULE_4__state_actions_routes__["d" /* routeDashboard */] }]
          }));

        case 17:
          _context2.next = 19;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_editing__["c" /* editingStarted */])({ user: msg.user, newsletterId: msg.newsletterId }));

        case 19:
          _context2.next = 34;
          break;

        case 21:
          if (!(msg.type === RECORD_UPDATED)) {
            _context2.next = 26;
            break;
          }

          _context2.next = 24;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_editing__["a" /* editCommitted */])(_extends({}, msg)));

        case 24:
          _context2.next = 34;
          break;

        case 26:
          if (!(msg.type === USER_DISCONNECTED)) {
            _context2.next = 31;
            break;
          }

          _context2.next = 29;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_editing__["e" /* userDisconnected */])({ userId: msg.userId }));

        case 29:
          _context2.next = 34;
          break;

        case 31:
          if (!(msg.type === __WEBPACK_IMPORTED_MODULE_6__state_types_editing__["a" /* EDITING_ENDED */])) {
            _context2.next = 34;
            break;
          }

          _context2.next = 34;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__state_actions_editing__["b" /* editingEnded */])(msg.payload));

        case 34:
          _context2.next = 6;
          break;

        case 36:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function wsSagas() {
  var url, ws;
  return regeneratorRuntime.wrap(function wsSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["g" /* take */])(function (action) {
            return action.type === __WEBPACK_IMPORTED_MODULE_8__state_types_auth__["b" /* CHECK_PASSED */] || action.type === __WEBPACK_IMPORTED_MODULE_8__state_types_auth__["f" /* LOGIN_SUCCESS */];
          });

        case 2:
          url = "https://newsletter.elovade.com".replace(/^(http).*?/, 'ws') + '/api/ws/';
          ws = new __WEBPACK_IMPORTED_MODULE_9__helpers_websocket__["a" /* default */](url);
          _context3.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* fork */])(startAndListenWS, ws);

        case 6:
          _context3.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_0_redux_saga_effects__["d" /* fork */])(sendMessagesToWS, ws);

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/***/ }),

/***/ "./state/selectors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRouteType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getRoutesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentRecordId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLoggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentRoute; });
/* unused harmony export checkListParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getListParams; });

var getLocation = function getLocation(state) {
  return state.location;
};
var getRouteType = function getRouteType(state) {
  return state.location.type;
};
var getRoutesMap = function getRoutesMap(state) {
  return state.location.routesMap;
};
var getCurrentRecordId = function getCurrentRecordId(state) {
  return state.location.payload.id;
};

var getLoggedUser = function getLoggedUser(state) {
  return state.auth;
};

var getCurrentRoute = function getCurrentRoute(state) {
  return state.location.routesMap[state.location.type];
};

var checkListParams = function checkListParams(resource) {
  return function (state) {
    return !!Object.keys(state.rest[resource].list.params).length;
  };
};

var getListParams = function getListParams(resource) {
  return function (state) {
    var curr = state.rest[resource].list.params;

    var out = [resource, {
      perPage: curr.perPage,
      page: curr.page
    }, {
      field: curr.sort,
      order: curr.order
    }, curr.filter];
    return out;
  };
};

/***/ }),

/***/ "./state/static/components.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");


var defaultState = {
  sort: 'title',
  order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */],
  page: 1,
  perPage: 10,
  filter: {}
};

/* harmony default export */ __webpack_exports__["a"] = (defaultState);

/***/ }),

/***/ "./state/static/contacts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  sort: 'full_name',
  order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */],
  page: 1,
  perPage: 10,
  filter: {}
});

/***/ }),

/***/ "./state/static/newsletters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  sort: 'created_at',
  order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["e" /* SORT_DESC */],
  page: 1,
  perPage: 10,
  filter: {}
});

/***/ }),

/***/ "./state/static/products.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  sort: 'title',
  order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */],
  page: 1,
  perPage: 10,
  filter: {}
});

/***/ }),

/***/ "./state/static/users.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_types_query__ = __webpack_require__("./state/types/query.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  sort: 'full_name',
  order: __WEBPACK_IMPORTED_MODULE_0__state_types_query__["d" /* SORT_ASC */],
  page: 1,
  perPage: 10,
  filter: {}
});

/***/ }),

/***/ "./state/store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__("../node_modules/redux-saga/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_sagas_root__ = __webpack_require__("./state/sagas/root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_enhancers__ = __webpack_require__("./state/enhancers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_reducers__ = __webpack_require__("./state/reducers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_routes__ = __webpack_require__("./state/routes.js");








var sagasMiddleware = Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* default */])();

var composeMiddlewares = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_5__state_routes__["c" /* middleware */], sagasMiddleware);

var composeEnhancers = "production" !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || __WEBPACK_IMPORTED_MODULE_0_redux__["compose"];

var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_4__state_reducers__["a" /* resettableAppReducer */], composeEnhancers(__WEBPACK_IMPORTED_MODULE_5__state_routes__["a" /* enhancer */], Object(__WEBPACK_IMPORTED_MODULE_3__state_enhancers__["a" /* persistState */])(['auth'], 'data'), composeMiddlewares));

sagasMiddleware.run(Object(__WEBPACK_IMPORTED_MODULE_2__state_sagas_root__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__state_routes__["b" /* initialDispatch */], __WEBPACK_IMPORTED_MODULE_5__state_routes__["e" /* routesMap */]));

/***/ }),

/***/ "./state/types/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_PASSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGOUT; });
var LOGIN = 'auth/LOGIN';
var LOGIN_LOADING = 'auth/LOGIN_LOADING';
var LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
var LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
var CHECK = 'auth/CHECK';
var CHECK_PASSED = 'auth/CHECK_PASSED';
var LOGOUT = 'auth/LOGOUT';

/***/ }),

/***/ "./state/types/data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_LIST; });
/* unused harmony export GET_LIST_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_ONE; });
/* unused harmony export GET_ONE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_ONE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_ONE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE; });
/* unused harmony export CREATE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE; });
/* unused harmony export UPDATE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE; });
/* unused harmony export DELETE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_MANY; });
/* unused harmony export GET_MANY_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_MANY_FAILURE; });
/* unused harmony export GET_MANY_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_SIMPLE; });
/* unused harmony export GET_SIMPLE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_SIMPLE_FAILURE; });
/* unused harmony export GET_SIMPLE_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_MATCHING; });
/* unused harmony export GET_MATCHING_LOADING */
/* unused harmony export GET_MATCHING_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_MATCHING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_MANY_REFERENCE; });
/* unused harmony export GET_MANY_REFERENCE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_MANY_REFERENCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_MANY_REFERENCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DOWNLOAD_TEMPLATE; });
var GET_LIST = 'crud/GET_LIST';
var GET_LIST_LOADING = 'crud/GET_LIST_LOADING';
var GET_LIST_FAILURE = 'crud/GET_LIST_FAILURE';
var GET_LIST_SUCCESS = 'crud/GET_LIST_SUCCESS';

var GET_ONE = 'crud/GET_ONE';
var GET_ONE_LOADING = 'crud/GET_ONE_LOADING';
var GET_ONE_FAILURE = 'crud/GET_ONE_FAILURE';
var GET_ONE_SUCCESS = 'crud/GET_ONE_SUCCESS';

var CREATE = 'crud/CREATE';
var CREATE_LOADING = 'crud/CREATE_LOADING';
var CREATE_FAILURE = 'crud/CREATE_FAILURE';
var CREATE_SUCCESS = 'crud/CREATE_SUCCESS';

var UPDATE = 'crud/UPDATE';
var UPDATE_LOADING = 'crud/UPDATE_LOADING';
var UPDATE_FAILURE = 'crud/UPDATE_FAILURE';
var UPDATE_SUCCESS = 'crud/UPDATE_SUCCESS';

var DELETE = 'crud/DELETE';
var DELETE_LOADING = 'crud/DELETE_LOADING';
var DELETE_FAILURE = 'crud/DELETE_FAILURE';
var DELETE_SUCCESS = 'crud/DELETE_SUCCESS';

var GET_MANY = 'crud/GET_MANY';
var GET_MANY_LOADING = 'crud/GET_MANY_LOADING';
var GET_MANY_FAILURE = 'crud/GET_MANY_FAILURE';
var GET_MANY_SUCCESS = 'crud/GET_MANY_SUCCESS';

var GET_SIMPLE = 'crud/GET_SIMPLE';
var GET_SIMPLE_LOADING = 'crud/GET_SIMPLE_LOADING';
var GET_SIMPLE_FAILURE = 'crud/GET_SIMPLE_FAILURE';
var GET_SIMPLE_SUCCESS = 'crud/GET_SIMPLE_SUCCESS';

var GET_MATCHING = 'crud/GET_MATCHING';
var GET_MATCHING_LOADING = 'crud/GET_MATCHING_LOADING';
var GET_MATCHING_FAILURE = 'crud/GET_MATCHING_FAILURE';
var GET_MATCHING_SUCCESS = 'crud/GET_MATCHING_SUCCESS';

var GET_MANY_REFERENCE = 'crud/GET_MANY_REFERENCE';
var GET_MANY_REFERENCE_LOADING = 'crud/GET_MANY_REFERENCE_LOADING';
var GET_MANY_REFERENCE_FAILURE = 'crud/GET_MANY_REFERENCE_FAILURE';
var GET_MANY_REFERENCE_SUCCESS = 'crud/GET_MANY_REFERENCE_SUCCESS';

var CHECK_TEMPLATE = 'ajax/CHECK_TEMPLATE';
var DOWNLOAD_TEMPLATE = 'ajax/DOWNLOAD_TEMPLATE';

/***/ }),

/***/ "./state/types/defaultLabel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOIMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RTE; });
var BUTTON = 'BUTTON';
var HEADER = 'Header';
var NOIMAGE = 'Add image in the edit box to the right.';
var NOITEMS = 'No items added yet. Please use the right edit bar to add elements';
var RTE = '<p class="no-items">Start writing here.</p>';

/***/ }),

/***/ "./state/types/editing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDITING_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDITING_ENDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFY_SERVER_EDITING_ENDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDIT_COMMITTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_DISCONNECTED; });
var EDITING_STARTED = 'ui/EDITING_STARTED';
var EDITING_ENDED = 'ui/EDITING_ENDED';
var NOTIFY_SERVER_EDITING_ENDED = 'ui/NOTIFY_SERVER_EDITING_ENDED';
var EDIT_COMMITTED = 'ui/EDIT_COMMITTED';
var USER_DISCONNECTED = 'ui/USER_DISCONNECTED';

/***/ }),

/***/ "./state/types/fetch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
var START = 'fetch/START';
var END = 'fetch/END';
var ERROR = 'fetch/ERROR';
var CANCEL = 'fetch/CANCEL';

/***/ }),

/***/ "./state/types/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_LIST_PARAMS; });
var CHANGE_LIST_PARAMS = 'crud/CHANGE_LIST_PARAMS';

/***/ }),

/***/ "./state/types/locale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_LOCALE; });
var CHANGE_LOCALE = 'locale/CHANGE';

/***/ }),

/***/ "./state/types/modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_MODAL; });
var SHOW_MODAL = 'modal/SHOW';
var HIDE_MODAL = 'modal/HIDE';

/***/ }),

/***/ "./state/types/notification.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_NOTIFICATION; });
var SHOW_NOTIFICATION = 'ui/SHOW_NOTIFICATION';
var HIDE_NOTIFICATION = 'ui/HIDE_NOTIFICATION';

/***/ }),

/***/ "./state/types/pageflip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STOP; });
var STOP = 'pageflip/STOP';

/***/ }),

/***/ "./state/types/query.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SORT_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SORT_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_FILTER; });
var SET_SORT = 'query/SET_SORT';
var SORT_ASC = 'query/ASC';
var SORT_DESC = 'query/DESC';

var SET_PAGE = 'query/SET_PAGE';

var SET_FILTER = 'query/SET_FILTER';

/***/ }),

/***/ "./state/types/routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ROUTE_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ROUTE_NEWSLETTERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ROUTE_NEWSLETTERS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTE_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ROUTE_COMPONENTS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUTE_COMPONENTS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ROUTE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ROUTE_PRODUCTS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ROUTE_PRODUCTS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ROUTE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ROUTE_USERS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ROUTE_USERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ROUTE_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ROUTE_CONTACTS_NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROUTE_CONTACTS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROUTE_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ROUTE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ROUTE_REGISTER; });

var ROUTE_DASHBOARD = 'route/ROUTE_DASHBOARD';
var ROUTE_NEWSLETTERS_EDIT = 'route/ROUTE_NEWSLETTERS_EDIT';
var ROUTE_NEWSLETTERS_NEW = 'route/ROUTE_NEWSLETTERS_NEW';

var ROUTE_COMPONENTS = 'route/ROUTE_COMPONENTS';
var ROUTE_COMPONENTS_NEW = 'route/ROUTE_COMPONENTS_NEW';
var ROUTE_COMPONENTS_EDIT = 'route/ROUTE_COMPONENTS_EDIT';

var ROUTE_PRODUCTS = 'route/ROUTE_PRODUCTS';
var ROUTE_PRODUCTS_NEW = 'route/ROUTE_PRODUCTS_NEW';
var ROUTE_PRODUCTS_EDIT = 'route/ROUTE_PRODUCTS_EDIT';

var ROUTE_USERS = 'route/ROUTE_USERS';
var ROUTE_USERS_NEW = 'route/ROUTE_USERS_NEW';
var ROUTE_USERS_EDIT = 'route/ROUTE_USERS_EDIT';

var ROUTE_CONTACTS = 'route/ROUTE_CONTACTS';
var ROUTE_CONTACTS_NEW = 'route/ROUTE_CONTACTS_NEW';
var ROUTE_CONTACTS_EDIT = 'route/ROUTE_CONTACTS_EDIT';

var ROUTE_LOGIN = 'route/ROUTE_LOGIN';
var ROUTE_RESET = 'route/ROUTE_RESET';
var ROUTE_REGISTER = 'route/ROUTE_REGISTER';

/***/ }),

/***/ "./state/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAllowed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routesMap__ = __webpack_require__("./state/routesMap.js");


var isAllowed = function isAllowed(type, state) {
  var role = __WEBPACK_IMPORTED_MODULE_0__routesMap__["a" /* default */][type] && __WEBPACK_IMPORTED_MODULE_0__routesMap__["a" /* default */][type].role;
  if (!role) return true;

  var user = userFromState(state);

  if (!user) return false;

  return true;
};

var userFromState = function userFromState(_ref) {
  var userObj = _ref.auth.user;
  return userObj;
};

/***/ }),

/***/ "./styles/fonts.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./styles/mobi/theme.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"switcher":"switcher","next1":"next1","enter":"enter","enter-active":"enter-active","leave":"leave","leave-active":"leave-active","back2":"back2","next":"next","back":"back","app":"app","body":"body","wrap":"wrap","type-status":"type-status","type-processed":"type-processed","type-in-progress":"type-in-progress","button-link":"button-link","contact-col":"contact-col flex-middle","avatar":"avatar","product-col":"product-col flex-middle","user-col":"user-col flex-middle","drop-wrapper":"drop-wrapper","drop-zone":"drop-zone","square-box":"square-box flex-cell","edit-user":"edit-user","colored-card":"colored-card","form-group":"form-group","form-control-feedback":"form-control-feedback","newsletter-edit":"newsletter-edit","login-box":"login-box","card-body":"card-body","with-header":"with-header","forgot-button":"forgot-button","card-dark-header":"card-dark-header","card-header":"card-header","product-logo-label":"product-logo-label","form":"form","product":"product","center-vertical":"center-vertical","v-padding-large":"v-padding-large","t-padding-large":"t-padding-large","color-field":"color-field","app-bar-inverse":"app-bar-inverse","app-bar-inverse-item":"app-bar-inverse-item","app-bar-inverse-active":"app-bar-inverse-active","add-component":"add-component","block-card":"block-card","container":"container","card":"card","block-active":"block-active","card-content":"card-content","block-minimized":"block-minimized","block-wraper":"block-wraper","add-icon":"add-icon","newsletter-selected":"newsletter-selected","newsletter-edit-sidebar":"newsletter-edit-sidebar","splitted":"splitted","newsletter-edit-aside":"newsletter-edit-aside","previews":"previews","button":"button","sidebar-active":"sidebar-active","sidebar-inactive":"sidebar-inactive","newsletter-edit-content":"newsletter-edit-content","with-aside":"with-aside","renderpreview":"renderpreview","infothek-preview":"infothek-preview","text-preview":"text-preview","imagetext-preview":"imagetext-preview","innerwrap":"innerwrap","akademie-preview":"akademie-preview","empty-image":"empty-image","narrow-container":"narrow-container","new-content":"new-content","new-content-selected":"new-content-selected","lock-icon":"lock-icon","app-bar":"app-bar","app-bar-nav":"app-bar-nav","app-bar-nav-item":"app-bar-nav-item","app-bar-active":"app-bar-active","app-bar-logo":"app-bar-logo","app-bar-right":"app-bar-right","app-bar-user":"app-bar-user","app-bar-underline":"app-bar-underline","app-bar-title":"app-bar-title","app-bar-left-icon":"app-bar-left-icon","app-bar-right-icon":"app-bar-right-icon","dropdown":"dropdown","dropdown-spacer":"dropdown-spacer","dropdown-link":"dropdown-link","active":"active","container-wider":"container-wider","container-fluid":"container-fluid","breadcrumb":"breadcrumb container","breadcrumb-item":"breadcrumb-item","breadcrumb-active":"breadcrumb-active","breadcrumb-actions":"breadcrumb-actions","crumb-enter":"crumb-enter","crumb-enter-active":"crumb-enter-active","crumb-leave":"crumb-leave","crumb-leave-active":"crumb-leave-active","pagination":"pagination","page-item":"page-item","page-link":"page-link","disabled":"disabled","color-pale-gray-two":"color-pale-gray-two","without-header":"without-header","card-title":"card-title","card-subtitle":"card-subtitle","card-text":"card-text","card-link":"card-link","cardLink":"cardLink","card-footer":"card-footer","text-success":"text-success","text-warning":"text-warning","text-inverse":"text-inverse","bg-primary":"bg-primary","bg-success":"bg-success","bg-warning":"bg-warning","bg-danger":"bg-danger","bg-inverse":"bg-inverse","bg-primary-faded":"bg-primary-faded","bg-success-faded":"bg-success-faded","bg-warning-faded":"bg-warning-faded","bg-danger-faded":"bg-danger-faded","bg-faded":"bg-faded","flex":"flex","flex-grow":"flex-grow","flex-j-center":"flex-j-center","flex-row":"flex-row","flex-left":"flex-left","flex-center":"flex-center","flex-right":"flex-right","flex-top":"flex-top","flex-middle":"flex-middle","flex-bottom":"flex-bottom","flex-vertical":"flex-vertical","gutter":"gutter","flex-cell-10":"flex-cell-10","flex-cell-20":"flex-cell-20","flex-cell-25":"flex-cell-25","flex-cell-33":"flex-cell-33","flex-cell-40":"flex-cell-40","flex-cell-50":"flex-cell-50","flex-cell-60":"flex-cell-60","flex-cell-66":"flex-cell-66","flex-cell-75":"flex-cell-75","flex-cell-80":"flex-cell-80","flex-cell-90":"flex-cell-90","gutter-large":"gutter-large","__row-gutter-large-margin-bottom-double":"__row-gutter-large-margin-bottom-double","flex-cell":"flex-cell","flex-column":"flex-column","flex-cell-30":"flex-cell-30","flex-wrap":"flex-wrap","top-margin-0":"top-margin-0","top-margin-half":"top-margin-half","top-margin":"top-margin","top-margin-24":"top-margin-24","top-margin-large":"top-margin-large","bottom-margin-0":"bottom-margin-0","bottom-margin":"bottom-margin","bottom-margin-double":"bottom-margin-double","bottom-margin-large":"bottom-margin-large","left-margin-auto":"left-margin-auto","right-margin":"right-margin","right-margin-8":"right-margin-8","right-margin-24":"right-margin-24","h-padding":"h-padding","h-padding-large":"h-padding-large","padding-top-80":"padding-top-80","margin-bottom-48":"margin-bottom-48","float-left":"float-left","float-right":"float-right","margin-0-auto":"margin-0-auto","va-middle":"va-middle","position-relative":"position-relative","hide-on-mobile":"hide-on-mobile","show-on-mobile":"show-on-mobile","table":"table","without-head":"without-head","th":"th","td":"td","tr":"tr","sortable":"sortable","sorted":"sorted","column-simple":"column-simple","button-focus":"button-focus","button-disabled":"button-disabled","nohover":"nohover","button-active":"button-active","button-clean":"button-clean","button-primary":"button-primary","button-inverted":"button-inverted","button-secondary":"button-secondary","button-danger":"button-danger","button-success":"button-success","button-outline":"button-outline","button-block":"button-block","button-ripple":"button-ripple","button-group":"button-group","vertical":"vertical","button-horizontal":"button-horizontal","focus":"focus","has-danger":"has-danger","checkbox-inner":"checkbox-inner","checkbox-input":"checkbox-input","scroll-view":"scroll-view","no-scroll":"no-scroll","text-bold":"text-bold","text-left":"text-left","text-center":"text-center","text-right":"text-right","text-muted":"text-muted","text-primary":"text-primary","text-danger":"text-danger","text-small":"text-small","text-mono":"text-mono","tooltip-wrapper":"tooltip-wrapper","tooltip":"tooltip","tooltip-slide":"tooltip-slide","tooltip-content":"tooltip-content","tooltip-arrow":"tooltip-arrow","tooltip-gap":"tooltip-gap","notification":"notification","notification-visible":"notification-visible","notification-large":"notification-large","notification-label":"notification-label","notification-button":"notification-button","modal":"modal","modal-scroll":"modal-scroll","modal-content":"modal-content","modal-small":"modal-small","modal-medium":"modal-medium","modal-large":"modal-large","modal-header":"modal-header","modal-close":"modal-close","modal-body":"modal-body","modal-footer":"modal-footer","modal-shadow":"modal-shadow","modal-enter":"modal-enter","modal-enter-active":"modal-enter-active","scroll":"scroll","content":"content","modal-leave":"modal-leave","modal-leave-active":"modal-leave-active","avatar-square":"avatar-square","avatar-image":"avatar-image","avatar-letter":"avatar-letter","bordered-box":"bordered-box","divider":"divider","inset":"inset","autocomplete":"autocomplete","suggestions":"suggestions","values":"values","value":"value","suggestions-container":"suggestions-container","up":"up","suggestion":"suggestion","input-calendar":"input-calendar","input-calendar-wrapper":"input-calendar-wrapper","days":"days","months":"months","years":"years","cell":"cell","datepicker-table":"datepicker-table","current":"current","day":"day","prev":"prev","month":"month","year":"year","days-title":"days-title","years-view":"years-view","navigation-title":"navigation-title","today-btn":"today-btn","navigation-wrapper":"navigation-wrapper","dropdown-menu":"dropdown-menu","dropdown-toggle":"dropdown-toggle","dropdown-menu-items":"dropdown-menu-items","dropdown-items-upwards":"dropdown-items-upwards","dropdown-menu-item":"dropdown-menu-item","dropdown-menu-separator":"dropdown-menu-separator","dropdown-menu-item-active":"dropdown-menu-item-active","dropdown-opened":"dropdown-opened","dropdown-menu-inverse":"dropdown-menu-inverse","dropdown-items-container":"dropdown-items-container","dropdown-enter":"dropdown-enter","dropdown-enter-active":"dropdown-enter-active","dropdown-leave":"dropdown-leave","dropdown-leave-active":"dropdown-leave-active"};

/***/ }),

/***/ "./styles/plugin/medium-rte.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"medium-toolbar-arrow-over":"medium-toolbar-arrow-over","medium-toolbar-arrow-under":"medium-toolbar-arrow-under","medium-editor-toolbar":"medium-editor-toolbar","medium-editor-button-first":"medium-editor-button-first","medium-editor-button-last":"medium-editor-button-last","medium-editor-button-active":"medium-editor-button-active","medium-editor-toolbar-form":"medium-editor-toolbar-form","medium-editor-toolbar-input":"medium-editor-toolbar-input","medium-editor-toolbar-anchor-preview":"medium-editor-toolbar-anchor-preview","medium-editor-placeholder":"medium-editor-placeholder"};

/***/ }),

/***/ "./ui/AppBar/AppBar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_NavLink__ = __webpack_require__("./ui/NavLink/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Avatar_Avatar__ = __webpack_require__("./ui/Avatar/Avatar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ClickAwayListener__ = __webpack_require__("./ui/ClickAwayListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_Mail__ = __webpack_require__("./icons/Mail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_svg_logo_svg__ = __webpack_require__("./media/svg/logo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_svg_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_auth__ = __webpack_require__("./state/actions/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_types_routes__ = __webpack_require__("./state/types/routes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__media_svg_logo_svg___default.a, { width: '32', height: '32' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: 'dropdown-spacer' });

var AppBar = function (_React$Component) {
  _inherits(AppBar, _React$Component);

  function AppBar() {
    var _temp, _this, _ret;

    _classCallCheck(this, AppBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      userMenuOpen: false
    }, _this.logout = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_auth__["d" /* userLogout */])());
    }, _this.openUserMenu = function (open) {
      _this.setState({ userMenuOpen: !_this.state.userMenuOpen });
    }, _this.clickAwayMenu = function () {
      if (_this.state.userMenuOpen) {
        _this.openUserMenu(false);
      }
    }, _this.gotoBuild = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__state_actions_routes__["g" /* routeNewslettersNew */])());
    }, _this.gotoAccount = function () {
      _this.setState({ userMenuOpen: false });
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__state_actions_routes__["a" /* goToPage */])(__WEBPACK_IMPORTED_MODULE_11__state_types_routes__["q" /* ROUTE_USERS_EDIT */], null, { id: _this.props.user.id }));
    }, _this.getInitials = function (string) {
      var names = string.split(' ');
      var initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      } else {
        initials += names[0].substring(1, 2).toUpperCase();
      }
      return initials;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AppBar.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (this.state.userMenuOpen !== prevState.userMenuOpen) {
      requestAnimationFrame(function () {
        setTimeout(function () {
          _this2.userMenuNode.classList.toggle('active');
        }, 0);
      });
    }
  };

  AppBar.prototype.animateUnderLine = function animateUnderLine() {
    var _this3 = this;

    setTimeout(function () {
      if (!_this3.navigationNode) {
        return;
      }
      var nav = _this3.navigationNode.getBoundingClientRect();
      var currentName = _this3.props.routesMap[_this3.props.currentRouteType].name;
      var node = _this3.navigationNode.querySelector('[data-title="' + currentName + '"]');
      var label = void 0;
      if (node) {
        label = node.getBoundingClientRect();
      } else {
        currentName = _this3.props.routesMap[_this3.props.routesMap[_this3.props.currentRouteType].parent].name;
        node = _this3.navigationNode.querySelector('[data-title="' + currentName + '"]');
        if (!node) {
          return;
        }
        label = node.getBoundingClientRect();
      }
      _this3.underlineNode.style.top = nav.height + 'px';
      _this3.underlineNode.style.left = label.left - nav.left + 'px';
      _this3.underlineNode.style.width = label.width + 'px';
    }, 0);
  };

  AppBar.prototype.render = function render() {
    var _this4 = this;

    var _props = this.props,
        theme = _props.theme,
        currentRouteType = _props.currentRouteType,
        user = _props.user,
        props = _objectWithoutProperties(_props, ['theme', 'currentRouteType', 'user']);

    var routes = Object.keys(props.routesMap);
    if (this.currentRouteType !== currentRouteType) {
      this.currentRouteType = this.props.currentRouteType;
      this.animateUnderLine();
    }
    var initials = user ? this.getInitials(user.full_name) : '';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        {
          className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav'),
          role: 'tablist',
          ref: function ref(node) {
            _this4.navigationNode = node;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav-item', 'app-bar-logo') },
          _ref
        ),
        routes.map(function (route, idx) {
          return props.routesMap[route].path && !props.routesMap[route].hidden && !props.routesMap[route].notInMenu ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ui_NavLink__["a" /* default */],
            _extends({
              key: route,
              activeClassName: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav-item', 'app-bar-active'),
              className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav-item'),
              to: { type: route },
              'data-title': props.routesMap[route].name
            }, props.routesMap[route].resource && {
              includeQuery: props.routesMap[route].resource
            }, props.routesMap[route].path === '/' && { exact: 'exact' }),
            props.routesMap[route].name
          ) : null;
        }, this),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          {
            className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav-item', 'app-bar-right', 'left-margin-auto')
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__ui_Button_Button__["a" /* default */],
            { theme: theme, classes: ['ripple', 'success'], onClick: this.gotoBuild },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__icons_Mail__["a" /* default */], { size: '1.5em', style: { marginRight: '1em' } }),
            'Build newsletter'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'app-bar-nav-item', 'app-bar-user') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_ClickAwayListener__["a" /* default */],
            { onClickAway: this.clickAwayMenu },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                ref: function ref(node) {
                  _this4.userMenuNode = node;
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__ui_Button_Button__["a" /* default */],
                { theme: theme, classes: 'clean', onClick: this.openUserMenu },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__ui_Avatar_Avatar__["a" /* default */],
                  { theme: theme, cover: true },
                  initials
                )
              ),
              this.state.userMenuOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_classNames__["a" /* default */])(theme, 'dropdown') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  'Welcome, ',
                  user.full_name,
                  ' \uD83D\uDE0A'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: theme['dropdown-link'], onClick: this.gotoAccount },
                  'Edit profile'
                ),
                _ref2,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { className: theme['dropdown-link'], onClick: this.logout },
                  'Logout'
                )
              ) : null
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
        ref: function ref(node) {
          _this4.underlineNode = node;
        },
        className: theme['app-bar-underline']
      })
    );
  };

  return AppBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AppBar.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (AppBar);

/***/ }),

/***/ "./ui/AppBar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__("./ui/AppBar/AppBar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppBar__["a"]; });



/***/ }),

/***/ "./ui/Avatar/Avatar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Avatar = function Avatar(_ref) {
  var _classnames;

  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      square = _ref.square,
      cover = _ref.cover,
      image = _ref.image,
      color = _ref.color,
      letter = _ref.letter,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'square', 'cover', 'image', 'color', 'letter', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme.avatar, (_classnames = {}, _classnames[theme['avatar-square']] = square, _classnames[theme['avatar-letter']] = letter, _classnames))
    }, other, color && { style: { backgroundColor: '#' + color, color: '#fff' } }),
    children && children.length ? children : cover && typeof image === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
      'aria-label': alt,
      className: theme['avatar-image'],
      style: { backgroundImage: 'url(' + image + ')' }
    }) : !cover && typeof image === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: alt, className: theme['avatar-image'], src: image }) : image
  );
};

Avatar.propTypes = {
  alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Avatar.defaultProps = {
  alt: '',
  cover: false
};

/* harmony default export */ __webpack_exports__["a"] = (Avatar);

/***/ }),

/***/ "./ui/Avatar/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__("./ui/Avatar/Avatar.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Avatar__["a"]; });



/***/ }),

/***/ "./ui/Blocks/Akademie.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__ = __webpack_require__("./ui/RTE/Medium.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AkademieBlock = function (_Component) {
  _inherits(AkademieBlock, _Component);

  function AkademieBlock() {
    _classCallCheck(this, AkademieBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AkademieBlock.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        active = _props.active,
        _onChange = _props.onChange,
        theme = _props.theme;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'akademie-preview') },
      item.data && item.data.length ? item.data.map(function (element, indx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
            tagName: 'h4',
            html: element.header || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            textual: true,
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            onChange: function onChange(e, value) {
              return _onChange(item, [indx, 'header'], value);
            }
          }),
          active ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__["a" /* default */], {
            id: 'text',
            name: 'text',
            key: 'rte' + item.id,
            value: element.text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            onChange: function onChange(value) {
              return _onChange(item, [indx, 'text'], value);
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: element.text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */] } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'button', 'button-outline'),
              style: { marginTop: '24px', padding: '16px' }
            },
            element.buttontext || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["a" /* BUTTON */]
          )
        );
      }, this) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: theme['no-items'] },
        __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["d" /* NOITEMS */]
      )
    );
  };

  return AkademieBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AkademieBlock.displayName = 'Card / Akademie';
AkademieBlock.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (AkademieBlock);

/***/ }),

/***/ "./ui/Blocks/AkademieCustom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__ = __webpack_require__("./ui/RTE/Medium.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AkademieCustom = function (_Component) {
  _inherits(AkademieCustom, _Component);

  function AkademieCustom() {
    _classCallCheck(this, AkademieCustom);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AkademieCustom.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        theme = _props.theme,
        _onChange = _props.onChange;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'akademie-preview') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
        tagName: 'h1',
        key: 'mainHeader',
        html: item.mainHeader || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
        textual: true,
        selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
        onChange: function onChange(e, value) {
          return _onChange(item, 'mainHeader', value);
        }
      }),
      item.data && item.data.length ? item.data.map(function (element, indx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
            tagName: 'h4',
            html: element.header || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            textual: true,
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            onChange: function onChange(e, value) {
              return _onChange(item, [indx, 'header'], value);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__["a" /* default */], {
            id: 'text',
            name: 'text',
            key: 'rte' + item.id,
            value: element.text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            onChange: function onChange(value) {
              return _onChange(item, [indx, 'text'], value);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'button', 'button-outline'),
              style: { marginTop: '24px', padding: '16px' }
            },
            element.buttontext || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["a" /* BUTTON */]
          )
        );
      }, this) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: theme['no-items'] },
        __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["d" /* NOITEMS */]
      )
    );
  };

  return AkademieCustom;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AkademieCustom.displayName = 'Card / Akademie custom';
AkademieCustom.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (AkademieCustom);

/***/ }),

/***/ "./ui/Blocks/AkademieHeader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__ = __webpack_require__("./ui/RTE/Medium.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["c" /* NOIMAGE */]
);

var TextBlock = function (_Component) {
  _inherits(TextBlock, _Component);

  function TextBlock() {
    _classCallCheck(this, TextBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TextBlock.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        active = _props.active,
        theme = _props.theme,
        _onChange = _props.onChange,
        newsletterId = _props.newsletterId;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'akademie-preview') },
      item.image ? _typeof(item.image) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.image.src, alt: '' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        src: 'newsletters/' + String(newsletterId).padStart(4, '0') + '/' + item.image,
        alt: ''
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['empty-image'] },
        _ref
      ),
      item.data && item.data.length ? item.data.map(function (element, indx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
            tagName: 'h4',
            html: element.header || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            textual: true,
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
            onChange: function onChange(e, value) {
              return _onChange(item, [indx, 'header'], value);
            }
          }),
          active ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__["a" /* default */], {
            id: 'text',
            name: 'text',
            key: 'rte' + item.id,
            value: element.text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
            onChange: function onChange(value) {
              return _onChange(item, [indx, 'text'], value);
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: element.text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */] } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'button', 'button-outline'),
              style: { marginTop: '24px', padding: '16px' }
            },
            element.buttontext || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["a" /* BUTTON */]
          )
        );
      }, this) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: theme['no-items'] },
        __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["d" /* NOITEMS */]
      )
    );
  };

  return TextBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextBlock.displayName = 'Card / Akademie + header';
TextBlock.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (TextBlock);

/***/ }),

/***/ "./ui/Blocks/Block.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Blocks_Text__ = __webpack_require__("./ui/Blocks/Text.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Blocks_Image__ = __webpack_require__("./ui/Blocks/Image.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Blocks_ImageText__ = __webpack_require__("./ui/Blocks/ImageText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Blocks_Infothek__ = __webpack_require__("./ui/Blocks/Infothek.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Blocks_InfothekIcons__ = __webpack_require__("./ui/Blocks/InfothekIcons.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Blocks_Akademie__ = __webpack_require__("./ui/Blocks/Akademie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Blocks_AkademieCustom__ = __webpack_require__("./ui/Blocks/AkademieCustom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Blocks_AkademieHeader__ = __webpack_require__("./ui/Blocks/AkademieHeader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_ArrowDropDown__ = __webpack_require__("./icons/ArrowDropDown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_RemoveCircle__ = __webpack_require__("./icons/RemoveCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_Add__ = __webpack_require__("./icons/Add.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  'Wrong type, data error!'
);

var Block = function (_Component) {
  _inherits(Block, _Component);

  function Block() {
    var _temp, _this, _ret;

    _classCallCheck(this, Block);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      minimized: false
    }, _this.minimizeToggle = function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.setState({ minimized: !_this.state.minimized });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Block.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        item = _props.item,
        header = _props.header,
        onRemove = _props.onRemove,
        onDuplicate = _props.onDuplicate,
        _onClick = _props.onClick,
        handle = _props.handle,
        rest = _objectWithoutProperties(_props, ['theme', 'item', 'header', 'onRemove', 'onDuplicate', 'onClick', 'handle']);

    var Component = item.type === 'Card / Text only' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_Blocks_Text__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Text only + CTA' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_Blocks_Text__["a" /* default */], _extends({ item: item, theme: theme, cta: true }, rest)) : item.type === 'Card / Image' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Blocks_Image__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Image + Text' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Blocks_ImageText__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Image + Text (no CTA)' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Blocks_ImageText__["a" /* default */], _extends({ item: item, theme: theme, cta: false }, rest)) : item.type === 'Card / Akademie' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Blocks_Akademie__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Akademie custom' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Blocks_AkademieCustom__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Akademie + header' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ui_Blocks_AkademieHeader__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Infothek' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Blocks_Infothek__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : item.type === 'Card / Infothek + Icons' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ui_Blocks_InfothekIcons__["a" /* default */], _extends({ item: item, theme: theme }, rest)) : _ref;
    var displayName = this.props.item.type || Component.type && Component.type.displayName || 'Error';

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        onClick: function onClick(e) {
          return _onClick(item, e);
        },
        className: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_classNames__["a" /* default */])(theme, 'card', 'block-card', {
          'block-minimized': this.state.minimized,
          'block-active': rest.active
        }),
        'data-id': item.id
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({ className: theme['card-header'] }, handle),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_ArrowDropDown__["a" /* default */], { size: '1em', onClick: this.minimizeToggle }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          displayName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['float-right'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icons_RemoveCircle__["a" /* default */], { size: '2.5em', onClick: function onClick(e) {
              return onRemove(e, item.id);
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__icons_Add__["a" /* default */], { size: '2.5em', onClick: function onClick(e) {
              return onDuplicate(item.id);
            } })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: Object(__WEBPACK_IMPORTED_MODULE_1__helpers_classNames__["a" /* default */])(theme, 'card-body', {
            'with-header': header,
            'without-header': !header
          })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['card-content'] },
          Component
        )
      )
    );
  };

  return Block;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Block);

/***/ }),

/***/ "./ui/Blocks/Edit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("../node_modules/lodash.debounce/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectField__ = __webpack_require__("./ui/Blocks/SelectField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_linkTypes__ = __webpack_require__("./helpers/linkTypes.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var cap = function cap(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  'Image'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'p',
  null,
  'Drop your image here'
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title' });

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  'Image'
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'p',
  null,
  'Drop your image here'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title' });

var _ref7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  'Image'
);

var _ref8 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'p',
  null,
  'Drop your image here'
);

var _ref9 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title' });

var _ref10 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', {
  key: '2'
});

var _ref11 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', {
  key: '1'
});

var _ref12 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  'Link type'
);

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit() {
    var _temp, _this, _ret;

    _classCallCheck(this, Edit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.debouncedChange = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function (item, type, value) {
      _this.props.onChange(item, type, value);
    }, _this.props.debounce), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Edit.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.debouncedChange) {
      this.debouncedChange.cancel();
    }
  };

  Edit.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        item = _props.item,
        newsletterId = _props.newsletterId,
        current = _props.current,
        theme = _props.theme;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'form', key: item.type + item.id },
      item.type === 'Card / Text only' || item.type === 'Card / Text only + CTA' ? item.type == 'Card / Text only + CTA' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'buttontext',
        theme: theme,
        key: 'buttontext' + item.id,
        name: 'buttontext',
        labelText: 'Button text',
        defaultValue: item.buttontext,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'buttontext', value);
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'buttonlink',
        theme: theme,
        key: 'buttonlink' + item.id,
        name: 'buttonlink',
        labelText: 'Button link',
        defaultValue: item.buttonlink,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'buttonlink', value);
        }
      })] : null : item.type == 'Card / Image' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['form-group'], key: '0'
        },
        _ref,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'relative', minHeight: '115px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__ui_Input__["b" /* ImageInput */],
            {
              id: 'image',
              theme: this.props.theme,
              source: 'image',
              label: 'Image',
              accept: 'image/*',
              key: 'img' + item.id,
              input: {
                value: item.image ? item.image.src ? item.image.src : 'newsletters/' + String(newsletterId).padStart(4, '0') + '/' + item.image : null,
                onChange: function onChange(v) {
                  return _this2.props.onChange(item, 'image', Array.isArray(v) && v[0] || null);
                }
              },
              placeholder: _ref2
            },
            _ref3
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'imageurl',
        theme: theme,
        key: 'imageurl' + item.id,
        name: 'imageurl',
        labelText: 'Image URL',
        defaultValue: item.imageurl,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'imageurl', value);
        }
      })] : item.type == 'Card / Image + Text' || item.type == 'Card / Image + Text (no CTA)' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['form-group'], key: '0'
        },
        _ref4,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'relative', minHeight: '115px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__ui_Input__["b" /* ImageInput */],
            {
              id: 'image',
              theme: this.props.theme,
              source: 'image',
              label: 'Image',
              accept: 'image/*',
              key: 'img' + item.id,
              cta: item.type == 'Card / Image + Text',
              input: {
                value: item.image ? item.image.src ? item.image.src : 'newsletters/' + String(newsletterId).padStart(4, '0') + '/' + item.image : null,
                onChange: function onChange(v) {
                  return _this2.props.onChange(item, 'image', Array.isArray(v) && v[0] || null);
                }
              },
              placeholder: _ref5
            },
            _ref6
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'imageurl',
        theme: theme,
        key: 'imageurl' + item.id,
        name: 'imageurl',
        labelText: 'Image URL',
        defaultValue: item.imageurl,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'imageurl', value);
        }
      }), item.type == 'Card / Image + Text' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'buttontext',
        theme: theme,
        key: 'buttontext' + item.id,
        name: 'buttontext',
        labelText: 'Button text',
        defaultValue: item.buttontext,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'buttontext', value);
        }
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'buttonlink',
        theme: theme,
        key: 'buttonlink' + item.id,
        name: 'buttonlink',
        labelText: 'Button link',
        defaultValue: item.buttonlink,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'buttonlink', value);
        }
      })] : null] : ['Card / Akademie', 'Card / Akademie custom', 'Card / Akademie + header'].includes(item.type) ? [item.type == 'Card / Akademie + header' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['form-group'], key: '0-0'
        },
        _ref7,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'relative', minHeight: '115px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__ui_Input__["b" /* ImageInput */],
            {
              id: 'image',
              theme: this.props.theme,
              source: 'image',
              label: 'Image',
              accept: 'image/*',
              key: 'img' + item.id,
              cta: item.type == 'Card / Akademie + header',
              input: {
                value: item.image ? item.image.src ? item.image.src : 'newsletters/' + String(newsletterId).padStart(4, '0') + '/' + item.image : null,
                onChange: function onChange(v) {
                  return _this2.props.onChange(item, 'image', Array.isArray(v) && v[0] || null);
                }
              },
              placeholder: _ref8
            },
            _ref9
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
        id: 'imageurl',
        theme: theme,
        key: 'imageurl' + item.id,
        name: 'imageurl',
        labelText: 'Image URL',
        defaultValue: item.imageurl,
        onChange: function onChange(e, value) {
          return _this2.props.onChange(item, 'imageurl', value);
        }
      })] : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme.splitted, key: '1'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'items',
          theme: theme,
          key: 'items-' + current + '-' + item.id,
          name: 'items',
          labelText: 'Items',
          defaultValue: item.data && item.data.length || 0,
          onChange: function onChange(e, value) {
            return _this2.props.onChange(item, 'numItems', value);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SelectField__["a" /* default */], {
          id: 'current',
          theme: theme,
          key: 'select-' + current + '-' + item.id,
          name: 'current',
          labelText: 'Edit item',
          prefix: 'Item',
          value: current | 0,
          items: item.data && item.data.length || 0,
          onChange: function onChange(e, value) {
            return _this2.props.onChange(item, 'current', value);
          }
        })
      ), _ref10, item.data && Array.isArray(item.data) && !isNaN(current) && item.data[current] ? function (element, key) {
        var _this3 = this;

        return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'buttontext',
          theme: theme,
          key: 'bt-' + current + '-' + item.id,
          name: 'buttontext',
          labelText: 'Button text',
          value: element['buttontext'] || '',
          onChange: function onChange(e, value) {
            return _this3.props.onChange(item, [current, 'buttontext'], value);
          }
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'buttonlink',
          theme: theme,
          key: 'bl-' + current + '-' + item.id,
          name: 'buttonlink',
          labelText: 'Button link',
          value: element['buttonlink'] || '',
          onChange: function onChange(e, value) {
            return _this3.props.onChange(item, [current, 'buttonlink'], value);
          }
        })];
      }.call(this, item.data[current], '3') : null] : item.type === 'Card / Infothek' || item.type === 'Card / Infothek + Icons' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme.splitted, key: '0'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'items',
          theme: theme,
          key: 'items' + item.id,
          name: 'items',
          labelText: 'Items',
          defaultValue: item.data && item.data.length || 0,
          onChange: function onChange(e, value) {
            return _this2.props.onChange(item, 'numItems', value);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SelectField__["a" /* default */], {
          id: 'current',
          theme: theme,
          key: 'current' + item.id,
          name: 'current',
          labelText: 'Edit item',
          prefix: 'Item',
          value: current | 0,
          items: item.data && item.data.length || 0,
          onChange: function onChange(e, value) {
            return _this2.props.onChange(item, 'current', value);
          }
        })
      ), _ref11, item.data && Array.isArray(item.data) && !isNaN(current) && item.data[current] ? function (element, key) {
        var _this4 = this;

        return [item.type === 'Card / Infothek + Icons' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['form-group'], key: '2-0'
          },
          _ref12,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            {
              'data-i': JSON.stringify(item),
              key: 'lt' + current + item.id,
              name: 'linktype',
              defaultValue: element.linktype,
              onChange: function onChange(e) {
                return _this4.props.onChange(item, [current, 'linktype'], e.target.value);
              }
            },
            __WEBPACK_IMPORTED_MODULE_6__helpers_linkTypes__["a" /* default */].map(function (item, indx) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: indx, value: __WEBPACK_IMPORTED_MODULE_6__helpers_linkTypes__["a" /* default */][indx] },
                cap(__WEBPACK_IMPORTED_MODULE_6__helpers_linkTypes__["a" /* default */][indx])
              );
            }, this)
          )
        ) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'linktext',
          theme: theme,
          key: 'lt' + current + item.id,
          name: 'linktext',
          labelText: 'Link text',
          defaultValue: element['linktext'],
          onChange: function onChange(e, value) {
            return _this4.props.onChange(item, [current, 'linktext'], value);
          }
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input__["c" /* InputField */], {
          id: 'linkurl',
          theme: theme,
          key: 'lu' + current + item.id,
          name: 'linkurl',
          labelText: 'Link url',
          defaultValue: element['linkurl'],
          onChange: function onChange(e, value) {
            return _this4.props.onChange(item, [current, 'linkurl'], value);
          }
        })];
      }.call(this, item.data[current], '2') : null] : null
    );
  };

  return Edit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Edit.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  debounce: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
Edit.defaultProps = {
  debounce: 500
};


/* harmony default export */ __webpack_exports__["a"] = (Edit);

/***/ }),

/***/ "./ui/Blocks/Image.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  'Add image in the edit box to the right.'
);

var TextBlock = function (_Component) {
  _inherits(TextBlock, _Component);

  function TextBlock() {
    _classCallCheck(this, TextBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TextBlock.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        theme = _props.theme,
        newsletterId = _props.newsletterId;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'imagetext-preview') },
      item.image ? _typeof(item.image) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.image.src, alt: '' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        src: "https://newsletter.elovade.com" + '/newsletters/' + String(newsletterId).padStart(4, '0') + '/' + item.image,
        alt: ''
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['empty-image'] },
        _ref
      )
    );
  };

  return TextBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextBlock.displayName = 'Card / Image';
TextBlock.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (TextBlock);

/***/ }),

/***/ "./ui/Blocks/ImageText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__ = __webpack_require__("./ui/RTE/Medium.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["c" /* NOIMAGE */]
);

var TextBlock = function (_Component) {
  _inherits(TextBlock, _Component);

  function TextBlock() {
    _classCallCheck(this, TextBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TextBlock.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        item = _props.item,
        theme = _props.theme,
        active = _props.active,
        _onChange = _props.onChange,
        newsletterId = _props.newsletterId,
        cta = _props.cta;
    var id = item.id,
        image = item.image,
        _item$text = item.text,
        text = _item$text === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */] : _item$text,
        _item$header = item.header,
        header = _item$header === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */] : _item$header,
        _item$buttontext = item.buttontext,
        buttontext = _item$buttontext === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["a" /* BUTTON */] : _item$buttontext;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'imagetext-preview') },
      image ? (typeof image === 'undefined' ? 'undefined' : _typeof(image)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: image.src, alt: '' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        src: "https://newsletter.elovade.com" + '/newsletters/' + String(newsletterId).padStart(4, '0') + '/' + image,
        alt: ''
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['empty-image'] },
        _ref
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['innerwrap'] },
        active ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
          tagName: 'h1',
          html: header,
          textual: true,
          selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
          onChange: function onChange(e, value) {
            return _onChange(_this2.props.item, 'header', value);
          },
          key: '0'
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_RTE_Medium__["a" /* default */], {
          id: 'text',
          name: 'text',
          key: 'rte' + id,
          value: text,
          selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
          onChange: function onChange(value) {
            return _onChange(_this2.props.item, 'text', value);
          }
        })] : [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          {
            key: '0'
          },
          header
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: text }, key: '1'
        })],
        cta ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'button', 'button-outline'),
            style: { marginTop: '24px', padding: '16px' }
          },
          buttontext
        ) : null
      )
    );
  };

  return TextBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextBlock.displayName = 'Card / Image + Text';
TextBlock.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
TextBlock.defaultProps = {
  cta: true
};


/* harmony default export */ __webpack_exports__["a"] = (TextBlock);

/***/ }),

/***/ "./ui/Blocks/Infothek.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Infothek = function (_Component) {
  _inherits(Infothek, _Component);

  function Infothek() {
    _classCallCheck(this, Infothek);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Infothek.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        _onChange = _props.onChange,
        theme = _props.theme;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'infothek-preview') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input_Content__["a" /* default */], {
        tagName: 'h1',
        key: 'header',
        html: item.header || __WEBPACK_IMPORTED_MODULE_4__state_types_defaultLabel__["b" /* HEADER */],
        textual: true,
        selectText: __WEBPACK_IMPORTED_MODULE_4__state_types_defaultLabel__["b" /* HEADER */],
        onChange: function onChange(e, value) {
          return _onChange(item, 'header', value);
        }
      }),
      item.data && item.data.length ? item.data.map(function (item, indx) {
        return item.linkurl && item.linktext ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: item.linkurl },
            item.linktext
          )
        ) : null;
      }, this) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: theme['no-items'], key: 'warning' },
        __WEBPACK_IMPORTED_MODULE_4__state_types_defaultLabel__["d" /* NOITEMS */]
      )
    );
  };

  return Infothek;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Infothek.displayName = 'Card / Infothek';
Infothek.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Infothek);

/***/ }),

/***/ "./ui/Blocks/InfothekIcons.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_icon_webinar_png__ = __webpack_require__("./media/icon-webinar.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_icon_webinar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media_icon_webinar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_icon_brochure_png__ = __webpack_require__("./media/icon-brochure.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_icon_brochure_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__media_icon_brochure_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_icon_download_png__ = __webpack_require__("./media/icon-download.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_icon_download_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__media_icon_download_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_icon_event_png__ = __webpack_require__("./media/icon-event.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_icon_event_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__media_icon_event_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_icon_info_png__ = __webpack_require__("./media/icon-info.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_icon_info_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_icon_info_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_icon_play_png__ = __webpack_require__("./media/icon-play.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_icon_play_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__media_icon_play_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Infothek = function (_Component) {
  _inherits(Infothek, _Component);

  function Infothek() {
    _classCallCheck(this, Infothek);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Infothek.prototype.render = function render() {
    var _props = this.props,
        item = _props.item,
        _onChange = _props.onChange,
        theme = _props.theme;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'infothek-preview') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Input_Content__["a" /* default */], {
        tagName: 'h1',
        key: 'header',
        textual: true,
        selectText: __WEBPACK_IMPORTED_MODULE_10__state_types_defaultLabel__["b" /* HEADER */],
        html: item.header || __WEBPACK_IMPORTED_MODULE_10__state_types_defaultLabel__["b" /* HEADER */],
        onChange: function onChange(e, value) {
          return _onChange(item, 'header', value);
        }
      }),
      this.props.item.data && this.props.item.data.length ? this.props.item.data.map(function (item, indx) {
        return item.linkurl && item.linktext ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: item.linkurl },
            item.linktype === 'webinar' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_4__media_icon_webinar_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }) : item.linktype === 'brochure' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_5__media_icon_brochure_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }) : item.linktype === 'download' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_6__media_icon_download_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }) : item.linktype === 'event' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_7__media_icon_event_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }) : item.linktype === 'info' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_8__media_icon_info_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __WEBPACK_IMPORTED_MODULE_9__media_icon_play_png___default.a,
              alt: '',
              style: { width: '1em', height: '1em', marginRight: '.5em' }
            }),
            item.linktext
          )
        ) : null;
      }, this) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: theme['no-items'], key: 'warning' },
        __WEBPACK_IMPORTED_MODULE_10__state_types_defaultLabel__["d" /* NOITEMS */]
      )
    );
  };

  return Infothek;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Infothek.displayName = 'Card / Infothek + Icons';
Infothek.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Infothek);

/***/ }),

/***/ "./ui/Blocks/SelectField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Form_FormGroup__ = __webpack_require__("./ui/Form/FormGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Label__ = __webpack_require__("./ui/Input/Label.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var SelectField = function SelectField(_ref) {
  var className = _ref.className,
      labelText = _ref.labelText,
      theme = _ref.theme,
      prefix = _ref.prefix,
      items = _ref.items,
      _onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ['className', 'labelText', 'theme', 'prefix', 'items', 'onChange']);

  var itemsArr = Array.from(Array(items).keys()).map(function (i) {
    return i + 1;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__ui_Form_FormGroup__["a" /* default */],
    null,
    labelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ui_Input_Label__["a" /* default */],
      { key: 'label', htmlFor: rest.id },
      labelText
    ) : null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      _extends({}, rest, { onChange: function onChange(e) {
          return _onChange(e, e.target.value);
        } }),
      itemsArr.map(function (item, indx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: indx, value: indx },
          prefix + ' ' + item
        );
      }, this)
    )
  );
};

SelectField.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_pure___default()(SelectField));

/***/ }),

/***/ "./ui/Blocks/Text.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_RTE_Medium__ = __webpack_require__("./ui/RTE/Medium.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__ = __webpack_require__("./ui/Input/Content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TextBlock = function (_Component) {
  _inherits(TextBlock, _Component);

  function TextBlock() {
    _classCallCheck(this, TextBlock);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TextBlock.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        item = _props.item,
        cta = _props.cta,
        active = _props.active,
        _onChange = _props.onChange;
    var id = item.id,
        _item$text = item.text,
        text = _item$text === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */] : _item$text,
        _item$header = item.header,
        header = _item$header === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */] : _item$header,
        _item$buttontext = item.buttontext,
        buttontext = _item$buttontext === undefined ? __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["a" /* BUTTON */] : _item$buttontext;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'renderpreview', 'text-preview') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Input_Content__["a" /* default */], {
        tagName: 'h1',
        textual: true,
        selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["b" /* HEADER */],
        html: header,
        onChange: function onChange(e, value) {
          return _onChange(item, 'header', value);
        }
      }),
      active ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'toolbar', style: { position: 'absolute', marginTop: '-21px' }, key: '0'
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_RTE_Medium__["a" /* default */], {
        id: 'text',
        name: 'text',
        key: 'rte' + id,
        selectText: __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */],
        value: text,
        onChange: function onChange(value) {
          return _onChange(item, 'text', value);
        }
      })] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: text || __WEBPACK_IMPORTED_MODULE_5__state_types_defaultLabel__["e" /* RTE */] } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['innerwrap'] },
        cta ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'button', 'button-outline'),
            style: { marginTop: '24px', padding: '16px' }
          },
          buttontext
        ) : null
      )
    );
  };

  return TextBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextBlock.displayName = 'Card / Text only';
TextBlock.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  cta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
TextBlock.defaultProps = {
  cta: false
};


/* harmony default export */ __webpack_exports__["a"] = (TextBlock);

/***/ }),

/***/ "./ui/Blocks/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Akademie__ = __webpack_require__("./ui/Blocks/Akademie.js");
/* unused harmony reexport Akademie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImageText__ = __webpack_require__("./ui/Blocks/ImageText.js");
/* unused harmony reexport ImageText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Infothek__ = __webpack_require__("./ui/Blocks/Infothek.js");
/* unused harmony reexport Infothek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Text__ = __webpack_require__("./ui/Blocks/Text.js");
/* unused harmony reexport Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Block__ = __webpack_require__("./ui/Blocks/Block.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Block__["a"]; });











/***/ }),

/***/ "./ui/Breadcrumb/Breadcrumbs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_NavLink__ = __webpack_require__("./ui/NavLink/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_TriangleRight__ = __webpack_require__("./icons/TriangleRight.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons_TriangleRight__["a" /* default */], { size: '.6em' });

var Breadcrumb = function Breadcrumb(props) {
  var getPath = function getPath(path, map) {
    var paths = [];
    var curr = path;
    var route = map[curr];

    while (curr) {
      paths.unshift({ obj: route, type: curr });
      curr = route.parent;
      route = curr && map[curr];
    }
    return paths;
  };
  var routesMap = props.routesMap,
      route = props.route,
      theme = props.theme,
      goToPage = props.goToPage;

  var segments = getPath(route, routesMap);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: theme.breadcrumb },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      segments.map(function (segment, indx) {
        return segments.length > 1 && indx !== segments.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_NavLink__["a" /* default */],
          _extends({
            key: segment.obj.name,
            tag: 'div',
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme['breadcrumb-item'], theme['breadcrumb-active']),
            to: { type: segment.type }
          }, segment.obj.resource && {
            includeQuery: segment.obj.resource
          }, segment.obj.path === '/' && { exact: 'exact' }),
          segment.obj.name
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: segment.obj.name, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme['breadcrumb-item']) },
          indx !== 0 && _ref,
          segment.obj.name
        );
      }, this),
      routesMap[route].action ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme['breadcrumb-item'], theme['breadcrumb-actions']) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__ui_Button_Button__["a" /* default */],
          {
            classes: 'secondary',
            theme: theme,
            onClick: function onClick() {
              return goToPage(routesMap[route].action.target);
            }
          },
          routesMap[route].action.label
        )
      ) : null
    )
  );
};

Breadcrumb.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  routesMap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);

/***/ }),

/***/ "./ui/Button/Button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var mapToCSSModule = function mapToCSSModule(styles, classes, theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, 'button', [].concat(Array.isArray(classes) && classes || [classes]).map(function (c) {
    return 'button-' + c;
  }), styles);
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function (e) {
      if (_this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        styles = _props.styles,
        theme = _props.theme,
        resource = _props.resource,
        tag = _props.tag,
        getRef = _props.getRef,
        attributes = _objectWithoutProperties(_props, ['classes', 'styles', 'theme', 'resource', 'tag', 'getRef']);

    var Tag = tag;

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: mapToCSSModule(styles, classes, theme),
      ref: getRef,
      onClick: this.onClick
    }));
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.defaultProps = {
  tag: 'button'
};


Button.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "./ui/Button/ButtonGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      theme = props.theme,
      width = props.width,
      resource = props.resource,
      children = props.children,
      record = props.record,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'theme', 'width', 'resource', 'children', 'record', 'vertical', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, theme['button-group'], vertical ? theme['vertical'] : theme['horizontal']);
  var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
      record: record,
      resource: resource
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    childrenWithProps
  );
};

ButtonGroup.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

ButtonGroup.defaultProps = {
  tag: 'div',
  role: 'group'
};

/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),

/***/ "./ui/Button/EditButton.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var EditButton = function EditButton(_ref) {
  var source = _ref.source,
      _ref$basePath = _ref.basePath,
      basePath = _ref$basePath === undefined ? '' : _ref$basePath,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'i18n.action.edit' : _ref$title,
      _ref$record = _ref.record,
      record = _ref$record === undefined ? {} : _ref$record,
      _ref$clean = _ref.clean,
      clean = _ref$clean === undefined ? false : _ref$clean,
      locale = _ref.locale,
      translate = _ref.translate,
      sortable = _ref.sortable,
      click = _ref.click,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ['source', 'basePath', 'title', 'record', 'clean', 'locale', 'translate', 'sortable', 'click', 'label']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],
    _extends({}, rest, {
      classes: clean ? 'secondary' : ['clean', 'link']
    }, click && { onClick: function onClick(e) {
        return click(record);
      } }),
    title ? translate(title) : source ? __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source) : null
  );
};

EditButton.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  sortable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */])(EditButton));

/***/ }),

/***/ "./ui/Button/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themedButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return themedEditButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return themedButtonGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditButton__ = __webpack_require__("./ui/Button/EditButton.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonGroup__ = __webpack_require__("./ui/Button/ButtonGroup.js");





var themedButton = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */]);
var themedEditButton = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__EditButton__["a" /* default */]);
var themedButtonGroup = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__ButtonGroup__["a" /* default */]);




/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */]);

/***/ }),

/***/ "./ui/Card/Card.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var mapToCSSModule = function mapToCSSModule(classes, theme) {
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Array.isArray(classes) ? classes.map(function (c) {
    return theme[c];
  }) : theme[classes]);
};

var Card = function Card(props) {
  var _classNames;

  var header = props.header,
      skipHeader = props.skipHeader,
      footer = props.footer,
      color = props.color,
      theme = props.theme,
      children = props.children,
      classes = props.classes,
      attributes = _objectWithoutProperties(props, ['header', 'skipHeader', 'footer', 'color', 'theme', 'children', 'classes']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({ className: mapToCSSModule(['card', color].concat(classes), theme) }, attributes),
    header ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: theme['card-header'] },
      header
    ) : null,
    children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme['card-body'], (_classNames = {}, _classNames[theme['with-header']] = header && skipHeader !== true, _classNames[theme['without-header']] = !header && skipHeader !== true, _classNames))
      },
      children
    ) : null,
    footer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: theme['card-footer'] },
      footer
    ) : null
  );
};

Card.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Card.defaultProps = {
  theme: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),

/***/ "./ui/Card/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themedCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__("./ui/Card/Card.js");



var themedCard = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Card__["a" /* default */]);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Card__["a" /* default */]);

/***/ }),

/***/ "./ui/Chip/Chip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Avatar__ = __webpack_require__("./ui/Avatar/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Chip = function Chip(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      deletable = _ref.deletable,
      onDeleteClick = _ref.onDeleteClick,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['children', 'className', 'deletable', 'onDeleteClick', 'theme']);

  var hasAvatar = false;
  if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children)) {
    var flatChildren = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children);
    var firstChild = flatChildren[0];
    hasAvatar = firstChild && firstChild.type && firstChild.type === __WEBPACK_IMPORTED_MODULE_3__ui_Avatar__["a" /* default */];
  }

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme.chip, (_classnames = {}, _classnames[theme.deletable] = !!deletable, _classnames[theme.avatar] = !!hasAvatar, _classnames), className);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({ className: classes }, other),
    typeof children === 'string' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      children
    ) : children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'if',
      { condition: deletable },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: theme.delete, onClick: onDeleteClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { viewBox: '0 0 40 40', className: theme.deleteIcon },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: theme.deleteX, d: 'M 12,12 L 28,28 M 28,12 L 12,28' })
        )
      )
    )
  );
};

Chip.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  deletable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onDeleteClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Chip.defaultProps = {
  className: '',
  deletable: false
};

/* harmony default export */ __webpack_exports__["a"] = (Chip);

/***/ }),

/***/ "./ui/ClickAwayListener.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener__ = __webpack_require__("../node_modules/react-event-listener/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_event_listener__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isDescendant = function isDescendant(el, target) {
  if (target !== null && target.parentNode) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var ClickAwayListener = function (_React$Component) {
  _inherits(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _temp, _this, _ret;

    _classCallCheck(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.mounted = false, _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (_this.mounted) {
        var el = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this);

        if (event.target instanceof HTMLElement && document.documentElement && document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ClickAwayListener.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
  };

  ClickAwayListener.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  ClickAwayListener.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_event_listener___default.a,
      {
        target: 'document',
        onMouseup: this.handleClickAway,
        onTouchend: this.handleClickAway
      },
      this.props.children
    );
  };

  return ClickAwayListener;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ClickAwayListener);

/***/ }),

/***/ "./ui/Data/AutoCompleteField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AutoCompleteField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Input_AutoComplete__ = __webpack_require__("./ui/Input/AutoComplete.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var AutoCompleteField = function AutoCompleteField(_ref) {
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      _ref$input = _ref.input,
      value = _ref$input.value,
      name = _ref$input.name,
      _onChange = _ref$input.onChange,
      onBlur = _ref$input.onBlur,
      inputProps = _objectWithoutProperties(_ref$input, ['value', 'name', 'onChange', 'onBlur']),
      translate = _ref.translate,
      filter = _ref.filter,
      props = _objectWithoutProperties(_ref, ['meta', 'input', 'translate', 'filter']);

  var val = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== undefined && props.source ? props.source[value] : value;
  var bb = function bb(vv) {
    onBlur(value);
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Input_AutoComplete__["a" /* default */], _extends({}, props, {
    value: val,
    multiple: false,
    onBlur: bb,
    error: touched && error,
    className: 'form-group',
    showSelectedWhenNotInSource: true,
    showSuggestionsWhenValueIsSet: true,
    direction: 'down',
    onChange: function onChange(val) {
      return _onChange(val | 0 || null);
    }
  }));
};


AutoCompleteField.propTypes = {
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var mapStateToProps = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state, props) {
  return {
    source: state.rest[props.src] && state.rest[props.src].data && Object.entries(state.rest[props.src].data).reduce(function (res, key) {
      if (props.filter && !!props.filter(key[1])) return res;
      res[key[0]] = key[1][props.titleProperty];
      return res;
    }, {})
  };
});

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_2_recompose_pure___default.a, __WEBPACK_IMPORTED_MODULE_5__ui_Theme_themed__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__i18n_translate__["a" /* default */], mapStateToProps);

/* harmony default export */ __webpack_exports__["a"] = (enhance(AutoCompleteField));

/***/ }),

/***/ "./ui/Data/AvatarField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Avatar__ = __webpack_require__("./ui/Avatar/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var AvatarField = function AvatarField(_ref) {
  var source = _ref.source,
      _ref$record = _ref.record,
      record = _ref$record === undefined ? {} : _ref$record,
      localize = _ref.localize,
      translate = _ref.translate,
      sortable = _ref.sortable,
      locale = _ref.locale,
      fallback = _ref.fallback,
      resource = _ref.resource,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['source', 'record', 'localize', 'translate', 'sortable', 'locale', 'fallback', 'resource', 'theme']);

  var image = source ? __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source) : false;
  if (image) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Avatar__["a" /* default */], _extends({}, props, { color: record.color, theme: theme, image: image, cover: true, letter: false }));
  }
  var letters = '';
  if (fallback) {
    letters = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, fallback);

    if (letters) {
      if (letters.indexOf(' ') !== -1) {
        letters = letters.split(' ').slice(0, 2).map(function (str) {
          return str[0].toUpperCase();
        }).join('');
      } else {
        letters = letters.substring(0, 2).toUpperCase();
      }
    }
  }
  if (!image && !letters) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__ui_Avatar__["a" /* default */],
    _extends({}, props, { color: record.color, theme: theme, image: image, cover: true }),
    letters
  );
};

AvatarField.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fallback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]).isRequired
};

var PureAvatarField = __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default()(AvatarField);

/* harmony default export */ __webpack_exports__["a"] = (PureAvatarField);

/***/ }),

/***/ "./ui/Data/BooleanField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);




var BooleanField = function BooleanField(props) {
  var source = props.source,
      record = props.record,
      whenTrue = props.whenTrue,
      whenFalse = props.whenFalse,
      equals = props.equals,
      notEquals = props.notEquals,
      noUndefines = props.noUndefines,
      compare = props.compare;

  var bool = void 0;

  if (compare) {
    bool = compare(record);
  } else {
    var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(record, source);
    if (equals !== undefined) {
      bool = value === equals;
    } else if (notEquals !== undefined) {
      if (noUndefines !== undefined && noUndefines) {
        bool = value !== undefined && value !== notEquals;
      } else {
        bool = value !== notEquals;
      }
    } else {
      bool = !!value;
    }
  }
  return bool ? whenTrue : whenFalse;
};

BooleanField.defaultProps = {
  record: {},
  whenTrue: null,
  whenFalse: null
};

BooleanField.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  compare: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  noUndefines: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  whenTrue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  whenFalse: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  equals: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (BooleanField);

/***/ }),

/***/ "./ui/Data/ButtonField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var ButtonField = function ButtonField(props) {
  var record = props.record,
      locale = props.locale,
      translate = props.translate,
      sortable = props.sortable,
      label = props.label,
      click = props.click,
      width = props.width,
      classes = props.classes,
      _props$clean = props.clean,
      clean = _props$clean === undefined ? true : _props$clean,
      attribs = _objectWithoutProperties(props, ['record', 'locale', 'translate', 'sortable', 'label', 'click', 'width', 'classes', 'clean']);

  var combinedClasses = classes ? Array.isArray(classes) && [clean && 'button-clean'].concat(classes) || [clean && 'button-clean', classes] : clean && 'button-clean';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_Button__["a" /* Button */], _extends({}, attribs, click && { onClick: function onClick(e) {
      return click(record);
    } }, { styles: combinedClasses }));
};

ButtonField.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  sortable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clean: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__i18n_translate__["a" /* default */])(ButtonField));

/***/ }),

/***/ "./ui/Data/CombinedField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var CombinedField = function CombinedField(props) {
  var resource = props.resource,
      children = props.children,
      label = props.label,
      cellName = props.cellName,
      record = props.record,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['resource', 'children', 'label', 'cellName', 'record', 'tag']);

  var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
      record: record,
      resource: resource
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    attributes,
    childrenWithProps
  );
};

CombinedField.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

CombinedField.defaultProps = {
  tag: 'div'
};

/* harmony default export */ __webpack_exports__["a"] = (CombinedField);

/***/ }),

/***/ "./ui/Data/DateField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DateField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);





var toLocaleStringSupportsLocales = function () {
  try {
    new Date().toLocaleString('i');
  } catch (error) {
    return error instanceof RangeError;
  }
  return false;
}();

var DateField = function DateField(_ref) {
  var elStyle = _ref.elStyle,
      locales = _ref.locales,
      options = _ref.options,
      record = _ref.record,
      _ref$showTime = _ref.showTime,
      showTime = _ref$showTime === undefined ? false : _ref$showTime,
      source = _ref.source;

  if (!record) return null;
  var value = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source);
  if (value == null) return null;
  var date = value instanceof Date ? value : new Date(value);
  var dateString = showTime ? toLocaleStringSupportsLocales ? date.toLocaleString(locales, options) : date.toLocaleString() : toLocaleStringSupportsLocales ? date.toLocaleDateString(locales, options) : date.toLocaleDateString();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { style: elStyle },
    dateString
  );
};

DateField.propTypes = {
  addLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  elStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  showTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var PureDateField = __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default()(DateField);

PureDateField.defaultProps = {
  addLabel: true
};

/* harmony default export */ __webpack_exports__["a"] = (PureDateField);

/***/ }),

/***/ "./ui/Data/FieldTitle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inflection__ = __webpack_require__("../node_modules/inflection/lib/inflection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inflection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_inflection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_translate__ = __webpack_require__("./i18n/translate.js");








var FieldTitle = function FieldTitle(_ref) {
  var resource = _ref.resource,
      source = _ref.source,
      label = _ref.label,
      isRequired = _ref.isRequired,
      translate = _ref.translate;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    typeof label !== 'undefined' ? translate(label, { _: label }) : typeof source !== 'undefined' ? translate('resources.' + resource + '.fields.' + source, { _: __WEBPACK_IMPORTED_MODULE_2_inflection___default.a.humanize(source) }) : '',
    isRequired && ' *'
  );
};

FieldTitle.propTypes = {
  isRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var enhance = __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a, __WEBPACK_IMPORTED_MODULE_5__i18n_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(FieldTitle));

/***/ }),

/***/ "./ui/Data/ImageField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);




var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);

var ImageField = function ImageField(_ref) {
  var record = _ref.record,
      source = _ref.source,
      src = _ref.src,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? {} : _ref$theme;

  var sourceValue = Object.prototype.toString.call(record) === '[object String]' ? record : __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source);
  if (!sourceValue) {
    return _ref2;
  }

  if (Array.isArray(sourceValue)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      sourceValue.map(function (file, index) {
        var titleValue = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(file, title) || title;
        var srcValue = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(file, src) || title;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: titleValue, title: titleValue, src: srcValue })
        );
      })
    );
  }

  var titleValue = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, title) || title;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: theme['center-vertical'] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { title: titleValue, alt: titleValue, src: sourceValue })
  );
};

ImageField.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (ImageField);

/***/ }),

/***/ "./ui/Data/IndexField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_pure__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var IndexField = function IndexField(_ref) {
  var source = _ref.source,
      _ref$record = _ref.record,
      record = _ref$record === undefined ? {} : _ref$record,
      localize = _ref.localize,
      translate = _ref.translate,
      addLabel = _ref.addLabel,
      sortable = _ref.sortable,
      locale = _ref.locale,
      resource = _ref.resource,
      format = _ref.format,
      index = _ref.index,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === undefined ? 'span' : _ref$tag,
      props = _objectWithoutProperties(_ref, ['source', 'record', 'localize', 'translate', 'addLabel', 'sortable', 'locale', 'resource', 'format', 'index', 'tag']);

  var no = index + 1;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    props,
    format ? format(no) : no
  );
};

IndexField.propTypes = {
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var PureIndexField = __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default()(IndexField);

/* harmony default export */ __webpack_exports__["a"] = (PureIndexField);

/***/ }),

/***/ "./ui/Data/TextField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var TextField = function TextField(_ref) {
  var source = _ref.source,
      _ref$record = _ref.record,
      record = _ref$record === undefined ? {} : _ref$record,
      localize = _ref.localize,
      translate = _ref.translate,
      addLabel = _ref.addLabel,
      sortable = _ref.sortable,
      locale = _ref.locale,
      resource = _ref.resource,
      format = _ref.format,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === undefined ? 'span' : _ref$tag,
      props = _objectWithoutProperties(_ref, ['source', 'record', 'localize', 'translate', 'addLabel', 'sortable', 'locale', 'resource', 'format', 'tag']);

  var str = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    props,
    format ? format(str) : str
  );
};

TextField.propTypes = {
  addLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var PureTextField = __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default()(TextField);

PureTextField.defaultProps = {
  addLabel: true
};

/* harmony default export */ __webpack_exports__["a"] = (PureTextField);

/***/ }),

/***/ "./ui/Data/TextInput.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TextInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Input_InputField__ = __webpack_require__("./ui/Input/InputField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleBlur = function (eventOrValue) {
      _this.props.onBlur(eventOrValue);
      _this.props.input.onBlur(eventOrValue);
    }, _this.handleFocus = function (event) {
      _this.props.onFocus(event);
      _this.props.input.onFocus(event);
    }, _this.handleChange = function (eventOrValue) {
      _this.props.onChange(eventOrValue);
      _this.props.input.onChange(eventOrValue);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextInput.prototype.render = function render() {
    var _props = this.props,
        elStyle = _props.elStyle,
        input = _props.input,
        meta = _props.meta,
        options = _props.options,
        resource = _props.resource,
        source = _props.source,
        type = _props.type,
        placeholder = _props.placeholder;

    if (typeof meta === 'undefined') {
      throw new Error("The TextInput component wasn't called within a redux-form <Field>." + ' Did you decorate it and forget to add the addField prop to your component? ' + 'See https://marmelab.com/rest-on-rest/Inputs.html#writing-your-own-input-component' + ' for details.');
    }
    var touched = meta.touched,
        error = meta.error;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_Input_InputField__["a" /* default */], _extends({}, input, {
      placeholder: placeholder,
      name: resource + '-' + source,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      type: type,
      errorText: touched && error,
      style: elStyle
    }, options));
  };

  return TextInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TextInput.propTypes = {
  addField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  elStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

TextInput.defaultProps = {
  addField: true,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  options: {},
  type: 'text'
};

/* harmony default export */ __webpack_exports__["a"] = (TextInput);

/***/ }),

/***/ "./ui/Data/TypeField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("../node_modules/lodash.get/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var TypeField = function TypeField(_ref) {
  var source = _ref.source,
      _ref$record = _ref.record,
      record = _ref$record === undefined ? {} : _ref$record,
      localize = _ref.localize,
      translate = _ref.translate,
      addLabel = _ref.addLabel,
      sortable = _ref.sortable,
      locale = _ref.locale,
      resource = _ref.resource,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['source', 'record', 'localize', 'translate', 'addLabel', 'sortable', 'locale', 'resource', 'theme']);

  var label = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, source);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(theme['type-' + label], theme['type-' + source]) }),
    localize ? translate('app.' + source + '.' + label) : label
  );
};

TypeField.defaultProps = {
  addLabel: true
};

TypeField.propTypes = {
  addLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var enhance = __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a, __WEBPACK_IMPORTED_MODULE_6__i18n_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(TypeField));

/***/ }),

/***/ "./ui/Data/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themedAvatarField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return themedTypeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvatarField__ = __webpack_require__("./ui/Data/AvatarField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TypeField__ = __webpack_require__("./ui/Data/TypeField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonField__ = __webpack_require__("./ui/Data/ButtonField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__ButtonField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BooleanField__ = __webpack_require__("./ui/Data/BooleanField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__BooleanField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CombinedField__ = __webpack_require__("./ui/Data/CombinedField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__CombinedField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateField__ = __webpack_require__("./ui/Data/DateField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__DateField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldTitle__ = __webpack_require__("./ui/Data/FieldTitle.js");
/* unused harmony reexport FieldTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
/* unused harmony reexport ImageField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TextField__ = __webpack_require__("./ui/Data/TextField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__TextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TextInput__ = __webpack_require__("./ui/Data/TextInput.js");
/* unused harmony reexport TextInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IndexField__ = __webpack_require__("./ui/Data/IndexField.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__IndexField__["a"]; });





var themedAvatarField = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__AvatarField__["a" /* default */]);
var themedTypeField = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__TypeField__["a" /* default */]);























/***/ }),

/***/ "./ui/DataTable/Datagrid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatagridCell__ = __webpack_require__("./ui/DataTable/DatagridCell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DatagridHeaderCell__ = __webpack_require__("./ui/DataTable/DatagridHeaderCell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DatagridBody__ = __webpack_require__("./ui/DataTable/DatagridBody.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Datagrid = function (_Component) {
  _inherits(Datagrid, _Component);

  function Datagrid() {
    var _temp, _this, _ret;

    _classCallCheck(this, Datagrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateSort = function (event) {
      event.stopPropagation();
      _this.props.setSort(event.currentTarget.dataset.sort);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Datagrid.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var _props = this.props,
        resource = _props.resource,
        children = _props.children,
        ids = _props.ids,
        isLoading = _props.isLoading,
        data = _props.data,
        currentSort = _props.currentSort,
        theme = _props.theme,
        headerOptions = _props.headerOptions,
        bodyOptions = _props.bodyOptions,
        rowOptions = _props.rowOptions,
        _props$sortable = _props.sortable,
        sortable = _props$sortable === undefined ? true : _props$sortable,
        startingNo = _props.startingNo;

    var withoutThead = headerOptions && headerOptions.hide;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'table',
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(theme.table, (_classNames = {}, _classNames[theme['without-thead']] = withoutThead, _classNames[theme['sortable']] = sortable, _classNames))
      },
      !withoutThead ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'thead',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (field, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DatagridHeaderCell__["a" /* default */], {
              key: field.props.source || index,
              field: field,
              width: field.props.width || 'auto',
              currentSort: currentSort,
              isSorting: field.props.source === currentSort.field,
              updateSort: _this2.updateSort,
              resource: resource,
              theme: theme
            });
          })
        )
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__DatagridBody__["a" /* default */],
        {
          resource: resource,
          ids: ids,
          data: data,
          isLoading: isLoading,
          options: bodyOptions,
          rowOptions: rowOptions,
          startingNo: startingNo,
          theme: theme
        },
        children
      )
    );
  };

  return Datagrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Datagrid.propTypes = {
  bodyOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  headerOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  ids: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rowOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  setSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Datagrid.defaultProps = {
  data: {},
  ids: [],
  theme: {}
};

/* harmony default export */ __webpack_exports__["a"] = (Datagrid);

/***/ }),

/***/ "./ui/DataTable/DatagridBody.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__ = __webpack_require__("../node_modules/recompose/shouldUpdate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatagridCell__ = __webpack_require__("./ui/DataTable/DatagridCell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Table__ = __webpack_require__("./ui/Table/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DatagridBody = function DatagridBody(_ref) {
  var resource = _ref.resource,
      children = _ref.children,
      ids = _ref.ids,
      data = _ref.data,
      isLoading = _ref.isLoading,
      options = _ref.options,
      rowOptions = _ref.rowOptions,
      _ref$startingNo = _ref.startingNo,
      startingNo = _ref$startingNo === undefined ? 0 : _ref$startingNo,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ['resource', 'children', 'ids', 'data', 'isLoading', 'options', 'rowOptions', 'startingNo', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'tbody',
    _extends({ className: theme['datagrid-body'] }, rest, options),
    ids.map(function (id, rowIndex) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ui_Table__["a" /* TableRow */],
        _extends({ key: id, selectable: false }, rowOptions),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (field, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DatagridCell__["a" /* default */], _extends({
            theme: theme,
            key: id + '-' + (field.props.source || index),
            classes: 'column-' + (field.props.source || field.props.cellName || 'simple'),
            record: data[id],
            index: startingNo + rowIndex
          }, { field: field, resource: resource }));
        })
      );
    })
  );
};

DatagridBody.propTypes = {
  ids: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  rowOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

DatagridBody.defaultProps = {
  data: {},
  ids: []
};

var PureDatagridBody = __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default()(function (props, nextProps) {
  return nextProps.isLoading === false;
})(DatagridBody);

/* harmony default export */ __webpack_exports__["a"] = (PureDatagridBody);

/***/ }),

/***/ "./ui/DataTable/DatagridCell.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var mapToCSSModule = function mapToCSSModule(classes, theme) {
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Array.isArray(classes) ? classes.map(function (c) {
    return theme[c];
  }) : theme[classes]);
};

var DatagridCell = function DatagridCell(_ref) {
  var classes = _ref.classes,
      field = _ref.field,
      index = _ref.index,
      record = _ref.record,
      resource = _ref.resource,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ['classes', 'field', 'index', 'record', 'resource', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'td',
    _extends({ className: mapToCSSModule(classes, theme) }, rest),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(field, { record: record, resource: resource, index: index })
  );
};

DatagridCell.propTypes = {
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (DatagridCell);

/***/ }),

/***/ "./ui/DataTable/DatagridHeaderCell.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DatagridHeaderCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__ = __webpack_require__("../node_modules/recompose/shouldUpdate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Data_FieldTitle__ = __webpack_require__("./ui/Data/FieldTitle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Data_ButtonField__ = __webpack_require__("./ui/Data/ButtonField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_Sort__ = __webpack_require__("./icons/Sort.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_HasSort__ = __webpack_require__("./icons/HasSort.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_types_query__ = __webpack_require__("./state/types/query.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__icons_HasSort__["a" /* default */], { size: '1.5em' });

var DatagridHeaderCell = function DatagridHeaderCell(_ref) {
  var _ClassNames;

  var field = _ref.field,
      width = _ref.width,
      currentSort = _ref.currentSort,
      updateSort = _ref.updateSort,
      resource = _ref.resource,
      theme = _ref.theme;

  var isSorted = field.props.source === currentSort.field;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'th',
    _extends({}, width && {
      style: {
        width: width
      }
    }, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(theme['column-' + (field.props.source || field.props.cellName || 'simple')], (_ClassNames = {}, _ClassNames[theme['sorted']] = isSorted, _ClassNames))
    }),
    field.props.sortable !== false && field.props.source ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_Data_ButtonField__["a" /* default */],
      { onClick: updateSort, 'data-sort': field.props.source, theme: theme },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Data_FieldTitle__["a" /* default */], { label: field.props.label, source: field.props.source, resource: resource }),
      isSorted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icons_Sort__["a" /* default */], {
        size: '1.5em',
        style: currentSort.order === __WEBPACK_IMPORTED_MODULE_8__state_types_query__["d" /* SORT_ASC */] ? { transform: 'rotate(180deg)' } : {}
      }) : _ref2
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Data_FieldTitle__["a" /* default */], { label: field.props.label, source: field.props.source, resource: resource })
  );
};

DatagridHeaderCell.propTypes = {
  field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  isSorting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  sortable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  updateSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_shouldUpdate___default()(function (props, nextProps) {
  return props.isSorting !== nextProps.isSorting || nextProps.isSorting && props.currentSort.order !== nextProps.currentSort.order;
})(DatagridHeaderCell));

/***/ }),

/***/ "./ui/DataTable/Filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__("../node_modules/lodash.debounce/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_objectEquals__ = __webpack_require__("./helpers/objectEquals.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterForm__ = __webpack_require__("./ui/DataTable/FilterForm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_removeEmpty__ = __webpack_require__("./helpers/removeEmpty.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.setFilters = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function (filters) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__helpers_objectEquals__["a" /* default */])(filters, _this.filters)) {
        var filtersWithoutEmpty = Object(__WEBPACK_IMPORTED_MODULE_6__helpers_removeEmpty__["a" /* default */])(filters);
        _this.props.setFilters(filtersWithoutEmpty);
        _this.filters = filtersWithoutEmpty;
      }
    }, _this.props.debounce);

    _this.filters = _this.props.filterValues;
    return _this;
  }

  Filter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.filters = nextProps.filterValues;
  };

  Filter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.setFilters) {
      this.setFilters.cancel();
    }
  };

  Filter.prototype.renderButton = function renderButton() {
    var _props = this.props,
        resource = _props.resource,
        children = _props.children,
        showFilter = _props.showFilter,
        displayedFilters = _props.displayedFilters,
        filterValues = _props.filterValues;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__["a" /* default */], {
      resource: resource,
      filters: __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children),
      showFilter: showFilter,
      displayedFilters: displayedFilters,
      filterValues: filterValues
    });
  };

  Filter.prototype.renderForm = function renderForm() {
    var _props2 = this.props,
        resource = _props2.resource,
        children = _props2.children,
        hideFilter = _props2.hideFilter,
        displayedFilters = _props2.displayedFilters,
        filterValues = _props2.filterValues;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FilterForm__["a" /* default */], {
      resource: resource,
      filters: __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children),
      hideFilter: hideFilter,
      displayedFilters: displayedFilters,
      initialValues: filterValues,
      setFilters: this.setFilters
    });
  };

  Filter.prototype.render = function render() {
    return this.props.context === 'button' ? this.renderButton() : this.renderForm();
  };

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Filter.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['form', 'button']),
  debounce: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  displayedFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  filterValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  hideFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

Filter.defaultProps = {
  debounce: 500
};

/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),

/***/ "./ui/DataTable/FilterForm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FilterForm */
/* unused harmony export mergeInitialValuesWithDefaultValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_Delete__ = __webpack_require__("./icons/Delete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withProps__ = __webpack_require__("../node_modules/recompose/withProps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var emptyRecord = {};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icons_Delete__["a" /* default */], null);

var FilterForm = function (_Component) {
  _inherits(FilterForm, _Component);

  function FilterForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, FilterForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleHide = function (event) {
      return _this.props.hideFilter(event.currentTarget.dataset.key);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FilterForm.prototype.getShownFilters = function getShownFilters() {
    var _props = this.props,
        filters = _props.filters,
        displayedFilters = _props.displayedFilters,
        initialValues = _props.initialValues;

    return filters.filter(function (filterElement) {
      return filterElement.props.alwaysOn || displayedFilters[filterElement.props.source] || typeof initialValues[filterElement.props.source] !== 'undefined';
    });
  };

  FilterForm.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        resource = _props2.resource,
        translate = _props2.translate;


    return this.getShownFilters().reverse().map(function (filterElement) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          key: filterElement.props.source,
          'data-source': filterElement.props.source,
          className: 'filter-field'
        },
        !filterElement.props.alwaysOn ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__ui_Button__["d" /* default */],
          {
            className: 'hide-filter',
            onClick: _this2.handleHide,
            'data-key': filterElement.props.source,
            tooltip: translate('i18n.action.remove_filter')
          },
          _ref
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], _extends({
          allowEmpty: true
        }, filterElement.props, {
          name: filterElement.props.source,
          component: filterElement.type,
          resource: resource,
          record: emptyRecord
        }))
      );
    });
  };

  return FilterForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FilterForm.propTypes = {
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node).isRequired,
  displayedFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  hideFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var mergeInitialValuesWithDefaultValues = function mergeInitialValuesWithDefaultValues(_ref2) {
  var initialValues = _ref2.initialValues,
      filters = _ref2.filters;
  return {
    initialValues: _extends({}, filters.filter(function (filterElement) {
      return filterElement.props.alwaysOn && filterElement.props.defaultValue;
    }).reduce(function (acc, filterElement) {
      var _extends2;

      return _extends({}, acc, (_extends2 = {}, _extends2[filterElement.props.source] = filterElement.props.defaultValue, _extends2));
    }, {}), initialValues)
  };
};

var enhance = __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_7__i18n_translate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_recompose_withProps___default()(mergeInitialValuesWithDefaultValues), Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'filterForm',
  enableReinitialize: true,
  onChange: function onChange(values, dispatch, props) {
    return props.setFilters(values);
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(FilterForm));

/***/ }),

/***/ "./ui/DataTable/List.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_inflection__ = __webpack_require__("../node_modules/inflection/lib/inflection.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_inflection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_inflection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Card_Card__ = __webpack_require__("./ui/Card/Card.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_reducers_resource_list_queryReducer__ = __webpack_require__("./state/reducers/resource/list/queryReducer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_types_query__ = __webpack_require__("./state/types/query.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pagination__ = __webpack_require__("./ui/DataTable/Pagination.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions_list__ = __webpack_require__("./state/actions/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_removeKey__ = __webpack_require__("./helpers/removeKey.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pagination__["a" /* default */], null);

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.refresh = function (event) {
      event.stopPropagation();
      _this.updateData();
    };

    _this.setSort = function (sort) {
      return _this.changeParams({ type: __WEBPACK_IMPORTED_MODULE_8__state_types_query__["c" /* SET_SORT */], payload: sort });
    };

    _this.setPage = function (page) {
      return _this.changeParams({ type: __WEBPACK_IMPORTED_MODULE_8__state_types_query__["b" /* SET_PAGE */], payload: page });
    };

    _this.setFilters = function (filters) {
      return _this.changeParams({ type: __WEBPACK_IMPORTED_MODULE_8__state_types_query__["a" /* SET_FILTER */], payload: filters });
    };

    _this.showFilter = function (filterName, defaultValue) {
      var _this$setState;

      _this.setState((_this$setState = {}, _this$setState[filterName] = true, _this$setState));
      if (typeof defaultValue !== 'undefined') {
        var _extends2;

        _this.setFilters(_extends({}, _this.props.filterValues, (_extends2 = {}, _extends2[filterName] = defaultValue, _extends2)));
      }
    };

    _this.hideFilter = function (filterName) {
      var _this$setState2;

      _this.setState((_this$setState2 = {}, _this$setState2[filterName] = false, _this$setState2));
      var newFilters = Object(__WEBPACK_IMPORTED_MODULE_13__helpers_removeKey__["a" /* default */])(_this.props.filterValues, filterName);
      _this.setFilters(newFilters);
    };

    _this.state = { key: 0 };
    return _this;
  }

  List.prototype.getQuery = function getQuery() {
    var query = _extends({}, this.props.params);
    if (!query.sort) {
      query.sort = this.props.sort.field;
      query.order = this.props.sort.order;
    }
    if (!query.perPage) {
      query.perPage = this.props.perPage;
    }
    return query;
  };

  List.prototype.filterQuery = function filterQuery(query) {
    var defaultParams = this.props.params.default;
    return _extends({}, query.sort && query.sort !== defaultParams.sort && { sort: query.sort }, query.order && query.order !== defaultParams.order && { order: query.order }, query.page && query.page != defaultParams.page && { page: query.page }, query.perPage && query.perPage != defaultParams.perPage && { perPage: query.perPage });
  };

  List.prototype.updateData = function updateData(query) {
    var params = query || this.getQuery();
    var sort = params.sort,
        order = params.order,
        page = params.page,
        perPage = params.perPage,
        filter = params.filter;

    var pagination = { page: parseInt(page, 10), perPage: parseInt(perPage, 10) };
    var permanentFilter = this.props.filter;
    this.props.crudGetList(this.props.resource, pagination, { field: sort, order: order }, _extends({}, filter, permanentFilter));
  };

  List.prototype.changeParams = function changeParams(action) {
    var newParams = Object(__WEBPACK_IMPORTED_MODULE_7__state_reducers_resource_list_queryReducer__["a" /* default */])(this.getQuery(), action);
    this.props.changeListParams(this.props.resource, newParams);
    this.props.goToPage(this.props.currentRouteType, this.filterQuery(newParams));
  };

  List.prototype.render = function render() {
    var _props = this.props,
        filters = _props.filters,
        _props$pagination = _props.pagination,
        pagination = _props$pagination === undefined ? _ref : _props$pagination,
        actions = _props.actions,
        resource = _props.resource,
        hasCreate = _props.hasCreate,
        title = _props.title,
        data = _props.data,
        ids = _props.ids,
        total = _props.total,
        theme = _props.theme,
        children = _props.children,
        isLoading = _props.isLoading,
        translate = _props.translate;

    var query = this.getQuery();
    var filterValues = query.filter;

    var resourceName = translate('resources.' + resource + '.name', {
      smart_count: 2,
      _: __WEBPACK_IMPORTED_MODULE_3_inflection___default.a.humanize(__WEBPACK_IMPORTED_MODULE_3_inflection___default.a.pluralize(resource))
    });
    var defaultTitle = translate('i18n.page.list', { name: '' + resourceName });
    var header = title !== false && filters ? [title !== false ? title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { key: 0 },
      title
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { key: 0 },
      defaultTitle
    ) : null, filters ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(filters, {
      resource: resource,
      theme: theme,
      key: 1,
      hideFilter: this.hideFilter,
      filterValues: filterValues,
      displayedFilters: this.state,
      setFilters: this.setFilters,
      context: 'form'
    }) : null] : null;

    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_Card_Card__["a" /* default */],
      {
        style: { opacity: isLoading ? 0.8 : 1 },
        header: header,
        key: 0,
        theme: theme,
        classes: 'bottom-margin-double'
      },
      actions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(actions, {
          resource: resource,
          theme: theme,
          filters: filters,
          filterValues: filterValues,
          hasCreate: hasCreate,
          displayedFilters: this.state,
          showFilter: this.showFilter,
          refresh: this.refresh
        })
      ) : null,
      isLoading || total > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { margin: '0 -24px 0 -24px' } },
        children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
          resource: resource,
          theme: theme,
          ids: ids,
          data: data,
          currentSort: { field: query.sort, order: query.order },
          isLoading: isLoading,
          setSort: this.setSort
        }) : null
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        translate('i18n.navigation.no_results')
      )
    ), pagination && (isLoading || total > 0) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(pagination, {
      total: total,
      theme: theme,
      key: 1,
      showRange: false,
      nbLabels: false,
      page: parseInt(query.page, 10),
      perPage: parseInt(query.perPage, 10),
      setPage: this.setPage
    }) : null];
  };

  return List;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

List.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  pagination: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  perPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,

  changeListParams: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  crudGetList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  currentRouteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  filterValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  hasCreate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  ids: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  params: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

List.defaultProps = {
  filter: {},
  filterValues: {},
  hasCreate: false,
  perPage: 10,
  sort: {
    field: 'id',
    order: __WEBPACK_IMPORTED_MODULE_8__state_types_query__["e" /* SORT_DESC */]
  }
};

function mapStateToProps(state, props) {
  var resourceState = state.rest[props.resource];
  return {
    params: resourceState.list.params,
    ids: resourceState.list.ids,
    total: resourceState.list.total,
    data: resourceState.data,
    isLoading: state.rest.loading > 0,
    filterValues: resourceState.list.params.filter
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, {
  crudGetList: __WEBPACK_IMPORTED_MODULE_10__state_actions_data__["d" /* crudGetList */],
  changeListParams: __WEBPACK_IMPORTED_MODULE_11__state_actions_list__["a" /* changeListParams */],
  goToPage: __WEBPACK_IMPORTED_MODULE_14__state_actions_routes__["a" /* goToPage */]
}), __WEBPACK_IMPORTED_MODULE_12__i18n_translate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__ui_Theme_themed__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(List));

/***/ }),

/***/ "./ui/DataTable/Pagination.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Paginator */
/* unused harmony export dataPaginator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__("../node_modules/recompose/pure.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Pagination_Pagination__ = __webpack_require__("./ui/Pagination/Pagination.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Pagination_PaginationItem__ = __webpack_require__("./ui/Pagination/PaginationItem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Pagination_PaginationLink__ = __webpack_require__("./ui/Pagination/PaginationLink.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_TriangleLeft__ = __webpack_require__("./icons/TriangleLeft.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_TriangleRight__ = __webpack_require__("./icons/TriangleRight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__icons_TriangleLeft__["a" /* default */], null);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icons_TriangleRight__["a" /* default */], null);

var Paginator = function (_Component) {
  _inherits(Paginator, _Component);

  function Paginator() {
    var _temp, _this, _ret;

    _classCallCheck(this, Paginator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.prevPage = function (event) {
      event.stopPropagation();
      if (_this.props.page === 1) {
        throw new Error(_this.props.translate('i18n.navigation.page_out_from_begin'));
      }
      _this.props.setPage(_this.props.page - 1);
    }, _this.nextPage = function (event) {
      event.stopPropagation();
      if (_this.props.page > _this.getNbPages()) {
        throw new Error(_this.props.translate('i18n.navigation.page_out_from_end'));
      }
      _this.props.setPage(_this.props.page + 1);
    }, _this.gotoPage = function (event) {
      event.stopPropagation();
      var page = event.currentTarget.dataset.page;
      if (page < 1 || page > _this.getNbPages()) {
        throw new Error(_this.props.translate('i18n.navigation.page_out_of_boundaries', { page: page }));
      }
      _this.props.setPage(page);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Paginator.prototype.getNbPages = function getNbPages() {
    return Math.ceil(this.props.total / this.props.perPage) || 1;
  };

  Paginator.prototype.range = function range() {
    var input = [];
    var _props = this.props,
        page = _props.page,
        perPage = _props.perPage,
        total = _props.total;

    if (isNaN(page)) return input;
    var nbPages = Math.ceil(total / perPage) || 1;

    if (page > 2) {
      input.push('1');
    }
    if (page === 4) {
      input.push('2');
    }
    if (page > 4) {
      input.push('.');
    }
    if (page > 1) {
      input.push(page - 1);
    }
    input.push(page);
    if (page < nbPages) {
      input.push(page + 1);
    }
    if (page === nbPages - 3) {
      input.push(nbPages - 1);
    }
    if (page < nbPages - 3) {
      input.push('.');
    }
    if (page < nbPages - 1) {
      input.push(nbPages);
    }

    return input;
  };

  Paginator.prototype.renderPageNums = function renderPageNums() {
    var _this2 = this;

    return this.range().map(function (pageNum, index) {
      return pageNum === '.' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          key: 'hyphen_' + index,
          style: { padding: '0 1.2em', fontWeight: 900, lineHeight: '2em' }
        },
        '\u2026'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Pagination_PaginationItem__["a" /* default */],
        _extends({
          key: pageNum,
          tag: 'div',
          theme: _this2.props.theme
        }, pageNum === _this2.props.page && { active: true }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__ui_Pagination_PaginationLink__["a" /* default */],
          {
            tag: 'span',
            theme: _this2.props.theme,
            'data-page': pageNum,
            onClick: _this2.gotoPage
          },
          pageNum
        )
      );
    });
  };

  Paginator.prototype.render = function render() {
    var _props2 = this.props,
        page = _props2.page,
        perPage = _props2.perPage,
        total = _props2.total,
        nbLabels = _props2.nbLabels,
        showRange = _props2.showRange,
        translate = _props2.translate,
        theme = _props2.theme;

    if (total === 0) return null;
    var offsetEnd = Math.min(page * perPage, total);
    var offsetBegin = Math.min((page - 1) * perPage + 1, offsetEnd);
    var nbPages = this.getNbPages();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: theme['flex-center'] },
      showRange ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { padding: '1.2em' } },
          translate('i18n.navigation.page_range_info', { offsetBegin: offsetBegin, offsetEnd: offsetEnd, total: total })
        )
      ) : null,
      nbPages > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ui_Pagination_Pagination__["a" /* default */],
        { tag: 'div', theme: theme },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Pagination_PaginationItem__["a" /* default */],
          { tag: 'div', key: 'prev', theme: theme, disabled: page === 1 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__ui_Pagination_PaginationLink__["a" /* default */],
            { tag: 'span', theme: theme, onClick: this.prevPage },
            _ref,
            nbLabels ? translate('i18n.navigation.prev') : null
          )
        ),
        this.renderPageNums(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Pagination_PaginationItem__["a" /* default */],
          { tag: 'div', key: 'next', theme: theme, disabled: page === nbPages },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__ui_Pagination_PaginationLink__["a" /* default */],
            { tag: 'span', theme: theme, onClick: this.nextPage },
            nbLabels ? translate('i18n.navigation.next') : null,
            _ref2
          )
        )
      )
    );
  };

  return Paginator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
Paginator.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  page: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  perPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nbLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var withTheme = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* getContext */])({ theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object });

var dataPaginator = Object(__WEBPACK_IMPORTED_MODULE_9__i18n_translate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_recompose_pure___default()(Paginator));
var themedPaginator = withTheme(dataPaginator);

/* harmony default export */ __webpack_exports__["a"] = (dataPaginator);


/***/ }),

/***/ "./ui/DatePicker/DatePicker.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range__ = __webpack_require__("../node_modules/moment-range/dist/moment-range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_ClickAwayListener__ = __webpack_require__("./ui/ClickAwayListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__day_view__ = __webpack_require__("./ui/DatePicker/day-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__month_view__ = __webpack_require__("./ui/DatePicker/month-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__year_view__ = __webpack_require__("./ui/DatePicker/year-view.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__("./ui/DatePicker/util.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var moment = Object(__WEBPACK_IMPORTED_MODULE_4_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_3_moment___default.a);

var Calendar = function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      date: _this.props.date ? _this.props.parsingFormat ? moment(_this.props.date, _this.props.parsingFormat, true) : moment(_this.props.date) : null,
      inputValue: _this.props.date ? moment(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].toDate(_this.props.date)).format(_this.props.format) : undefined,
      currentView: _this.props.minView | 0,
      isVisible: false
    }, _this.changeDate = function (e) {
      _this.setState({ inputValue: e.target.value });
    }, _this.clickAway = function (e) {
      _this.setVisibility(false);
      _this.setState({ isCalendar: false });
    }, _this.inputBlur = function (e) {
      var newDate = null;
      var computableDate = null;
      var date = _this.state.inputValue;

      if (date) {
        newDate = moment(date, _this.props.format, true);

        if (!newDate.isValid() && !_this.props.strictDateParsing) {
          var d = new Date(date);

          if (isNaN(d.getTime())) {
            d = new Date();
          }
          newDate = moment(d);
        }

        computableDate = newDate.format(_this.props.computableFormat);
      }
      _this.setState({
        date: newDate,
        inputValue: newDate ? newDate.format(_this.props.format) : null
      });

      if (_this.props.onChange) {
        _this.props.onChange(computableDate);
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(e, computableDate);
      }
    }, _this.inputClick = function (e) {
      if (_this.props.openOnInputFocus) {
        if (!_this.state.isVisible) {
          _this.toggleClick();
        }
      }
    }, _this.inputFocus = function (e) {
      if (_this.props.openOnInputFocus) {
        if (!_this.state.isVisible) {
          _this.toggleClick();
        }
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    }, _this.keyDown = function (e) {
      __WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].keyDownActions.call(_this, e.keyCode);
    }, _this.nextView = function () {
      if (_this.checkIfDateDisabled(_this.state.date)) return;
      var cv = _this.state.currentView + 1;
      _this.setState({ currentView: cv });
    }, _this.prevView = function (date) {
      var newDate = date;
      if (_this.props.minDate && date.isBefore(_this.props.minDate, 'day')) {
        newDate = _this.state.minDate.clone();
      }

      if (_this.props.maxDate && date.isAfter(_this.props.maxDate, 'day')) {
        newDate = _this.props.maxDate.clone();
      }

      if (_this.state.currentView === _this.props.minView) {
        _this.setState({
          date: newDate,
          inputValue: date.format(_this.props.format),
          isVisible: false
        });
        if (_this.props.onChange) {
          _this.props.onChange(date.format(_this.props.computableFormat));
        }
      } else {
        var cv = _this.state.currentView - 1;
        _this.setState({
          date: date,
          currentView: cv
        });
      }
    }, _this.setDate = function (date) {
      var isDayView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_this.checkIfDateDisabled(date)) return;

      _this.setState({
        date: date,
        inputValue: date.format(_this.props.format),
        isVisible: _this.props.closeOnSelect && isDayView ? !_this.state.isVisible : _this.state.isVisible
      });

      if (_this.props.onChange) {
        _this.props.onChange(date.format(_this.props.computableFormat));
      }
    }, _this.calendarClick = function (e) {
      e.stopPropagation();
      _this.setState({ isCalendar: true });
    }, _this.calendarMouseDown = function (e) {
      e.preventDefault();
    }, _this.todayClick = function () {
      var today = moment().startOf('day');

      if (_this.checkIfDateDisabled(today)) return;

      _this.setState({
        date: today,
        inputValue: today.format(_this.props.format),
        currentView: _this.props.minView
      });

      if (_this.props.onChange) {
        _this.props.onChange(today.format(_this.props.computableFormat));
      }
    }, _this.toggleClick = function () {
      _this.setState({ isCalendar: true });
      _this.setVisibility();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Calendar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newState = {
      date: nextProps.date ? this.props.parsingFormat ? moment(nextProps.date, nextProps.parsingFormat, true) : moment(nextProps.date) : this.state.date,
      inputValue: nextProps.date ? moment(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].toDate(nextProps.date)).format(this.props.format) : null,
      minDate: nextProps.minDate ? moment(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].toDate(nextProps.minDate)) : null,
      maxDate: nextProps.maxDate ? moment(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].toDate(nextProps.maxDate)) : null
    };
    if (nextProps.disabled === true) {
      newState.isVisible = false;
    }

    this.setState(newState);
  };

  Calendar.prototype.checkIfDateDisabled = function checkIfDateDisabled(date) {
    return date && this.props.minDate && date.isBefore(this.props.minDate, 'day') || date && this.props.maxDate && date.isAfter(this.props.maxDate, 'day');
  };

  Calendar.prototype.setVisibility = function setVisibility(val) {
    var value = val !== undefined ? val : !this.state.isVisible;
    var eventMethod = value ? 'addEventListener' : 'removeEventListener';

    document[eventMethod]('keydown', this.keyDown);

    if (this.state.isVisible !== value && !this.props.disabled) {
      this.setState({ isVisible: value });
    }
  };

  Calendar.prototype.render = function render() {
    var _cs;

    var _props = this.props,
        hideTouchKeyboard = _props.hideTouchKeyboard,
        todayText = _props.todayText,
        disabled = _props.disabled,
        theme = _props.theme,
        errorText = _props.errorText;

    var calendarDate = this.state.date || moment();
    var todayLabel = todayText || (moment.locale() === 'de' ? 'Heute' : 'Today');
    var calendarClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ 'input-calendar-wrapper': true });
    var displayed = !(!this.state.isVisible || disabled);

    var readOnly = false;

    if (hideTouchKeyboard) {
      try {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          readOnly = true;
        }
      } catch (e) {
        console.warn(e);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__ui_ClickAwayListener__["a" /* default */],
      { onClickAway: this.clickAway },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'input-calendar' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Input__["c" /* InputField */], {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cs = {}, _cs[theme['focus']] = displayed, _cs)),
          name: this.props.inputName,
          id: this.props.inputFieldId,
          labelText: this.props.labelText,
          onBlur: this.inputBlur,
          onChange: this.changeDate,
          onFocus: this.inputFocus,
          onClick: this.inputClick,
          placeholder: this.props.placeholder,
          readOnly: readOnly,
          disabled: this.props.disabled,
          type: 'text',
          value: this.state.inputValue || '',
          errorText: errorText
        }),
        displayed ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: calendarClass,
            onClick: this.calendarClick,
            onMouseDown: this.calendarMouseDown
          },
          this.state.currentView === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__day_view__["a" /* default */], {
            date: calendarDate,
            nextView: this.nextView,
            maxDate: this.props.maxDate,
            minDate: this.props.minDate,
            setDate: this.setDate
          }) : this.state.currentView === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__month_view__["a" /* default */], {
            date: calendarDate,
            nextView: this.nextView,
            maxDate: this.props.maxDate,
            minDate: this.props.minDate,
            prevView: this.prevView,
            setDate: this.setDate
          }) : this.state.currentView === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__year_view__["a" /* default */], {
            date: calendarDate,
            maxDate: this.props.maxDate,
            minDate: this.props.minDate,
            prevView: this.prevView,
            setDate: this.setDate
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__day_view__["a" /* default */], {
            date: calendarDate,
            nextView: this.nextView,
            maxDate: this.props.maxDate,
            minDate: this.props.minDate,
            setDate: this.setDate
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              className: 'today-btn' + (this.checkIfDateDisabled(moment().startOf('day')) ? ' disabled' : ''),
              onClick: this.todayClick
            },
            todayLabel
          )
        ) : null
      )
    );
  };

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Calendar.propTypes = {
  closeOnSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  computableFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strictDateParsing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  parsingFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputFieldId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputFieldClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  minView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  openOnInputFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideTouchKeyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  todayText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Calendar.defaultProps = {
  date: null,
  closeOnSelect: false,
  computableFormat: 'YYYY-MM-DD HH:mm:ss',
  format: 'MM-DD-YYYY',
  openOnInputFocus: true,
  strictDateParsing: false,
  minDate: null,
  maxDate: null,
  minView: 0
};


/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),

/***/ "./ui/DatePicker/cell.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Cell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



function Cell(_ref) {
  var value = _ref.value,
      classes = _ref.classes;

  var _classes = classes + ' cell';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: _classes },
    value
  );
}

/***/ }),

/***/ "./ui/DatePicker/day-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range__ = __webpack_require__("../node_modules/moment-range/dist/moment-range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cell__ = __webpack_require__("./ui/DatePicker/cell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_header__ = __webpack_require__("./ui/DatePicker/view-header.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var moment = Object(__WEBPACK_IMPORTED_MODULE_4_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_3_moment___default.a);

var DayView = function (_React$Component) {
  _inherits(DayView, _React$Component);

  function DayView() {
    var _temp, _this, _ret;

    _classCallCheck(this, DayView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.cellClick = function (e) {
      var cell = e.target;
      var date = parseInt(cell.innerHTML, 10);
      var newDate = _this.props.date ? _this.props.date.clone() : moment();

      if (isNaN(date)) return;

      if (cell.className.indexOf('prev') > -1) {
        newDate.subtract(1, 'months');
      } else if (cell.className.indexOf('next') > -1) {
        newDate.add(1, 'months');
      }

      newDate.date(date);
      _this.props.setDate(newDate, true);
    }, _this.next = function () {
      var nextDate = _this.props.date.clone().add(1, 'months');
      if (_this.props.maxDate && nextDate.isAfter(_this.props.maxDate, 'day')) {
        nextDate = _this.props.maxDate;
      }
      _this.props.setDate(nextDate);
    }, _this.prev = function () {
      var prevDate = _this.props.date.clone().subtract(1, 'months');
      if (_this.props.minDate && prevDate.isBefore(_this.props.minDate, 'day')) {
        prevDate = _this.props.minDate;
      }
      _this.props.setDate(prevDate);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DayView.prototype.getDays = function getDays() {
    var now = this.props.date ? this.props.date : moment();
    var start = now.clone().startOf('month').weekday(0);
    var end = now.clone().endOf('month').weekday(6);
    var minDate = this.props.minDate;
    var maxDate = this.props.maxDate;
    var month = now.month();
    var today = moment();
    var currDay = now.date();
    var year = now.year();
    var days = [];

    Array.from(moment().range(start, end).by('days')).forEach(function (day) {
      days.push({
        label: day.format('D'),
        prev: day.month() < month && !(day.year() > year) || day.year() < year,
        next: day.month() > month || day.year() > year,
        disabled: day.isBefore(minDate, 'day') || day.isAfter(maxDate, 'day'),
        curr: day.date() === currDay && day.month() === month,
        today: day.date() === today.date() && day.month() === today.month() && day.year() === today.year()
      });
    });
    return days;
  };

  DayView.prototype.getDaysTitles = function getDaysTitles() {
    var now = moment();
    return [0, 1, 2, 3, 4, 5, 6].map(function (i) {
      var weekday = now.weekday(i).format('dd');
      return { val: weekday, label: weekday };
    });
  };

  DayView.prototype.render = function render() {
    var titles = this.getDaysTitles().map(function (item, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cell__["a" /* default */], { classes: 'day title', key: i, value: item.label });
    });
    var _class = void 0;

    var days = this.getDays().map(function (item, i) {
      _class = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        day: true,
        next: item.next,
        prev: item.prev,
        disabled: item.disabled,
        current: item.curr,
        today: item.today
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cell__["a" /* default */], { classes: _class, key: i, value: item.label });
    });

    var currentDate = this.props.date ? this.props.date.format('MMMM') : moment().format('MMMM');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'view days-view', onKeyDown: this.keyDown },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__view_header__["a" /* default */], {
        data: currentDate,
        next: this.next,
        prev: this.prev,
        titleAction: this.props.nextView
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'days-title' },
        titles
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'datepicker-table days', onClick: this.cellClick },
        days
      )
    );
  };

  return DayView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DayView.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  setDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  nextView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (DayView);

/***/ }),

/***/ "./ui/DatePicker/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerThemed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DatePicker__ = __webpack_require__("./ui/DatePicker/DatePicker.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var DatePickerRedux = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["c" /* mapProps */])(function (_ref) {
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      _ref$input = _ref.input,
      _onBlur = _ref$input.onBlur,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onBlur', 'value']),
      props = _objectWithoutProperties(_ref, ['meta', 'input']);

  return _extends({
    errorText: touched && error,
    computableFormat: 'YYYY-MM-DD HH:mm:ss',
    format: 'MM-DD-YYYY',
    date: value,
    onBlur: function onBlur(e) {
      return _onBlur();
    } }, inputProps, props);
})(__WEBPACK_IMPORTED_MODULE_2__DatePicker__["a" /* default */]);

var DatePickerThemed = Object(__WEBPACK_IMPORTED_MODULE_1__ui_Theme_themed__["a" /* default */])(DatePickerRedux);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_2__DatePicker__["a" /* default */]);


/***/ }),

/***/ "./ui/DatePicker/month-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range__ = __webpack_require__("../node_modules/moment-range/dist/moment-range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cell__ = __webpack_require__("./ui/DatePicker/cell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_header__ = __webpack_require__("./ui/DatePicker/view-header.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var moment = Object(__WEBPACK_IMPORTED_MODULE_4_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_3_moment___default.a);

var MonthView = function (_React$Component) {
  _inherits(MonthView, _React$Component);

  function MonthView() {
    var _temp, _this, _ret;

    _classCallCheck(this, MonthView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.cellClick = function (e) {
      var month = e.target.innerHTML;
      if (_this.checkIfMonthDisabled(month)) return;

      var date = _this.props.date.clone().month(month);
      _this.props.prevView(date);
    }, _this.next = function () {
      var nextDate = _this.props.date.clone().add(1, 'years');
      if (_this.props.maxDate && nextDate.isAfter(_this.props.maxDate, 'day')) {
        nextDate = _this.props.maxDate;
      }
      _this.props.setDate(nextDate);
    }, _this.prev = function () {
      var prevDate = _this.props.date.clone().subtract(1, 'years');
      if (_this.props.minDate && prevDate.isBefore(_this.props.minDate, 'day')) {
        prevDate = _this.props.minDate;
      }
      _this.props.setDate(prevDate);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MonthView.prototype.checkIfMonthDisabled = function checkIfMonthDisabled(month) {
    var now = this.props.date;
    return now.clone().month(month).endOf('month').isBefore(this.props.minDate, 'day') || now.clone().month(month).startOf('month').isAfter(this.props.maxDate, 'day');
  };

  MonthView.prototype.getMonth = function getMonth() {
    var _this2 = this;

    var month = this.props.date.month();
    return moment.monthsShort().map(function (item, i) {
      return {
        label: item,
        disabled: _this2.checkIfMonthDisabled(i),
        curr: i === month
      };
    });
  };

  MonthView.prototype.render = function render() {
    var currentDate = this.props.date.format('YYYY');
    var months = this.getMonth().map(function (item, i) {
      var _class = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        month: true,
        disabled: item.disabled,
        current: item.curr
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cell__["a" /* default */], { classes: _class, key: i, value: item.label });
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'months-view' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__view_header__["a" /* default */], {
        data: currentDate,
        next: this.next,
        prev: this.prev,
        titleAction: this.props.nextView
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'datepicker-table months', onClick: this.cellClick },
        months
      )
    );
  };

  return MonthView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MonthView.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (MonthView);

/***/ }),

/***/ "./ui/DatePicker/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var _keyDownViewHelper = [{
  prev: false,
  next: true,
  exit: true,
  unit: 'day',
  upDown: 7
}, {
  prev: true,
  next: true,
  unit: 'months',
  upDown: 3
}, {
  prev: true,
  next: false,
  unit: 'years',
  upDown: 3
}];

var KEYS = {
  backspace: 8,
  enter: 13,
  esc: 27,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};

/* harmony default export */ __webpack_exports__["a"] = ({
  toDate: function toDate(date) {
    return date instanceof Date ? date : __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).toDate();
  },
  keyDownActions: function keyDownActions(code) {
    var _viewHelper = _keyDownViewHelper[this.state.currentView];
    var unit = _viewHelper.unit;

    switch (code) {
      case KEYS.left:
        this.setDate(this.state.date.subtract(1, unit));
        break;
      case KEYS.right:
        this.setDate(this.state.date.add(1, unit));
        break;
      case KEYS.up:
        this.setDate(this.state.date.subtract(_viewHelper.upDown, unit));
        break;
      case KEYS.down:
        this.setDate(this.state.date.add(_viewHelper.upDown, unit));
        break;
      case KEYS.enter:
        if (_viewHelper.prev) {
          this.prevView(this.state.date);
        }
        if (_viewHelper.exit) {
          this.setState({ isVisible: false });
        }
        break;
      case KEYS.esc:
        this.setState({ isVisible: false });
        break;
      default:
        break;
    }
  }
});

/***/ }),

/***/ "./ui/DatePicker/view-header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ViewHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



function ViewHeader(_ref) {
  var prev = _ref.prev,
      next = _ref.next,
      titleAction = _ref.titleAction,
      data = _ref.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "navigation-wrapper" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "prev", onClick: prev },
      "<"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "navigation-title", onClick: titleAction },
      data
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "next", onClick: next },
      ">"
    )
  );
}

/***/ }),

/***/ "./ui/DatePicker/year-view.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("../node_modules/moment/moment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range__ = __webpack_require__("../node_modules/moment-range/dist/moment-range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cell__ = __webpack_require__("./ui/DatePicker/cell.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_header__ = __webpack_require__("./ui/DatePicker/view-header.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var moment = Object(__WEBPACK_IMPORTED_MODULE_4_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_3_moment___default.a);

var YearsView = function (_React$Component) {
  _inherits(YearsView, _React$Component);

  function YearsView() {
    var _temp, _this, _ret;

    _classCallCheck(this, YearsView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { years: [] }, _this.cellClick = function (e) {
      var year = parseInt(e.target.innerHTML, 10);
      var date = _this.props.date.clone().year(year);
      if (_this.checkIfYearDisabled(date)) return;
      _this.props.prevView(date);
    }, _this.next = function () {
      var nextDate = _this.props.date.clone().add(10, 'years');
      if (_this.props.maxDate && nextDate.isAfter(_this.props.maxDate, 'day')) {
        nextDate = _this.props.maxDate;
      }
      _this.props.setDate(nextDate);
    }, _this.prev = function () {
      var prevDate = _this.props.date.clone().subtract(10, 'years');
      if (_this.props.minDate && prevDate.isBefore(_this.props.minDate, 'day')) {
        prevDate = _this.props.minDate;
      }
      _this.props.setDate(prevDate);
    }, _this.rangeCheck = function (currYear) {
      var years = _this.state.years;

      if (years.length == 0) {
        return false;
      }
      return years[0].label <= currYear && years[years.length - 1].label >= currYear;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  YearsView.prototype.componentWillMount = function componentWillMount() {
    this.getYears();
  };

  YearsView.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this.getYears();
  };

  YearsView.prototype.checkIfYearDisabled = function checkIfYearDisabled(year) {
    return year.clone().endOf('year').isBefore(this.props.minDate, 'day') || year.clone().startOf('year').isAfter(this.props.maxDate, 'day');
  };

  YearsView.prototype.getYears = function getYears() {
    var _this2 = this;

    var now = this.props.date;
    var start = now.clone().subtract(5, 'year');
    var end = now.clone().add(6, 'year');
    var currYear = now.year();
    var items = [];
    var inRange = this.rangeCheck(currYear);

    var years = this.state.years;


    if (years.length > 0 && inRange) {
      return years;
    }

    Array.from(moment().range(start, end).by('years')).forEach(function (year) {
      items.push({
        label: year.format('YYYY'),
        disabled: _this2.checkIfYearDisabled(year),
        curr: currYear === year.year()
      });
    });

    this.setState({ years: items });

    return items;
  };

  YearsView.prototype.render = function render() {
    var years = this.state.years;
    var currYear = this.props.date.year();
    var _class = void 0;

    var yearsCells = years.map(function (item, i) {
      _class = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        year: true,
        disabled: item.disabled,
        current: item.label == currYear
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cell__["a" /* default */], { value: item.label, classes: _class, key: i });
    });
    var currentDate = [years[0].label, years[years.length - 1].label].join('-');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'years-view' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__view_header__["a" /* default */], { data: currentDate, next: this.next, prev: this.prev }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'datepicker-table years', onClick: this.cellClick },
        yearsCells
      )
    );
  };

  return YearsView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

YearsView.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  changeView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (YearsView);

/***/ }),

/***/ "./ui/DevError/ErrorBoundary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'h1',
  null,
  'Something went wrong.'
);

var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = { hasError: false };
    return _this;
  }

  ErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error, info) {
    this.setState({ hasError: true, info: info });

    console.log(error, info);
  };

  ErrorBoundary.prototype.render = function render() {
    if (this.state.hasError) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        _ref,
        this.state.info && this.state.info.componentStack ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'pre',
          null,
          this.state.info.componentStack
        ) : null
      );
    }
    return this.props.children;
  };

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),

/***/ "./ui/Download/Download.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = download;
function download(url, filename) {
  var tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = url;
  tempLink.setAttribute('download', filename);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
}

/***/ }),

/***/ "./ui/Download/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Download_js__ = __webpack_require__("./ui/Download/Download.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Download_js__["a"]; });



/***/ }),

/***/ "./ui/Element/Divider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Divider = function Divider(props, context) {
  var inset = props.inset,
      theme = props.theme,
      other = _objectWithoutProperties(props, ['inset', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', _extends({}, other, { className: theme['divider'] }));
};

Divider.propTypes = {
  inset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Divider.defaultProps = {
  inset: false
};

Divider.contextTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),

/***/ "./ui/Element/Element.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Element = function Element(props) {
  var _props$tag = props.tag,
      Tag = _props$tag === undefined ? 'div' : _props$tag,
      theme = props.theme,
      classes = props.classes,
      attributes = _objectWithoutProperties(props, ['tag', 'theme', 'classes']);

  var cn = Array.isArray(classes) ? __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */].apply(undefined, [theme].concat(classes)) : Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, classes);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ className: cn }, attributes));
};

Element.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

/* harmony default export */ __webpack_exports__["a"] = (Element);

/***/ }),

/***/ "./ui/Element/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Element */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Column; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Flex; });
/* unused harmony export Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Divider__ = __webpack_require__("./ui/Element/Divider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Element__ = __webpack_require__("./ui/Element/Element.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var withTheme = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* getContext */])({ theme: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object });

var addSizes = function addSizes(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["c" /* mapProps */])(function (_ref) {
    var size = _ref.size,
        spacing = _ref.spacing,
        gutter = _ref.gutter,
        dir = _ref.dir,
        horz = _ref.horz,
        vert = _ref.vert,
        classes = _ref.classes,
        rest = _objectWithoutProperties(_ref, ['size', 'spacing', 'gutter', 'dir', 'horz', 'vert', 'classes']);

    return _extends({
      classes: [].concat(classes && classes || [], size && [type + '-' + size] || [type], spacing && ['bottom-margin-' + spacing] || [], gutter && ['gutter-' + gutter] || [], dir && (dir === 'vertical' && ['flex-vertical'] || ['flex-row']) || [], horz && (horz === 'left' && ['flex-left'] || horz === 'right' && ['flex-right'] || horz === 'center' && ['flex-center']) || [], vert && (vert === 'top' && ['flex-top'] || vert === 'middle' && ['flex-middle'] || vert === 'bottom' && ['flex-bottom']) || [])
    }, rest);
  });
};

var themedElement = withTheme(__WEBPACK_IMPORTED_MODULE_3__Element__["a" /* default */]);

var Container = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["f" /* withProps */])({ classes: ['container'] })(themedElement);
var Row = addSizes('flex-row')(themedElement);
var Column = addSizes('flex-column')(themedElement);
var Cell = addSizes('flex-cell')(themedElement);
var Flex = addSizes()(themedElement);




var themedDivider = withTheme(__WEBPACK_IMPORTED_MODULE_2__Divider__["a" /* default */]);


/* harmony default export */ __webpack_exports__["f"] = (__WEBPACK_IMPORTED_MODULE_3__Element__["a" /* default */]);

/***/ }),

/***/ "./ui/Form/FormFeedback.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'form-control-feedback');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes;
FormFeedback.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (FormFeedback);

/***/ }),

/***/ "./ui/Form/FormGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      color = props.color,
      check = props.check,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'color', 'check', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, color ? 'has-' + color : false, row ? 'row' : false, check ? 'form-check' : 'form-group', check && disabled ? 'disabled' : false);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),

/***/ "./ui/Form/FormText.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'small'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes;
FormText.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (FormText);

/***/ }),

/***/ "./ui/Input/AutoComplete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual__ = __webpack_require__("../node_modules/recompose/shallowEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Form_FormFeedback__ = __webpack_require__("./ui/Form/FormFeedback.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Chip_Chip_js__ = __webpack_require__("./ui/Chip/Chip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__("./ui/Input/Input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Input_Label__ = __webpack_require__("./ui/Input/Label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_domEvents__ = __webpack_require__("./helpers/domEvents.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var POSITION = {
  AUTO: 'auto',
  DOWN: 'down',
  UP: 'up'
};

var Autocomplete = function (_Component) {
  _inherits(Autocomplete, _Component);

  function Autocomplete() {
    var _temp, _this, _ret;

    _classCallCheck(this, Autocomplete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      direction: _this.props.direction,
      focus: false,
      showAllSuggestions: _this.props.showSuggestionsWhenValueIsSet,
      query: _this.props.query ? _this.props.query : _this.query(_this.props.value),
      isValueAnObject: false
    }, _this.handleChange = function (values, event) {
      var value = _this.props.multiple ? values : values[0];
      var showAllSuggestions = _this.props.showSuggestionsWhenValueIsSet;

      var query = _this.query(value);
      if (_this.props.onChange) _this.props.onChange(value, event);
      if (_this.props.keepFocusOnChange) {
        _this.setState({ query: query, showAllSuggestions: showAllSuggestions });
      } else {
        _this.setState({ focus: false, query: query, showAllSuggestions: showAllSuggestions }, function () {
          __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this).querySelector('input').blur();
        });
      }
      _this.updateQuery(query, _this.props.query);
    }, _this.handleMouseDown = function (event) {
      _this.selectOrCreateActiveItem(event);
    }, _this.handleQueryBlur = function (event) {
      if (_this.state.focus) _this.setState({ focus: false });
      if (_this.props.onBlur) _this.props.onBlur(event, _this.state.active);
    }, _this.updateQuery = function (query, notify) {
      if (notify && _this.props.onQueryChange) _this.props.onQueryChange(query);
      _this.setState({ query: query });
    }, _this.handleQueryChange = function (event) {
      var query = _this.clearQuery ? '' : event.target.value;
      _this.clearQuery = false;

      _this.updateQuery(query, true);
      _this.setState({
        showAllSuggestions: query ? false : _this.props.showSuggestionsWhenValueIsSet,
        active: null
      });
      if (_this.props.onChange && query === '') _this.props.onChange(query, event);
    }, _this.handleQueryFocus = function (event) {
      _this.suggestionsNode.scrollTop = 0;
      _this.setState({ active: '', focus: true });
      if (_this.props.onFocus) _this.props.onFocus(event);
    }, _this.handleQueryKeyDown = function (event) {
      _this.clearQuery = event.which === 8 && _this.props.showSuggestionsWhenValueIsSet && _this.state.showAllSuggestions;

      if (event.which === 13) {
        _this.selectOrCreateActiveItem(event);
      }
    }, _this.handleQueryKeyUp = function (event) {
      if (event.which === 27) __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this).querySelector('input').blur();

      if ([40, 38].indexOf(event.which) !== -1) {
        var suggestionsKeys = Array.from(_this.suggestions().keys());
        var index = suggestionsKeys.indexOf(_this.state.active) + (event.which === 40 ? +1 : -1);
        if (index < 0) index = suggestionsKeys.length - 1;
        if (index >= suggestionsKeys.length) index = 0;
        _this.setState({ active: suggestionsKeys[index] });
      }
    }, _this.handleSuggestionHover = function (event) {
      _this.setState({ active: event.target.id });
    }, _this.select = function (event, target) {
      __WEBPACK_IMPORTED_MODULE_9__helpers_domEvents__["a" /* default */].pauseEvent(event);
      var values = _this.values(_this.props.value);
      var source = _this.source();
      var newValue = target === void 0 ? event.target.id : target;

      if (_this.isValueAnObject()) {
        var newItem = Array.from(source).reduce(function (obj, _ref) {
          var k = _ref[0],
              value = _ref[1];

          if (k === newValue) {
            obj[k] = value;
          }
          return obj;
        }, {});

        if (Object.keys(newItem).length === 0 && newValue) {
          newItem[newValue] = newValue;
        }

        return _this.handleChange(Object.assign(_this.mapToObject(values), newItem), event);
      }

      _this.handleChange([newValue].concat(Array.from(values.keys())), event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Autocomplete.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!this.props.multiple) {
      var query = nextProps.query ? nextProps.query : this.query(nextProps.value);
      this.updateQuery(query, false);
    }
  };

  Autocomplete.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (!this.state.focus && nextState.focus && this.props.direction === POSITION.AUTO) {
      var direction = this.calculateDirection();
      if (this.state.direction !== direction) {
        this.setState({ direction: direction });
      }
    }
    return !__WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual___default()(this.props, nextProps) || !__WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual___default()(this.state, nextState) || !__WEBPACK_IMPORTED_MODULE_3_recompose_shallowEqual___default()(this.context, nextContext);
  };

  Autocomplete.prototype.calculateDirection = function calculateDirection() {
    if (this.props.direction === 'auto') {
      var client = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.inputNode).getBoundingClientRect();
      var screen_height = window.innerHeight || document.documentElement.offsetHeight;
      var up = client.top > screen_height / 2 + client.height;
      return up ? 'up' : 'down';
    }
    return this.props.direction;
  };

  Autocomplete.prototype.query = function query(key) {
    var query_value = '';
    if (!this.props.multiple && key) {
      var source_value = this.source().get('' + key);
      query_value = source_value || key;
    }
    return query_value;
  };

  Autocomplete.prototype.selectOrCreateActiveItem = function selectOrCreateActiveItem(event) {
    var target = this.state.active;
    if (!target) {
      target = this.props.allowCreate ? this.state.query : Array.from(this.suggestions().keys())[0];
      this.setState({ active: target });
    }
    this.select(event, target);
  };

  Autocomplete.prototype.normalise = function normalise(value) {
    var sdiak = 'áâäąáâäąččććççĉĉďđďđééěëēėęéěëēėęĝĝğğġġģģĥĥħħíîíîĩĩīīĭĭįįi̇ıĵĵķķĸĺĺļļŀŀłłĺľĺľňńņŋŋņňńŉóöôő' + 'øōōóöőôøřřŕŕŗŗššśśŝŝşşţţťťŧŧũũūūŭŭůůűűúüúüűųųŵŵýyŷŷýyžžźźżżß';
    var bdiak = 'AAAAAAAACCCCCCCCDDDDEEEEEEEEEEEEEGGGGGGGGHHHHIIIIIIIIIIIIIIJJKKKLLLLLLLLLLLLNNNNNNNNNOOOOO' + 'OOOOOOORRRRRRSSSSSSSSTTTTTTUUUUUUUUUUUUUUUUUWWYYYYYYZZZZZZS';

    var normalised = '';
    for (var p = 0; p < value.length; p++) {
      if (sdiak.indexOf(value.charAt(p)) !== -1) {
        normalised += bdiak.charAt(sdiak.indexOf(value.charAt(p)));
      } else {
        normalised += value.charAt(p);
      }
    }

    return normalised.toLowerCase().trim();
  };

  Autocomplete.prototype.suggestions = function suggestions() {
    var suggest = new Map();
    var rawQuery = this.state.query || (this.props.multiple ? '' : this.props.value);
    var query = this.normalise('' + rawQuery);
    var values = this.values();
    var source = this.source();

    if (this.props.multiple) {
      for (var _iterator = Array.from(source), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref3 = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref3 = _i.value;
        }

        var _ref2 = _ref3;
        var key = _ref2[0];
        var value = _ref2[1];

        if (!values.has(key) && this.matches(this.normalise(value), query)) {
          suggest.set(key, value);
        }
      }
    } else if (query && !this.state.showAllSuggestions) {
      for (var _iterator2 = Array.from(source), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref5 = _i2.value;
        }

        var _ref4 = _ref5;
        var _key2 = _ref4[0];
        var _value = _ref4[1];

        if (this.matches(this.normalise(_value), query)) {
          suggest.set(_key2, _value);
        }
      }
    } else {
      suggest = source;
    }

    return suggest;
  };

  Autocomplete.prototype.matches = function matches(value, query) {
    var suggestionMatch = this.props.suggestionMatch;


    if (suggestionMatch === 'disabled') {
      return true;
    } else if (suggestionMatch === 'start') {
      return value.startsWith(query);
    } else if (suggestionMatch === 'anywhere') {
      return value.includes(query);
    } else if (suggestionMatch === 'word') {
      var re = new RegExp('\\b' + query, 'g');
      return re.test(value);
    } else if (suggestionMatch === 'none') {
      return value;
    }

    return false;
  };

  Autocomplete.prototype.source = function source() {
    var src = this.props.source;

    if (src.hasOwnProperty('length')) {
      return new Map(src.map(function (item) {
        return Array.isArray(item) ? [].concat(item) : [item, item];
      }));
    }
    return new Map(Object.keys(src).map(function (key) {
      return ['' + key, src[key]];
    }));
  };

  Autocomplete.prototype.values = function values() {
    var vals = this.props.multiple ? this.props.value : this.props.value !== undefined ? [this.props.value] : [];

    if (!vals) vals = [];

    if (this.props.showSelectedWhenNotInSource && this.isValueAnObject()) {
      return new Map(Object.entries(vals));
    }

    var valueMap = new Map();

    var stringVals = vals.map(function (v) {
      return '' + v;
    });
    for (var _iterator3 = this.source(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref7;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref7 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref7 = _i3.value;
      }

      var _ref6 = _ref7;
      var k = _ref6[0];
      var v = _ref6[1];

      if (stringVals.indexOf(k) !== -1) valueMap.set(k, v);
    }

    return valueMap;
  };

  Autocomplete.prototype.unselect = function unselect(key, event) {
    if (!this.props.disabled) {
      var values = this.values(this.props.value);

      values.delete(key);

      if (this.isValueAnObject()) {
        return this.handleChange(this.mapToObject(values), event);
      }

      this.handleChange(Array.from(values.keys()), event);
    }
  };

  Autocomplete.prototype.isValueAnObject = function isValueAnObject() {
    return !Array.isArray(this.props.value) && _typeof(this.props.value) === 'object';
  };

  Autocomplete.prototype.mapToObject = function mapToObject(map) {
    return Array.from(map).reduce(function (obj, _ref8) {
      var k = _ref8[0],
          value = _ref8[1];

      obj[k] = value;
      return obj;
    }, {});
  };

  Autocomplete.prototype.renderSelected = function renderSelected() {
    var _this2 = this;

    if (this.props.multiple) {
      var selectedItems = Array.from(this.values()).map(function (_ref9) {
        var key = _ref9[0],
            value = _ref9[1];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__ui_Chip_Chip_js__["a" /* default */],
          {
            key: key,
            className: _this2.props.theme.value,
            deletable: true,
            onDeleteClick: _this2.unselect.bind(_this2, key)
          },
          value
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: this.props.theme.values },
        selectedItems
      );
    }
  };

  Autocomplete.prototype.renderSuggestions = function renderSuggestions() {
    var _this3 = this,
        _classnames2;

    var theme = this.props.theme;

    var suggestions = Array.from(this.suggestions());
    if (this.props.sort) {
      suggestions.sort(function (a, b) {
        return a[1].localeCompare(b[1]);
      });
    }
    suggestions = suggestions.map(function (_ref10) {
      var _classnames;

      var key = _ref10[0],
          value = _ref10[1];

      var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme.suggestion, (_classnames = {}, _classnames[theme.active] = _this3.state.active === key, _classnames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        {
          id: key,
          key: key,
          className: className,
          onMouseDown: _this3.handleMouseDown,
          onMouseOver: _this3.handleSuggestionHover
        },
        value
      );
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        className: theme['suggestions-container'],
        style: { position: 'absolute', width: '100%' }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme.suggestions, (_classnames2 = {}, _classnames2[theme.up] = this.state.direction === 'up', _classnames2)),
          style: { position: 'relative' },
          ref: function ref(node) {
            _this3.suggestionsNode = node;
          }
        },
        suggestions
      )
    );
  };

  Autocomplete.prototype.render = function render() {
    var _classnames3,
        _this4 = this;

    var _props = this.props,
        allowCreate = _props.allowCreate,
        error = _props.error,
        labelText = _props.labelText,
        source = _props.source,
        suggestionMatch = _props.suggestionMatch,
        query = _props.query,
        selectedPosition = _props.selectedPosition,
        keepFocusOnChange = _props.keepFocusOnChange,
        showSuggestionsWhenValueIsSet = _props.showSuggestionsWhenValueIsSet,
        showSelectedWhenNotInSource = _props.showSelectedWhenNotInSource,
        onQueryChange = _props.onQueryChange,
        theme = _props.theme,
        sort = _props.sort,
        titleProperty = _props.titleProperty,
        dispatch = _props.dispatch,
        other = _objectWithoutProperties(_props, ['allowCreate', 'error', 'labelText', 'source', 'suggestionMatch', 'query', 'selectedPosition', 'keepFocusOnChange', 'showSuggestionsWhenValueIsSet', 'showSelectedWhenNotInSource', 'onQueryChange', 'theme', 'sort', 'titleProperty', 'dispatch']);

    var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme.autocomplete, (_classnames3 = {}, _classnames3[theme.focus] = this.state.focus, _classnames3[theme['has-danger']] = error, _classnames3), this.props.className);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: className },
      this.props.selectedPosition === 'above' ? this.renderSelected() : null,
      labelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__ui_Input_Label__["a" /* default */],
        { key: 'label', htmlFor: this.props.id },
        labelText
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["a" /* default */], _extends({}, other, {
        ref: function ref(node) {
          _this4.inputNode = node;
        },
        autoComplete: 'off',
        className: theme.input,
        onBlur: this.handleQueryBlur,
        onChange: this.handleQueryChange,
        onFocus: this.handleQueryFocus,
        onKeyDown: this.handleQueryKeyDown,
        onKeyUp: this.handleQueryKeyUp,
        theme: theme,
        value: this.state.query
      })),
      this.renderSuggestions(),
      this.props.selectedPosition === 'below' ? this.renderSelected() : null,
      error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Form_FormFeedback__["a" /* default */],
        null,
        error
      ) : null
    );
  };

  return Autocomplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Autocomplete.propTypes = {
  allowCreate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'up', 'down']),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  keepFocusOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onQueryChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['above', 'below', 'none']),
  showSelectedWhenNotInSource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSuggestionsWhenValueIsSet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  suggestionMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['disabled', 'start', 'anywhere', 'word', 'none']),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    autocomplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    focus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    suggestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    suggestions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    up: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
Autocomplete.defaultProps = {
  allowCreate: false,
  className: '',
  direction: 'auto',
  keepFocusOnChange: false,
  multiple: true,
  selectedPosition: 'above',
  showSelectedWhenNotInSource: false,
  showSuggestionsWhenValueIsSet: false,
  source: {},
  suggestionMatch: 'start'
};


/* harmony default export */ __webpack_exports__["a"] = (Autocomplete);

/***/ }),

/***/ "./ui/Input/CheckBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Input_Label__ = __webpack_require__("./ui/Input/Label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_CheckBox__ = __webpack_require__("./icons/CheckBox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_CheckBoxOutlineBlank__ = __webpack_require__("./icons/CheckBoxOutlineBlank.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icons_CheckBox__["a" /* default */], { size: '2em' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons_CheckBoxOutlineBlank__["a" /* default */], { size: '2em' });

var Checkbox = function (_React$PureComponent) {
  _inherits(Checkbox, _React$PureComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({
        checked: nextProps.checked
      });
    }
  };

  Checkbox.prototype.focus = function focus() {
    this.input.focus();
  };

  Checkbox.prototype.blur = function blur() {
    this.input.blur();
  };

  Checkbox.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        className = _props.className,
        labelText = _props.labelText,
        style = _props.style,
        name = _props.name,
        type = _props.type,
        disabled = _props.disabled,
        readOnly = _props.readOnly,
        tabIndex = _props.tabIndex,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onBlur = _props.onBlur,
        autoFocus = _props.autoFocus,
        value = _props.value,
        theme = _props.theme,
        others = _objectWithoutProperties(_props, ['prefixCls', 'className', 'labelText', 'style', 'name', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value', 'theme']);

    var globalProps = Object.keys(others).reduce(function (prev, key) {
      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
        prev[key] = others[key];
      }
      return prev;
    }, {});

    var checked = this.state.checked;

    var classString = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_classNames__["a" /* default */])(theme, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classString, style: style },
      labelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__ui_Input_Label__["a" /* default */],
        { key: 'label', htmlFor: this.props.id },
        labelText
      ) : null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: theme[prefixCls + '-inner'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({
          name: name,
          type: type,
          readOnly: readOnly,
          disabled: disabled,
          tabIndex: tabIndex,
          className: prefixCls + '-input',
          checked: !!checked,
          onClick: onClick,
          onFocus: onFocus,
          onBlur: onBlur,
          onChange: this.handleChange,
          autoFocus: autoFocus,
          ref: this.saveInput,
          value: value
        }, globalProps)),
        checked ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { key: 'label2', htmlFor: this.props.id, className: 'disablepointer' },
          _ref
        ) : !checked ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { key: 'label3', htmlFor: this.props.id, className: 'disablepointer' },
          _ref2
        ) : null
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Checkbox.defaultProps = {
  prefixCls: 'checkbox',
  className: '',
  style: {},
  theme: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: _extends({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      }
    });
  };

  this.saveInput = function (node) {
    _this2.input = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),

/***/ "./ui/Input/Content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ContentEditable = function (_React$Component) {
  _inherits(ContentEditable, _React$Component);

  function ContentEditable() {
    var _temp, _this, _ret;

    _classCallCheck(this, ContentEditable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onPaste = function (evt) {
      var content = void 0;
      evt.preventDefault();
      if (evt.clipboardData) {
        content = (evt.originalEvent || evt).clipboardData.getData('text/plain');
        document.execCommand('insertText', false, content);
      } else if (window.clipboardData) {
        content = window.clipboardData.getData('Text');
        document.selection.createRange().pasteHTML(content);
      }
    }, _this.onKeyPress = function (evt) {
      if (!_this.props.textual) return;
      if (evt.charCode == 13) {
        evt.preventDefault();
      }
    }, _this.onFocus = function (evt) {
      if (!_this.props.textual || !_this.props.selectText || !(_this.lastHtml && _this.lastHtml === _this.props.selectText || _this.htmlEl.innerText === _this.props.selectText)) {
        return;
      }
      setTimeout(function () {
        var sel = void 0;
        var range = void 0;
        if (window.getSelection && document.createRange) {
          range = document.createRange();
          range.selectNodeContents(_this.htmlEl);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(_this.htmlEl);
          range.select();
        }
      }, 1);
    }, _this.emitChange = function (evt) {
      if (!_this.htmlEl) return;
      var html = _this.props.textual ? _this.htmlEl.innerText : _this.htmlEl.innerHTML;
      if (_this.props.onChange && html !== _this.lastHtml) {
        _this.props.onChange(evt, html);
      }
      _this.lastHtml = html;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ContentEditable.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        tagName = _props.tagName,
        html = _props.html,
        textual = _props.textual,
        selectText = _props.selectText,
        props = _objectWithoutProperties(_props, ['tagName', 'html', 'textual', 'selectText']);

    if (textual) {
      props.onPaste = this.onPaste;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(tagName || 'div', _extends({}, props, {
      spellCheck: false,
      ref: function ref(e) {
        return _this2.htmlEl = e;
      },
      onInput: this.emitChange,
      onBlur: this.props.onBlur || this.emitChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      contentEditable: !this.props.disabled,
      dangerouslySetInnerHTML: { __html: html }
    }));
  };

  ContentEditable.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var props = this.props,
        htmlEl = this.htmlEl;

    if (!htmlEl) {
      return true;
    }

    if (nextProps.textual) {
      if (nextProps.html !== htmlEl.innerText && nextProps.html !== props.html) {
        return true;
      }
    } else if (nextProps.html !== htmlEl.innerHTML && nextProps.html !== props.html) {
      return true;
    }

    var optional = ['style', 'className', 'disable', 'tagName'];

    return optional.some(function (name) {
      return props[name] !== nextProps[name];
    });
  };

  ContentEditable.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.htmlEl && this.props.html !== this.htmlEl.innerHTML) {
      this.htmlEl.innerHTML = this.props.html;
    }
  };

  return ContentEditable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContentEditable.propTypes = {
  textual: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ContentEditable.defaultProps = {
  textual: true
};
/* harmony default export */ __webpack_exports__["a"] = (ContentEditable);

/***/ }),

/***/ "./ui/Input/FileInput.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__("../node_modules/react-dropzone/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileInputPreview__ = __webpack_require__("./ui/Input/FileInputPreview.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_translate__ = __webpack_require__("./i18n/translate.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FileInput = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props) {
    _classCallCheck(this, FileInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var files = props.input.value || [];
    if (!Array.isArray(files)) {
      files = [files];
    }

    _this.state = {
      files: files.map(_this.transformFile)
    };
    return _this;
  }

  FileInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var files = nextProps.input.value || [];
    if (!Array.isArray(files)) {
      files = [files];
    }

    this.setState({ files: files.map(this.transformFile) });
  };

  FileInput.prototype.label = function label() {
    var _props = this.props,
        translate = _props.translate,
        placeholder = _props.placeholder,
        labelMultiple = _props.labelMultiple,
        labelSingle = _props.labelSingle;


    if (placeholder) {
      return placeholder;
    }

    if (this.props.multiple) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        translate(labelMultiple)
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      translate(labelSingle)
    );
  };

  FileInput.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        accept = _props2.accept,
        children = _props2.children,
        disableClick = _props2.disableClick,
        maxSize = _props2.maxSize,
        minSize = _props2.minSize,
        multiple = _props2.multiple,
        classes = _props2.classes,
        theme = _props2.theme;

    var styles = {};
    if (this.state.files.length && !multiple) {
      styles.background = 'transparent';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: classes },
      children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'previews' },
        this.state.files.map(function (file, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__FileInputPreview__["a" /* default */],
            {
              key: index,
              file: file,
              onRemove: _this2.onRemove(file),
              theme: theme
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
              record: file
            })
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* default */],
        {
          onDrop: this.onDrop,
          accept: accept,
          disableClick: disableClick,
          maxSize: maxSize,
          minSize: minSize,
          multiple: multiple,
          style: styles,
          className: theme['drop-zone']
        },
        multiple || !this.state.files.length ? this.label() : null
      )
    );
  };

  return FileInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FileInput.propTypes = {
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  labelMultiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelSingle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  translate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
FileInput.defaultProps = {
  addLabel: true,
  addField: true,
  labelMultiple: 'i18n.input.file.upload_several',
  labelSingle: 'i18n.input.file.upload_single',
  multiple: false,
  onUpload: function onUpload() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDrop = function (files) {
    var updatedFiles = _this3.props.multiple ? [].concat(_this3.state.files, files.map(_this3.transformFile)) : [].concat(files.map(_this3.transformFile));

    _this3.setState({ files: updatedFiles });
    _this3.props.input.onChange(updatedFiles);
  };

  this.onRemove = function (file) {
    return function () {
      var filteredFiles = _this3.state.files.filter(function (stateFile) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* shallowEqual */])(stateFile, file);
      });

      _this3.setState({ files: filteredFiles });
      _this3.props.input.onChange(filteredFiles);
    };
  };

  this.transformFile = function (file) {
    var _transformedFile;

    if (!(file instanceof File)) {
      return file;
    }

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(_this3.props.children)[0].props,
        source = _React$Children$toArr.source,
        title = _React$Children$toArr.title;


    var transformedFile = (_transformedFile = {
      rawFile: file
    }, _transformedFile[source] = file.preview, _transformedFile);

    if (title) {
      transformedFile[title] = file.name;
    }

    return transformedFile;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__i18n_translate__["a" /* default */])(FileInput));

/***/ }),

/***/ "./ui/Input/FileInputPreview.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FileInputPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_Remove__ = __webpack_require__("./icons/Remove.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FileInputPreview = function (_Component) {
  _inherits(FileInputPreview, _Component);

  function FileInputPreview(props) {
    _classCallCheck(this, FileInputPreview);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleMouseOut = function () {
      return _this.setState({ hovered: false });
    };

    _this.handleMouseOver = function () {
      return _this.setState({ hovered: true });
    };

    _this.state = {
      hovered: false
    };
    return _this;
  }

  FileInputPreview.prototype.componentWillUnmount = function componentWillUnmount() {
    var file = this.props.file;


    if (file.preview) {
      window.URL.revokeObjectURL(file.preview);
    }
  };

  FileInputPreview.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        onRemove = _props.onRemove,
        theme = _props.theme;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        style: { height: '100%' }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__ui_Button_Button__["a" /* default */],
        { classes: 'clean', onClick: onRemove, theme: theme },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icons_Remove__["a" /* default */], { color: theme['text-primary'] })
      ),
      children
    );
  };

  return FileInputPreview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FileInputPreview.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  file: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FileInputPreview.defaultProps = {
  file: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (FileInputPreview);

/***/ }),

/***/ "./ui/Input/ImageInput.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ImageInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FileInput__ = __webpack_require__("./ui/Input/FileInput.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ImageInput = function (_FileInput) {
  _inherits(ImageInput, _FileInput);

  function ImageInput() {
    _classCallCheck(this, ImageInput);

    return _possibleConstructorReturn(this, _FileInput.apply(this, arguments));
  }

  return ImageInput;
}(__WEBPACK_IMPORTED_MODULE_0__FileInput__["a" /* FileInput */]);

ImageInput.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_0__FileInput__["a" /* FileInput */].defaultProps, {
  labelMultiple: 'i18n.input.image.upload_several',
  labelSingle: 'i18n.input.image.upload_single'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__i18n_translate__["a" /* default */])(ImageInput));

/***/ }),

/***/ "./ui/Input/Input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  static: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'p',
  type: 'text'
};

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Input.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        theme = _props.theme,
        type = _props.type,
        size = _props.size,
        state = _props.state,
        tag = _props.tag,
        addon = _props.addon,
        staticInput = _props.static,
        getRef = _props.getRef,
        attributes = _objectWithoutProperties(_props, ['className', 'theme', 'type', 'size', 'state', 'tag', 'addon', 'static', 'getRef']);

    var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;

    var fileInput = type === 'file';
    var textareaInput = type === 'textarea';
    var selectInput = type === 'select';
    var Tag = selectInput || textareaInput ? type : 'input';

    var formControlClass = 'form-control';

    if (staticInput) {
      formControlClass = theme[formControlClass + '-static'];
      Tag = tag;
    } else if (fileInput) {
      formControlClass = theme[formControlClass + '-file'];
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = theme['form-check-input'];
      }
    }

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, state ? theme['form-control-' + state] : false, size ? theme['form-control-' + size] : false, formControlClass);

    if (Tag === 'input') {
      attributes.type = type;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ key: 'input' }, attributes, { ref: getRef, className: classes }));
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),

/***/ "./ui/Input/InputField.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual__ = __webpack_require__("../node_modules/recompose/shallowEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Input_InputGroup__ = __webpack_require__("./ui/Input/InputGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Input_InputGroupAddon__ = __webpack_require__("./ui/Input/InputGroupAddon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Form_FormFeedback__ = __webpack_require__("./ui/Form/FormFeedback.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Form_FormGroup__ = __webpack_require__("./ui/Form/FormGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Form_FormText__ = __webpack_require__("./ui/Form/FormText.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Input_Input__ = __webpack_require__("./ui/Input/Input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Input_Textarea__ = __webpack_require__("./ui/Input/Textarea.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input_Label__ = __webpack_require__("./ui/Input/Label.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














function isValid(value) {
  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
}

function has(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var InputField = function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    var _temp, _this, _ret;

    _classCallCheck(this, InputField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isFocused: false,
      errorText: undefined,
      hasValue: false
    }, _this.handleInputBlur = function (event) {
      _this.setState({ isFocused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleInputChange = function (event) {
      if (!has(_this.props, 'value')) {
        _this.setState({ hasValue: isValid(event.target.value) });
      }
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _this.handleInputFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }
      _this.setState({ isFocused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  InputField.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        name = _props.name,
        hintText = _props.hintText,
        labelText = _props.labelText,
        id = _props.id;


    this.setState({
      errorText: this.props.errorText,
      hasValue: isValid(this.props.value) || isValid(this.props.defaultValue)
    });
    this.uniqueId = (name || 'input') + '-' + new Date().getTime();
  };

  InputField.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.errorText !== this.props.errorText) {
      this.setState({
        errorText: nextProps.errorText
      });
    }

    if (has(nextProps, 'value')) {
      var hasValue = isValid(nextProps.value);

      this.setState({
        hasValue: hasValue
      });
    }
  };

  InputField.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !__WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual___default()(this.props, nextProps) || !__WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual___default()(this.state, nextState) || !__WEBPACK_IMPORTED_MODULE_2_recompose_shallowEqual___default()(this.context, nextContext);
  };

  InputField.prototype.getValue = function getValue() {
    return this.input ? this.input.value : undefined;
  };

  InputField.prototype.select = function select() {
    if (this.input) {
      this.input.select();
    }
  };

  InputField.prototype.focus = function focus() {
    if (this.input) {
      this.input.focus();
    }
  };

  InputField.prototype.blur = function blur() {
    if (this.input) {
      this.input.blur();
    }
  };

  InputField.prototype._isControlled = function _isControlled() {
    return has(this.props, 'value');
  };

  InputField.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        className = _props2.className,
        disabled = _props2.disabled,
        errorText = _props2.errorText,
        fullWidth = _props2.fullWidth,
        hintText = _props2.hintText,
        labelText = _props2.labelText,
        id = _props2.id,
        multiLine = _props2.multiLine,
        onBlur = _props2.onBlur,
        onChange = _props2.onChange,
        onFocus = _props2.onFocus,
        type = _props2.type,
        Icon = _props2.icon,
        addonRight = _props2.addonRight,
        rows = _props2.rows,
        maxRows = _props2.maxRows,
        other = _objectWithoutProperties(_props2, ['className', 'disabled', 'errorText', 'fullWidth', 'hintText', 'labelText', 'id', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'type', 'icon', 'addonRight', 'rows', 'maxRows']);

    var inputId = id || this.uniqueId;

    var inputProps = _extends({
      id: inputId,
      ref: function ref(elem) {
        _this2.input = elem;
      },
      disabled: this.props.disabled,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus
    }, className && { className: className });


    var InputElement = multiLine ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ui_Input_Textarea__["a" /* default */], _extends({ rows: rows, maxRows: maxRows }, other, inputProps)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Input_Input__["a" /* default */], _extends({ type: type }, other, inputProps));

    var formProps = this.state.errorText ? { color: 'danger' } : {};

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__ui_Form_FormGroup__["a" /* default */],
      _extends({}, formProps, { className: className }),
      labelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input_Label__["a" /* default */],
        { key: 'label', htmlFor: this.props.id },
        labelText
      ) : null,
      Icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__ui_Input_InputGroup__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_Input_InputGroupAddon__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, null)
        ),
        InputElement
      ) : InputElement,
      this.state.errorText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Form_FormFeedback__["a" /* default */],
        null,
        this.state.errorText
      ) : null,
      hintText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__ui_Form_FormText__["a" /* default */],
        null,
        hintText
      ) : null
    );
  };

  return InputField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

InputField.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  fullWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  hintText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  labelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  multiLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  maxRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  addonRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
InputField.defaultProps = {
  disabled: false,
  multiLine: false,
  fullWidth: false,
  addonRight: false,
  type: 'text',
  rows: 1
};


/* harmony default export */ __webpack_exports__["a"] = (InputField);

/***/ }),

/***/ "./ui/Input/InputGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (InputGroup);

/***/ }),

/***/ "./ui/Input/InputGroupAddon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-addon');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupAddon.propTypes = propTypes;
InputGroupAddon.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (InputGroupAddon);

/***/ }),

/***/ "./ui/Input/Label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp,
  push: stringOrNumberProp,
  pull: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps = {
  tag: 'label',
  widths: colWidths
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      inline = props.inline,
      disabled = props.disabled,
      size = props.size,
      htmlFor = props.for,
      attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'inline', 'disabled', 'size', 'for']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-' + (inline ? 'inline' : 'label') : false, check && inline && disabled ? 'disabled' : false, size ? 'col-form-label-' + size : false);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),

/***/ "./ui/Input/Textarea.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea() {
    var _temp, _this, _ret;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      height: 0
    }, _this.registerRef = function (el) {
      _this.el = el;
    }, _this.getLineHeight = function () {
      var _this$props = _this.props,
          maxRows = _this$props.maxRows,
          rows = _this$props.rows;

      var values = {};
      var textarea = document.createElement('textarea');
      textarea.style.padding = '0px';
      textarea.style.position = 'fixed';
      textarea.style.top = '-10000px';
      textarea.style.visibility = 'hidden';
      textarea.style.maxHeight = 'none';
      textarea.style.width = _this.el.scrollWidth + 'px';
      textarea.className = _this.el.className;
      textarea.value = ' ';
      textarea.rows = 1;

      _this.el.parentNode.insertBefore(textarea, _this.el);
      var paddingAndBorder = textarea.offsetHeight - textarea.scrollHeight;
      values.lineHeight = textarea.scrollHeight;
      textarea.value = _this.el.value;
      textarea.rows = _this.el.rows;
      values.autoHeight = textarea.scrollHeight + paddingAndBorder;
      textarea.remove();

      if (rows !== null || maxRows !== null) {
        if (rows !== null) {
          values.minHeight = values.lineHeight * rows + paddingAndBorder;
          values.autoHeight = Math.max(values.minHeight, values.autoHeight);
        }
        if (maxRows !== null) {
          values.maxHeight = values.lineHeight * maxRows + paddingAndBorder;
          values.autoHeight = Math.min(values.maxHeight, values.autoHeight);
        }
      }

      values.rowCount = Math.floor(values.autoHeight / values.lineHeight);

      return values;
    }, _this.autoGrow = function (text) {
      var el = _this.el;
      if (!el) return;
      var offset = !window.opera ? el.offsetHeight - el.clientHeight : el.offsetHeight + parseInt(window.getComputedStyle(el, null).getPropertyValue('border-top-width'), 10);
      el.style.height = 'auto';
      var height = Math.max(_this.state.minHeight, el.scrollHeight + offset);
      if (_this.state.maxHeight) {
        el.style.height = Math.min(_this.state.maxHeight, height);
      } else {
        el.style.height = height + 'px';
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TextArea.prototype.componentDidMount = function componentDidMount() {
    var sizes = this.getLineHeight();
    this.setState(sizes);
    setTimeout(this.autoGrow);
  };

  TextArea.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.autoGrow();
    }
  };

  TextArea.prototype.render = function render() {
    var _props = this.props,
        maxRows = _props.maxRows,
        rows = _props.rows,
        labelText = _props.labelText,
        style = _props.style,
        attributes = _objectWithoutProperties(_props, ['maxRows', 'rows', 'labelText', 'style']);

    var styles = _extends({
      height: this.state.autoHeight
    }, style);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', _extends({ ref: this.registerRef, style: styles, onInput: this.autoGrow }, attributes));
  };

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextArea.defaultProps = {
  maxRows: null,
  rows: null
};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),

/***/ "./ui/Input/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InputFieldRedux; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckBoxRedux; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputField__ = __webpack_require__("./ui/Input/InputField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckBox__ = __webpack_require__("./ui/Input/CheckBox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput__ = __webpack_require__("./ui/Input/FileInput.js");
/* unused harmony reexport FileInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileInputPreview__ = __webpack_require__("./ui/Input/FileInputPreview.js");
/* unused harmony reexport FileInputPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImageInput__ = __webpack_require__("./ui/Input/ImageInput.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__ImageInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Input__ = __webpack_require__("./ui/Input/Input.js");
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroup__ = __webpack_require__("./ui/Input/InputGroup.js");
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupAddon__ = __webpack_require__("./ui/Input/InputGroupAddon.js");
/* unused harmony reexport InputGroupAddon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Label__ = __webpack_require__("./ui/Input/Label.js");
/* unused harmony reexport Label */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var InputFieldRedux = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["c" /* mapProps */])(function (_ref) {
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      inputProps = _objectWithoutProperties(_ref.input, []),
      props = _objectWithoutProperties(_ref, ['meta', 'input']);

  return _extends({
    errorText: touched && error
  }, inputProps, props, {
    fullWidth: true
  });
})(__WEBPACK_IMPORTED_MODULE_1__InputField__["a" /* default */]);

var CheckBoxRedux = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["c" /* mapProps */])(function (_ref2) {
  var _ref2$meta = _ref2.meta;
  _ref2$meta = _ref2$meta === undefined ? {} : _ref2$meta;

  var touched = _ref2$meta.touched,
      error = _ref2$meta.error,
      inputProps = _objectWithoutProperties(_ref2.input, []),
      props = _objectWithoutProperties(_ref2, ['meta', 'input']);

  var value = props.values ? Object.entries(props.values).find(function (o) {
    return o[1] === inputProps.value;
  }) : !!inputProps.value;

  var checked = props.values ? value && value[1] || false : value;
  return _extends({
    errorText: touched && error
  }, inputProps, props, {
    checked: checked
  });
})(__WEBPACK_IMPORTED_MODULE_2__CheckBox__["a" /* default */]);



















/***/ }),

/***/ "./ui/Modal/Modal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Modal */
/* unused harmony export mapStateToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_ReactTransitionGroup__ = __webpack_require__("./ui/ReactTransitionGroup/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_cloneReactChildren__ = __webpack_require__("./helpers/cloneReactChildren.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_Remove__ = __webpack_require__("./icons/Remove.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_ClickAwayListener__ = __webpack_require__("./ui/ClickAwayListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















function FirstChild(props) {
  var childrenArray = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(props.children);
  return childrenArray[0] || null;
}

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_Remove__["a" /* default */], { size: '40' });

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleOnOutsideClick = function (e) {
      if (!_this.props.params.sticky) {
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__state_actions_modal__["a" /* hideModal */])());
      }
    }, _this.removeModal = function (e) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__state_actions_modal__["a" /* hideModal */])());
    }, _this.mapParts = function (parts, record) {
      return parts.map(function (part) {
        return part.startsWith('$') ? function (property) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: property, key: property },
            record[property]
          );
        }.call(this, part.substring(1)) : part;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        transition = _props.transition,
        params = _props.params;

    var type = params.type,
        record = params.record,
        size = params.size,
        hideClose = params.hideClose,
        sticky = params.sticky,
        buttons = params.buttons,
        buttonActions = params.buttonActions,
        rest = _objectWithoutProperties(params, ['type', 'record', 'size', 'hideClose', 'sticky', 'buttons', 'buttonActions']);

    var title = rest.title,
        content = rest.content;


    var visible = Object.keys(this.props.params).length !== 0;
    var transitionName = {
      enter: theme['modal-enter'],
      enterActive: theme['modal-enter-active'],
      leave: theme['modal-leave'],
      leaveActive: theme['modal-leave-active']
    };

    if (record) {
      var $parts = title.split(/(\$[A-z]+)/);
      if ($parts.length > 1) {
        title = this.mapParts($parts, record);
      }

      $parts = content.split(/(\$[A-z]+)/);
      if ($parts.length > 1) {
        content = this.mapParts($parts, record);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__ui_ReactTransitionGroup__["a" /* CSSTransitionGroup */],
      _extends({}, transition, { transitionName: transitionName }),
      visible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['modal'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['modal-scroll'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__ui_ClickAwayListener__["a" /* default */],
            { onClickAway: this.handleOnOutsideClick },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme['modal-content'], theme['modal-' + (size || 'medium')])
              },
              title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: theme['modal-header'] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  title
                )
              ) : null,
              !hideClose ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                {
                  type: 'button',
                  className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme['modal-close'], theme['modal-icon-cancel']),
                  onClick: this.removeModal
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Tooltip__["b" /* default */],
                  { content: 'Close modal', theme: theme },
                  _ref
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: theme['modal-body'] },
                content || ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: theme['modal-footer'] },
                buttons ? Object(__WEBPACK_IMPORTED_MODULE_7__helpers_cloneReactChildren__["a" /* default */])(buttons, { theme: theme }) : null,
                buttonActions ? buttonActions.map(function (buttonAction, idx) {
                  var _this2 = this;

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9__ui_Button__["a" /* Button */],
                    {
                      key: idx,
                      onClick: function onClick() {
                        _this2.props.dispatch(buttonAction.action());
                        _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__state_actions_modal__["a" /* hideModal */])());
                      }
                    },
                    buttonAction.label
                  );
                }, this) : null
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: theme['modal-shadow'] })
      ) : null
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Modal.defaultProps = {
  transition: {
    leave: false,
    enter: true,
    component: FirstChild,
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300
  }
};
function mapStateToProps(state) {
  var _state$ui$modal = state.ui.modal,
      _state$ui$modal$param = _state$ui$modal.params,
      params = _state$ui$modal$param === undefined ? {} : _state$ui$modal$param,
      visible = _state$ui$modal.visible;

  for (var _len2 = arguments.length, ownProps = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    ownProps[_key2 - 1] = arguments[_key2];
  }

  return _extends({
    visible: visible,
    params: params
  }, ownProps);
}

var enhance = __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps), __WEBPACK_IMPORTED_MODULE_6__i18n_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(Modal));

/***/ }),

/***/ "./ui/Modal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__("./ui/Modal/Modal.js");



var themedModal = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */]);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */]);

/***/ }),

/***/ "./ui/NavLink/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rudy_match_path__ = __webpack_require__("../node_modules/rudy-match-path/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rudy_match_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rudy_match_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router_link__ = __webpack_require__("../node_modules/redux-first-router-link/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_first_router_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toUrl__ = __webpack_require__("./ui/NavLink/toUrl.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var NavLink = function NavLink(_ref, _ref2) {
  var store = _ref2.store;

  var to = _ref.to,
      href = _ref.href,
      pathname = _ref.pathname,
      className = _ref.className,
      style = _ref.style,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === undefined ? 'active' : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      _ref$ariaCurrent = _ref.ariaCurrent,
      ariaCurrent = _ref$ariaCurrent === undefined ? 'true' : _ref$ariaCurrent,
      exact = _ref.exact,
      strict = _ref.strict,
      isActive = _ref.isActive,
      includeQuery = _ref.includeQuery,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === undefined ? 'li' : _ref$tag,
      props = _objectWithoutProperties(_ref, ['to', 'href', 'pathname', 'className', 'style', 'activeClassName', 'activeStyle', 'ariaCurrent', 'exact', 'strict', 'isActive', 'includeQuery', 'tag']);

  to = href || to;
  var state = store.getState();
  var location = Object(__WEBPACK_IMPORTED_MODULE_4_redux_first_router__["selectLocationState"])(state);
  var path = Object(__WEBPACK_IMPORTED_MODULE_6__toUrl__["a" /* default */])(to, location.routesMap).split('?')[0];
  var match = __WEBPACK_IMPORTED_MODULE_3_rudy_match_path___default()(pathname, { path: path, exact: exact, strict: strict });
  var active = !!(isActive ? isActive(match, location) : match);

  if (includeQuery) {
    var current = state.rest[includeQuery].list.params;
    var defaultParams = current.default;
    to.query = _extends({}, current.sort && current.sort !== defaultParams.sort && { sort: current.sort }, current.order && current.order !== defaultParams.order && { order: current.order }, current.page && current.page != defaultParams.page && { page: current.page }, current.perPage && current.perPage != defaultParams.perPage && { perPage: current.perPage });
  }

  var combinedClassName = active ? [className, activeClassName].filter(function (i) {
    return i;
  }).join(' ') : className;

  var combinedStyle = active ? _extends({}, style, activeStyle) : style;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    { className: combinedClassName, style: combinedStyle },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_first_router_link___default.a, _extends({ to: to, 'aria-current': active && ariaCurrent }, props))
  );
};

NavLink.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var mapState = function mapState(state) {
  return { pathname: Object(__WEBPACK_IMPORTED_MODULE_4_redux_first_router__["selectLocationState"])(state).pathname };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapState)(NavLink));

/***/ }),

/***/ "./ui/NavLink/toUrl.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = (function (to, routesMap) {
  if (to && typeof to === 'string') {
    return to;
  } else if (Array.isArray(to)) {
    return '/' + to.join('/');
  } else if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object') {
    var action = to;

    try {
      var _getOptions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__["getOptions"])(),
          querySerializer = _getOptions.querySerializer;

      return Object(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__["actionToPath"])(action, routesMap, querySerializer);
    } catch (e) {
      console.warn('[redux-first-router-link] could not create path from action:', action, 'For reference, here are your current routes:', routesMap);

      return '#';
    }
  }

  console.warn('[redux-first-router-link] `to` prop must be a string, array or action object. You provided:', to);
  return '#';
});

/***/ }),

/***/ "./ui/Notification/Snackbar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ClickAwayListener__ = __webpack_require__("./ui/ClickAwayListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_translate__ = __webpack_require__("./i18n/translate.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Snackbar = function (_React$Component) {
  _inherits(Snackbar, _React$Component);

  function Snackbar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      snack: null,
      visible: false
    }, _this.showSnack = function (snack) {
      _this.hideSnack().then(function () {
        _this.setState({ snack: snack, visible: false });
        setTimeout(function () {
          _this.setState({ visible: true });
          if (snack.data.timeout) {
            _this.snackTimer = setTimeout(function () {
              _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__state_actions_notification__["a" /* hideNotification */])(snack.id));
            }, snack.data.timeout);
          }
        }, 1);
      });
    }, _this.hideSnack = function () {
      if (!_this.state.snack) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        _this.clearDismissTimer();
        _this.setState({ visible: false });
        _this.afterTransition = function () {
          _this.setState({ snack: null });
          resolve();
        };
      });
    }, _this.clearDismissTimer = function () {
      if (_this.snackTimer) {
        clearTimeout(_this.snackTimer);
        _this.snackTimer = null;
      }
    }, _this.transitionEndHandler = function () {
      if (_this.afterTransition) {
        _this.afterTransition();
        _this.afterTransition = null;
      }
    }, _this.buttonClickHandler = function () {
      var onButtonClick = _this.props.onButtonClick;
      var snack = _this.state.snack;
      var id = snack.id,
          _snack$data$button = snack.data.button,
          button = _snack$data$button === undefined ? {} : _snack$data$button;


      if (onButtonClick) {
        onButtonClick(snack);
      } else if (button.action && typeof button.action === 'function') {
        button.action(snack);
      } else if (button.action === 'redirect' && button.href) {
        window.location.href = button.href;
      }

      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__state_actions_notification__["a" /* hideNotification */])(id));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Snackbar.prototype.componentDidMount = function componentDidMount() {
    if (this.props.snack) {
      this.showSnack(this.props.snack);
    }
  };

  Snackbar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var snack = this.props.snack;
    var nextSnack = nextProps.snack;
    var visibleSnack = this.state.snack;
    var isInactive = this.props.inactive;
    var willInactivate = nextProps.inactive;
    if (!willInactivate && (nextSnack && !snack || nextSnack && nextSnack.id !== (snack || {}).id)) {
      this.showSnack(nextSnack);
    } else if (isInactive && !willInactivate && snack && !visibleSnack) {
      this.showSnack(snack);
    } else if (!isInactive && willInactivate && visibleSnack) {
      this.hideSnack();
    } else if (!nextSnack && snack) {
      this.hideSnack();
    }
  };

  Snackbar.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDismissTimer();
  };

  Snackbar.prototype.render = function render() {
    var _classNames;

    var snack = this.state.snack;

    if (!snack) {
      return null;
    }
    var _props = this.props,
        theme = _props.theme,
        translate = _props.translate;

    var button = (snack.data.button || {}).text ? snack.data.button : null;
    var largeScreen = window.matchMedia('(min-width: 720px)').matches;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_ClickAwayListener__["a" /* default */],
      { onClickAway: this.buttonClickHandler },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(theme['notification'], (_classNames = {}, _classNames[theme['notification-large']] = largeScreen, _classNames[theme['notification-visible']] = this.state.visible, _classNames)),
          onTransitionEnd: this.transitionEndHandler
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: theme['notification-label'] },
          snack.text.startsWith('i18n.') ? translate(snack.text) : snack.text
        ),
        button ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: theme['notification-button'], onClick: this.buttonClickHandler },
          button.label
        ) : null
      )
    );
  };

  return Snackbar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Snackbar.propTypes = {
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


function mapStateToProps(state, props) {
  return { snack: state.ui.notification.queue[0] || null };
}

var enhance = __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps), __WEBPACK_IMPORTED_MODULE_7__i18n_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(Snackbar));

/***/ }),

/***/ "./ui/Notification/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Notification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Snackbar__ = __webpack_require__("./ui/Notification/Snackbar.js");



var themedNotification = Object(__WEBPACK_IMPORTED_MODULE_0__ui_Theme_themed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Snackbar__["a" /* default */]);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__Snackbar__["a" /* default */]);

/***/ }),

/***/ "./ui/Pagination/Pagination.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Pagination = function Pagination(props) {
  var _classNames;

  var className = props.className,
      theme = props.theme,
      size = props.size,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'theme', 'size', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, theme['pagination'], (_classNames = {}, _classNames[theme['pagination-' + size]] = !!size, _classNames));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

Pagination.defaultProps = {
  tag: 'ul'
};

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),

/***/ "./ui/Pagination/PaginationItem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var PaginationItem = function PaginationItem(props) {
  var _classNames;

  var active = props.active,
      className = props.className,
      theme = props.theme,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['active', 'className', 'theme', 'disabled', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, theme['page-item'], (_classNames = {}, _classNames[theme['active']] = active, _classNames[theme['disabled']] = disabled, _classNames));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

PaginationItem.defaultProps = {
  tag: 'li'
};

/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),

/***/ "./ui/Pagination/PaginationLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      next = props.next,
      theme = props.theme,
      previous = props.previous,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'next', 'theme', 'previous', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, theme['page-link']);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { 'aria-hidden': 'true', key: 'caret' },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'sr-only', key: 'sr' },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes, 'aria-label': ariaLabel }),
    children
  );
};

PaginationLink.propTypes = propTypes;
PaginationLink.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PaginationLink);

/***/ }),

/***/ "./ui/RTE/Medium.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_medium_editor__ = __webpack_require__("../node_modules/medium-editor/dist/js/medium-editor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_medium_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_medium_editor_dist_css_medium_editor_min_css__ = __webpack_require__("../node_modules/medium-editor/dist/css/medium-editor.min.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_medium_editor_dist_css_medium_editor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_medium_editor_dist_css_medium_editor_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_plugin_medium_rte_css__ = __webpack_require__("./styles/plugin/medium-rte.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_plugin_medium_rte_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_plugin_medium_rte_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_media_svg_format_bold_svg__ = __webpack_require__("../node_modules/raw-loader/index.js!./media/svg/format_bold.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_media_svg_format_bold_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_media_svg_format_bold_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_media_svg_format_italic_svg__ = __webpack_require__("../node_modules/raw-loader/index.js!./media/svg/format_italic.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_media_svg_format_italic_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_media_svg_format_italic_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_media_svg_format_list_bulleted_svg__ = __webpack_require__("../node_modules/raw-loader/index.js!./media/svg/format_list_bulleted.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_media_svg_format_list_bulleted_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_media_svg_format_list_bulleted_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_media_svg_format_list_numbered_svg__ = __webpack_require__("../node_modules/raw-loader/index.js!./media/svg/format_list_numbered.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_media_svg_format_list_numbered_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_media_svg_format_list_numbered_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_media_svg_insert_link_svg__ = __webpack_require__("../node_modules/raw-loader/index.js!./media/svg/insert_link.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_media_svg_insert_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_media_svg_insert_link_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MediumEditor = function (_Component) {
  _inherits(MediumEditor, _Component);

  function MediumEditor() {
    var _temp, _this, _ret;

    _classCallCheck(this, MediumEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.content = _this.props.value, _this.componentDidMount = function () {
      var options = _this.props.options;

      _this.medium = new __WEBPACK_IMPORTED_MODULE_1_medium_editor___default.a(_this.editor, options);
      _this.medium.setContent(_this.content);
      _this.medium.subscribe('editableInput', _this.onChange);
      _this.medium.subscribe('focus', _this.onFocus);
    }, _this.componentDidUpdate = function () {
      _this.medium.restoreSelection();
    }, _this.componentWillUnmount = function () {
      _this.medium.destroy();
    }, _this.onFocus = function (evt) {
      if (!_this.props.selectText || !(_this.content && _this.content === _this.props.selectText || _this.editor.innerHTML === _this.props.selectText)) {
        return;
      }
      console.log('selecting');
      setTimeout(function () {
        _this.medium.selectAllContents();
      }, 1);
    }, _this.onChange = function (evt) {
      var content = _this.editor.innerHTML;

      if (content.includes('"font-size: 1.6em; letter-spacing: 0.01em;"')) {
        content = content.replace(/ style="font-size: 1\.6em; letter-spacing: 0\.01em;"/g, '').replace('\n', '').replace('\r', '');

        _this.medium.saveSelection();
        _this.editor.innerHTML = content;

        _this.medium.restoreSelection();
      }
      if (content !== _this.content) {
        _this.content = content;
        _this.props.onChange(content.replace(/\n|\r/g, ''));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MediumEditor.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value.replace(/\n|\r/g, '') === this.content.replace(/\n|\r/g, '')) return false;
    return true;
  };

  MediumEditor.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        Tag = _props.tag,
        value = _props.value,
        onChange = _props.onChange,
        options = _props.options,
        selectText = _props.selectText,
        props = _objectWithoutProperties(_props, ['tag', 'value', 'onChange', 'options', 'selectText']);

    if (this.medium) {
      this.medium.saveSelection();

      if (this.props.flushEditorDOM) {
        this.medium.setContent(this.props.value);
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      ref: function ref(element) {
        _this2.editor = element;
      }
    }, props));
  };

  return MediumEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MediumEditor.defaultProps = {
  tag: 'div',
  value: '<p>Click to edit text!</p>',
  onChange: function onChange() {},
  options: {
    spellcheck: false,
    disableDoubleReturn: true,
    disableExtraSpaces: false,
    toolbar: {
      buttons: [{ name: 'bold', contentDefault: __WEBPACK_IMPORTED_MODULE_4__raw_loader_media_svg_format_bold_svg___default.a }, { name: 'italic', contentDefault: __WEBPACK_IMPORTED_MODULE_5__raw_loader_media_svg_format_italic_svg___default.a }, { name: 'anchor', contentDefault: __WEBPACK_IMPORTED_MODULE_8__raw_loader_media_svg_insert_link_svg___default.a }, { name: 'orderedlist', contentDefault: __WEBPACK_IMPORTED_MODULE_7__raw_loader_media_svg_format_list_numbered_svg___default.a }, { name: 'unorderedlist', contentDefault: __WEBPACK_IMPORTED_MODULE_6__raw_loader_media_svg_format_list_bulleted_svg___default.a }]
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MediumEditor);

/***/ }),

/***/ "./ui/ReactTransitionGroup/CSSTransitionGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionGroup__ = __webpack_require__("./ui/ReactTransitionGroup/TransitionGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CSSTransitionGroupChild__ = __webpack_require__("./ui/ReactTransitionGroup/CSSTransitionGroupChild.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__("./ui/ReactTransitionGroup/utils/PropTypes.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var propTypes = {
  transitionName: __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* nameShape */].isRequired,

  transitionAppear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transitionAppearTimeout: Object(__WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* transitionTimeout */])('Appear'),
  transitionEnterTimeout: Object(__WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* transitionTimeout */])('Enter'),
  transitionLeaveTimeout: Object(__WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* transitionTimeout */])('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CSSTransitionGroupChild__["a" /* default */], {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TransitionGroup__["a" /* default */], Object.assign({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes = propTypes;
CSSTransitionGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CSSTransitionGroup);

/***/ }),

/***/ "./ui/ReactTransitionGroup/CSSTransitionGroupChild.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__ = __webpack_require__("./helpers/transitionProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__("./ui/ReactTransitionGroup/utils/PropTypes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var events = [];
if (__WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__["c" /* transitionEnd */]) events.push(__WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__["c" /* transitionEnd */]);
if (__WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__["a" /* animationEnd */]) events.push(__WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__["a" /* animationEnd */]);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  name: __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* nameShape */].isRequired,

  appear: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  enter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  leave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  appearTimeout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  enterTimeout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  leaveTimeout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    node.classList.add(className);

    this.queueClassAndNode(activeClassName, node);

    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      node.classList.remove(className, activeClassName);

      if (removeListeners) removeListeners();

      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (__WEBPACK_IMPORTED_MODULE_0__helpers_transitionProperties__["c" /* transitionEnd */]) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = requestAnimationFrame(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        obj.node.scrollTop;

        obj.node.classList.add(obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (CSSTransitionGroupChild);

/***/ }),

/***/ "./ui/ReactTransitionGroup/TransitionGroup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_chainFunction__ = __webpack_require__("./helpers/chainFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__ = __webpack_require__("./ui/ReactTransitionGroup/utils/ChildMapping.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  childFactory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["a" /* getChildMapping */])(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["a" /* getChildMapping */])(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["a" /* getChildMapping */])(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = Object.assign({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["a" /* getChildMapping */])(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["a" /* getChildMapping */])(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: Object(__WEBPACK_IMPORTED_MODULE_3__utils_ChildMapping__["b" /* mergeChildMappings */])(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

        if (factoryChild === child && isCallbackRef) {
          ref = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_chainFunction__["a" /* default */])(child.ref, ref);
        }

        childrenToRender.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    var props = Object.assign({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes = propTypes;
TransitionGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),

/***/ "./ui/ReactTransitionGroup/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransitionGroup__ = __webpack_require__("./ui/ReactTransitionGroup/CSSTransitionGroup.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CSSTransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransitionGroup__ = __webpack_require__("./ui/ReactTransitionGroup/TransitionGroup.js");
/* unused harmony reexport TransitionGroup */





/***/ }),

/***/ "./ui/ReactTransitionGroup/utils/ChildMapping.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeChildMappings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "./ui/ReactTransitionGroup/utils/PropTypes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transitionTimeout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nameShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    if (props[enabledPropName]) {
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + " wasn't supplied to CSSTransitionGroup: " + "this can cause unreliable animations and won't be supported in " + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  enter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  leave: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  active: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  enter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  enterActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  leave: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  leaveActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  appear: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  appearActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
})]);

/***/ }),

/***/ "./ui/Table/Row.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tableTheme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  selectable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'tr',
  tableTheme: {}
};

var TableRow = function TableRow(props) {
  var className = props.className,
      tableTheme = props.tableTheme,
      Tag = props.tag,
      selectable = props.selectable,
      attributes = _objectWithoutProperties(props, ['className', 'tableTheme', 'tag', 'selectable']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, tableTheme['table']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

TableRow.propTypes = propTypes;
TableRow.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),

/***/ "./ui/Table/Table.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Table = function Table(props) {
  var className = props.className,
      theme = props.theme,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      hover = props.hover,
      Tag = props.tag,
      attributes = _objectWithoutProperties(props, ['className', 'theme', 'size', 'bordered', 'striped', 'inverse', 'hover', 'tag']);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, theme['table'], bordered ? theme['table-bordered'] : false, striped ? theme['table-striped'] : false, inverse ? theme['table-inverse'] : false, hover ? theme['table-hover'] : false);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Table.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

Table.defaultProps = {
  tag: 'table'
};

/* unused harmony default export */ var _unused_webpack_default_export = (Table);

/***/ }),

/***/ "./ui/Table/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__("./ui/Table/Table.js");
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__("./ui/Table/Row.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Row__["a"]; });



/***/ }),

/***/ "./ui/Theme/ThemeProvider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_mobi_theme_css__ = __webpack_require__("./styles/mobi/theme.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_mobi_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_mobi_theme_css__);






var withIThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["e" /* withContext */])({ theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, function () {
  return { theme: __WEBPACK_IMPORTED_MODULE_3__styles_mobi_theme_css___default.a };
});

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
};

/* harmony default export */ __webpack_exports__["a"] = (withIThemeContext(ThemeProvider));

/***/ }),

/***/ "./ui/Theme/themed.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");



/* harmony default export */ __webpack_exports__["a"] = (function (Component) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* getContext */])({ theme: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object })(Component);
});

/***/ }),

/***/ "./ui/Tooltip/Tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.timer = false, _this._mounted = false, _this.state = { visible: false }, _this.state = {
      visible: false
    }, _this.timer = false, _this.toggle = function (visible) {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }
      _this.timer = setTimeout(function () {
        if (_this.state.visible !== visible) _this.setVisibility(visible);
      }, 10);
    }, _this.setVisibility = function (visible) {
      if (_this._mounted) {
        _this.setState({ visible: visible });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tooltip.prototype.componentWillMount = function componentWillMount() {
    this._mounted = true;
  };

  Tooltip.prototype.componentWillUnmount = function componentWillUnmount() {
    this._mounted = false;
  };

  Tooltip.prototype.capitalize = function capitalize(s) {
    return s[0].toUpperCase() + s.toLowerCase().slice(1);
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        children = _props.children,
        content = _props.content,
        state = this.state,
        toggle = this.toggle;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      {
        onMouseEnter: function onMouseEnter() {
          return toggle(true);
        },
        onMouseLeave: function onMouseLeave() {
          return toggle(false);
        },
        onClick: function onClick() {
          return toggle(false);
        },
        className: theme['tooltip-wrapper']
      },
      children,
      state.visible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme.tooltip },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['tooltip-content'] },
          this.capitalize(content)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['tooltip-arrow'] },
          ' '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['tooltip-gap'] },
          ' '
        )
      ) : null
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),

/***/ "./ui/Tooltip/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themedTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("../node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tooltip__ = __webpack_require__("./ui/Tooltip/Tooltip.js");




var withTheme = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* getContext */])({ theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object });

var themedTooltip = withTheme(__WEBPACK_IMPORTED_MODULE_2__Tooltip__["a" /* default */]);

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_2__Tooltip__["a" /* default */]);


/***/ }),

/***/ "./view/Components/Components.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_Datagrid__ = __webpack_require__("./ui/DataTable/Datagrid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_DataTable_List__ = __webpack_require__("./ui/DataTable/List.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Data__ = __webpack_require__("./ui/Data/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_pad__ = __webpack_require__("./helpers/pad.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_Delete__ = __webpack_require__("./icons/Delete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icons_Edit__ = __webpack_require__("./icons/Edit.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Data__["f" /* IndexField */], { label: 'Nr.', width: 'calc(2.3rem + 3em)', sortable: false, format: __WEBPACK_IMPORTED_MODULE_11__helpers_pad__["a" /* default */] });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Data__["g" /* TextField */], { source: 'identifier', label: 'Identifier' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_7__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Edit component' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icons_Edit__["a" /* default */], { size: '2.5em' })
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_7__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Delete component' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__icons_Delete__["a" /* default */], { size: '2.5em' })
);

var Components = function (_Component) {
  _inherits(Components, _Component);

  function Components() {
    var _temp, _this, _ret;

    _classCallCheck(this, Components);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.close = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_modal__["a" /* hideModal */])());
    }, _this.delete = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_data__["c" /* crudDelete */])('components', record.id, false, { message: record.title + ' deleted.' }));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_modal__["a" /* hideModal */])());
    }, _this.edit = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__state_actions_routes__["b" /* routeComponentsEdit */])(record.id));
    }, _this.remove = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_modal__["b" /* showModal */])({
        title: 'Permanently delete $title?',
        record: record,
        content: 'This will permanently delete $title from the component list and ' + 'it will no logner be accessible to anyone. All related items will ' + 'remain. This action is irreversible.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'danger', key: 'delete', onClick: function onClick() {
              return _this.delete(record);
            } },
          'Delete'
        )]
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Components.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        startingNo = _props.startingNo,
        props = _objectWithoutProperties(_props, ['theme', 'startingNo']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Element__["e" /* Row */],
        { spacing: 'double' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__ui_DataTable_List__["a" /* default */],
            _extends({}, props, { resource: 'components', title: false }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_Datagrid__["a" /* default */],
              { startingNo: startingNo },
              _ref,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Button__["c" /* EditButton */], { source: 'title', title: false, click: this.edit, theme: theme }),
              _ref2,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__ui_Button__["b" /* ButtonGroup */],
                { width: '10rem', label: 'Manage' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__ui_Data__["c" /* ButtonField */],
                  {
                    tag: 'div',
                    sortable: false,
                    click: this.edit,
                    classes: ['flex-center', 'flex-middle']
                  },
                  _ref3
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', sortable: false, click: this.remove },
                  _ref4
                )
              )
            )
          )
        )
      )
    );
  };

  return Components;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  return {
    startingNo: (state.rest.components.list.params.page - 1) * state.rest.components.list.params.perPage
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Components));

/***/ }),

/***/ "./view/Components/editComponents.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Image, JPG, PNG',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    'min. size 360 x 360 px'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'DROP IMAGE TO UPLOAD'
  )
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'title',
  labelText: 'Component Name:',
  component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
  placeholder: 'Component name',
  id: 'title'
});

var EditComponents = function (_Component) {
  _inherits(EditComponents, _Component);

  function EditComponents() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditComponents);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        _ref2
      );
    }, _this.saveComponent = function (record) {
      if (_this.props.id) {
        _this.props.crudUpdate('components', _this.props.id, record, _this.props.initialValues, false, {
          message: (record.title || _this.props.initialValues.title) + ' updated.'
        });
      } else {
        _this.props.crudCreate('components', record, false, {
          message: (record.title || _this.props.initialValues.title) + ' created.'
        });
      }
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EditComponents.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting;

    var disabled = !!this.props.id;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: handleSubmit(this.saveComponent) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__ui_Card__["a" /* Card */],
            { classes: ['v-padding-large', 'colored-card'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__ui_Element__["e" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
                null,
                _ref3,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                  name: 'identifier',
                  labelText: 'Component Identifier:',
                  component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                  placeholder: 'Component identifier (should not be changed)..',
                  id: 'identifier',
                  disabled: disabled
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                  name: 'code',
                  labelText: 'Inky code:',
                  className: theme['text-mono'],
                  style: { whiteSpace: 'pre' },
                  component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                  multiLine: true,
                  autoCorrect: 'off',
                  placeholder: '<Inky code />',
                  id: 'code'
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return EditComponents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  var componentId = state.location.payload.id;
  return {
    id: componentId,
    initialValues: state.rest.components.data[componentId],
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__["a" /* goToPage */],
  crudUpdate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["g" /* crudUpdate */],
  crudCreate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["b" /* crudCreate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'editComponents',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['full_name', 'position', 'email', 'phone'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(EditComponents));

/***/ }),

/***/ "./view/Components/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components__ = __webpack_require__("./view/Components/Components.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Components__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editComponents__ = __webpack_require__("./view/Components/editComponents.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__editComponents__["a"]; });





/***/ }),

/***/ "./view/Contacts/Contacts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__ = __webpack_require__("./ui/DataTable/Datagrid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__ = __webpack_require__("./ui/DataTable/List.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Data__ = __webpack_require__("./ui/Data/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_UserOff__ = __webpack_require__("./icons/UserOff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_Edit__ = __webpack_require__("./icons/Edit.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Empty = function Empty() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '50px', height: '2.5em', display: 'inline-block' } });
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["a" /* AvatarField */], { source: 'picture', fallback: 'full_name', letter: true });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["g" /* TextField */], { source: 'position' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Inactive' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_UserOff__["a" /* default */], { width: '2.5em', height: '2.5em' })
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Empty, null);

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Edit contact' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icons_Edit__["a" /* default */], { size: '2.5em' })
);

var Contacts = function (_Component) {
  _inherits(Contacts, _Component);

  function Contacts() {
    var _temp, _this, _ret;

    _classCallCheck(this, Contacts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.close = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_modal__["a" /* hideModal */])());
    }, _this.delete = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_data__["c" /* crudDelete */])('contacts', record.id, false, { message: record.full_name + ' deleted.' }));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_modal__["a" /* hideModal */])());
    }, _this.edit = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["c" /* routeContactsEdit */])(record.id));
    }, _this.remove = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_modal__["b" /* showModal */])({
        title: 'Permanently delete $full_name?',
        record: record,
        content: 'This will permanently delete $full_name from the contact list and ' + 'it will no logner be accessible to anyone. All related items will ' + 'remain. This action is irreversible.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_Button__["a" /* Button */],
          { classes: 'danger', key: 'delete', onClick: function onClick() {
              return _this.delete(record);
            } },
          'Delete'
        )]
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Contacts.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        props = _objectWithoutProperties(_props, ['theme']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Element__["e" /* Row */],
        { spacing: 'double' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__["a" /* default */],
            _extends({}, props, { resource: 'contacts', title: false }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__ui_Data__["d" /* CombinedField */],
                { label: 'Contacts', cellName: 'contact', className: theme['contact-col'] },
                _ref,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["d" /* CombinedField */],
                  {
                    className: theme['flex-vertical'] + ' ' + theme['flex-grow'] + ' ' + theme['text-left']
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Button__["c" /* EditButton */], { source: 'full_name', title: false, click: this.edit, theme: theme }),
                  _ref2
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__ui_Button__["b" /* ButtonGroup */],
                { width: '10rem', label: 'Manage' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["b" /* BooleanField */], {
                  source: 'disabled',
                  compare: function compare(rec) {
                    return rec.disabled && rec.disabled === 1;
                  },
                  whenTrue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      className: theme['flex-middle'] + ' ' + theme['flex-center'] + ' ' + theme['button-clean'] + ' ' + theme['button']
                    },
                    _ref3
                  ),
                  whenFalse: _ref4
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  {
                    tag: 'div',
                    sortable: false,
                    click: this.edit,
                    classes: ['flex-center', 'flex-middle']
                  },
                  _ref5
                )
              )
            )
          )
        )
      )
    );
  };

  return Contacts;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Contacts);

/***/ }),

/***/ "./view/Contacts/editContact.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Image, JPG, PNG',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    'min. size 360 x 360 px'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'DROP IMAGE TO UPLOAD'
  )
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
  { size: '66' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'full_name',
    labelText: 'Full name:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Full name',
    id: 'full_name'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'position',
    labelText: 'Position:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Contact position',
    id: 'position'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'email',
    labelText: 'E-Mail address:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'you@elovade.com',
    id: 'email'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'phone',
    labelText: 'Phone:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Phone',
    id: 'phone'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'disabled',
    labelText: 'Inactive:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["a" /* CheckBox */],

    id: 'disabled'
  })
);

var EditContact = function (_Component) {
  _inherits(EditContact, _Component);

  function EditContact() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveContact = function (record) {
      _this.props.crudUpdate('contacts', _this.props.id, record, _this.props.initialValues, false, {
        message: (record.full_name || _this.props.initialValues.full_name) + ' updated.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EditContact.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: handleSubmit(this.saveContact) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
                  { size: '33', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'picture',
                    component: this.renderImage,
                    classes: theme['square-box'],
                    id: 'picture'
                  })
                ),
                _ref2
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return EditContact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  var contactId = state.location.payload.id;
  return {
    id: contactId,
    initialValues: state.rest.contacts.data[contactId],
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__["a" /* goToPage */],
  crudUpdate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["g" /* crudUpdate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'editContact',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['full_name', 'position', 'email', 'phone'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(EditContact));

/***/ }),

/***/ "./view/Contacts/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contacts__ = __webpack_require__("./view/Contacts/Contacts.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Contacts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editContact__ = __webpack_require__("./view/Contacts/editContact.js");
/* unused harmony reexport editContact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__newContact__ = __webpack_require__("./view/Contacts/newContact.js");
/* unused harmony reexport newContact */







/***/ }),

/***/ "./view/Contacts/newContact.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Image, JPG, PNG',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    'min. size 360 x 360 px'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'DROP IMAGE TO UPLOAD'
  )
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
  { size: '66' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'full_name',
    labelText: 'Full name:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Full name',
    id: 'full_name'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'position',
    labelText: 'Position:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Contact position',
    id: 'position'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'email',
    labelText: 'E-Mail address:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'you@elovade.com',
    id: 'email'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'phone',
    labelText: 'Phone:',
    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
    placeholder: 'Phone',
    id: 'phone'
  })
);

var NewContact = function (_Component) {
  _inherits(NewContact, _Component);

  function NewContact() {
    var _temp, _this, _ret;

    _classCallCheck(this, NewContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveContact = function (record) {
      _this.props.crudCreate('contacts', record, false, {
        message: (record.full_name || _this.props.initialValues.full_name) + ' created.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  NewContact.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: handleSubmit(this.saveContact) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9__ui_Element__["a" /* Cell */],
                  { size: '33', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'picture',
                    component: this.renderImage,
                    classes: theme['square-box'],
                    id: 'picture'
                  })
                ),
                _ref2
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return NewContact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  return {
    data: state.form.newContact && state.form.newContact.values || {},
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__["a" /* goToPage */],
  crudCreate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["b" /* crudCreate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'newContact',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['full_name', 'position', 'email', 'phone'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(NewContact));

/***/ }),

/***/ "./view/Dashboard/Dashboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_first_router_link__ = __webpack_require__("../node_modules/redux-first-router-link/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_first_router_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_first_router_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_DataTable_Datagrid__ = __webpack_require__("./ui/DataTable/Datagrid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_DataTable_List__ = __webpack_require__("./ui/DataTable/List.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_generateUUID__ = __webpack_require__("./helpers/generateUUID.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_selectors__ = __webpack_require__("./state/selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Data__ = __webpack_require__("./ui/Data/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_pad__ = __webpack_require__("./helpers/pad.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__state_types_routes__ = __webpack_require__("./state/types/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Search__ = __webpack_require__("./view/Dashboard/Search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__icons_Delete__ = __webpack_require__("./icons/Delete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__icons_MailDownload__ = __webpack_require__("./icons/MailDownload.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__icons_Add__ = __webpack_require__("./icons/Add.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__media_svg_icon_lock_svg__ = __webpack_require__("./media/svg/icon-lock.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__media_svg_icon_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__media_svg_icon_lock_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Search__["a" /* default */], null);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["f" /* IndexField */], { label: 'Nr.', width: 'calc(2.3rem + 3em)', sortable: false, format: __WEBPACK_IMPORTED_MODULE_12__helpers_pad__["a" /* default */] });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["g" /* TextField */], { source: 'product_title', label: 'Product' });

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["g" /* TextField */], { source: 'edited_by.full_name', tag: 'div' });

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["e" /* DateField */], { source: 'created_at', label: 'Created', locales: 'de', width: '7em' });

var _ref6 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["e" /* DateField */], { source: 'scheduled_at', label: 'Scheduled', locales: 'de', width: '8em' });

var _ref7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["h" /* TypeField */], { source: 'status', width: '9em', localize: true });

var _ref8 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_11__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Duplicate newsletter' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__icons_Add__["a" /* default */], { size: '2.5em' })
);

var _ref9 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_11__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Download template' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__icons_MailDownload__["a" /* default */], { size: '2.5em' })
);

var _ref10 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_11__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Delete newsletter' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__icons_Delete__["a" /* default */], { size: '2.5em' })
);

var Dashboard = function (_Component) {
  _inherits(Dashboard, _Component);

  function Dashboard() {
    var _temp, _this, _ret;

    _classCallCheck(this, Dashboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.close = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["a" /* hideModal */])());
    }, _this.remove = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["b" /* showModal */])({
        title: 'Permanently delete $title?',
        record: record,
        content: 'This will permanently delete $title from the newsletter list and ' + 'it will no logner be accessible to anyone. All related items will ' + 'remain. This action is irreversible.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
          { classes: 'danger', key: 'delete', onClick: function onClick() {
              return _this.delete(record);
            } },
          'Delete'
        )]
      }));
    }, _this.duplicateModal = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["b" /* showModal */])({
        title: 'Duplicate $title?',
        record: record,
        content: 'Selected newsletter and its content will be duplicated.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
          { classes: 'success', key: 'duplicate', onClick: function onClick() {
              return _this.duplicate(record);
            } },
          'Ok'
        )]
      }));
    }, _this.duplicate = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__state_actions_data__["b" /* crudCreate */])('newsletters', _extends({}, record, {
        title: 'Copy of ' + record.title,
        data: record.data ? record.data.map(function (el) {
          return _extends({}, el, {
            id: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_generateUUID__["a" /* default */])()
          });
        }) : [] }), null, {
        message: 'Copy of ' + record.title + ' created.'
      }));


      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["a" /* hideModal */])());
      setTimeout(function () {
        location.reload();
      }, 400);
      _this.forceUpdate();
    }, _this.delete = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__state_actions_data__["c" /* crudDelete */])('newsletters', record.id, null, { message: record.title + ' deleted.' }));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["a" /* hideModal */])());
    }, _this.edit = function (record) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!force && record.edited_lock && _this.props.currentUserId !== record.edited_by.id) {
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["b" /* showModal */])({
          title: 'Take over editing of $title?',
          record: record,
          content: 'This will take over editing of the $title from ' + record.edited_by.full_name + '.',
          buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
            { classes: 'inverted', key: 'cancel', onClick: _this.close },
            'Cancel'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
            {
              classes: 'inverted',
              key: 'preview',
              onClick: function onClick() {
                _this.preview(record);
                _this.close();
              }
            },
            'Preview'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__ui_Button__["a" /* Button */],
            { classes: 'success', key: 'edit', onClick: function onClick() {
                return _this.edit(record, true);
              } },
            'Take over'
          )]
        }));
      } else if (record.status !== 'in-progress') {
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["a" /* hideModal */])());
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__state_actions_routes__["f" /* routeNewslettersEdit */])(record.id));
      } else {
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__state_actions_modal__["a" /* hideModal */])());
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__state_actions_routes__["a" /* goToPage */])(__WEBPACK_IMPORTED_MODULE_13__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */], null, { id: record.id, step: 'build' }));
      }
    }, _this.download = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__state_actions_data__["a" /* checkTemplate */])(record.id));
    }, _this.preview = function (record) {
      fetch("https://newsletter.elovade.com" + '/api/build/check/' + record.id).then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response.text();
        }
        return Promise.reject();
      }).then(function (data) {
        window.open("https://newsletter.elovade.com" + '/newsletters/' + String(record.id).padStart(4, '0') + '/' + data, 'preview');
      }).catch(function (err) {
        console.log(err);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Dashboard.prototype.render = function render() {
    var _props = this.props,
        dispatch = _props.dispatch,
        statistics = _props.statistics,
        locale = _props.locale,
        currentUserId = _props.currentUserId,
        theme = _props.theme,
        props = _objectWithoutProperties(_props, ['dispatch', 'statistics', 'locale', 'currentUserId', 'theme']);

    var datetimeOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Element__["e" /* Row */],
        { spacing: 'double' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__ui_Card__["a" /* Card */],
            { skipHeader: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__ui_Element__["e" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
                { size: '25', classes: 'bordered-box' },
                'EMAILS',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  statistics.emails
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_redux_first_router_link___default.a,
                  { to: { type: __WEBPACK_IMPORTED_MODULE_13__state_types_routes__["j" /* ROUTE_NEWSLETTERS_NEW */] } },
                  'Build newsletter'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
                { size: '25', classes: 'bordered-box' },
                'PRODUCTS',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  statistics.products
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_redux_first_router_link___default.a,
                  { to: { type: __WEBPACK_IMPORTED_MODULE_13__state_types_routes__["m" /* ROUTE_PRODUCTS_NEW */] } },
                  'Create new product'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
                { size: '25', classes: 'bordered-box' },
                'COMPONENTS',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  statistics.components
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_redux_first_router_link___default.a,
                  { to: { type: __WEBPACK_IMPORTED_MODULE_13__state_types_routes__["a" /* ROUTE_COMPONENTS */] } },
                  'View components'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
                { size: '25', classes: 'bordered-box' },
                'TEMPLATES',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  statistics.templates
                ),
                'Soon'
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Element__["e" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__ui_DataTable_List__["a" /* default */],
            _extends({}, props, {
              resource: 'newsletters',
              title: 'Newsletters',
              filters: _ref
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__ui_DataTable_Datagrid__["a" /* default */],
              { startingNo: this.props.startingNo },
              _ref2,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Button__["c" /* EditButton */], { source: 'title', title: false, click: this.edit, theme: theme }),
              _ref3,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__ui_Data__["d" /* CombinedField */],
                {
                  label: 'Edited',
                  cellName: 'edited',
                  className: theme['flex-col'] + ' ' + theme['position-relative']
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["b" /* BooleanField */], {
                  source: 'edited_by',
                  compare: function compare(rec) {
                    return rec.edited_lock && rec.edited_by.id !== currentUserId;
                  },
                  whenTrue: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__media_svg_icon_lock_svg___default.a, { className: theme['lock-icon'] })
                }),
                _ref4,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data__["e" /* DateField */], {
                  source: 'edited_at',
                  label: 'Edited',
                  locales: 'de',
                  width: '7em',
                  options: datetimeOptions
                })
              ),
              _ref5,
              _ref6,
              _ref7,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__ui_Button__["b" /* ButtonGroup */],
                { width: '120px', label: 'Manage' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', width: '2.5em', sortable: false, click: this.duplicateModal },
                  _ref8
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', width: '2.5em', sortable: false, click: this.download },
                  _ref9
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', width: '2.5em', sortable: false, click: this.remove },
                  _ref10
                )
              )
            )
          )
        )
      )
    );
  };

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  return {
    params: Object(__WEBPACK_IMPORTED_MODULE_6__state_selectors__["c" /* getListParams */])('newsletters')(state),
    statistics: state.rest.statistics.data,
    currentUserId: state.auth.user.id,
    startingNo: (state.rest.newsletters.list.params.page - 1) * state.rest.newsletters.list.params.perPage
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Dashboard));

/***/ }),

/***/ "./view/Dashboard/Search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Filter__ = __webpack_require__("./ui/DataTable/Filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Data_TextInput__ = __webpack_require__("./ui/Data/TextInput.js");





var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ui_Data_TextInput__["a" /* default */], { label: 'Search', source: 'search', alwaysOn: true, placeholder: 'Search' });

var SearchFilter = function SearchFilter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Filter__["a" /* default */],
    props,
    _ref
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchFilter);

/***/ }),

/***/ "./view/Dashboard/addContent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_svg_block_akademie_svg__ = __webpack_require__("./media/svg/block-akademie.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_svg_block_akademie_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media_svg_block_akademie_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_svg_block_akademie_header_svg__ = __webpack_require__("./media/svg/block-akademie-header.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_svg_block_akademie_header_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__media_svg_block_akademie_header_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_svg_block_img_text_svg__ = __webpack_require__("./media/svg/block-img+text.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_svg_block_img_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__media_svg_block_img_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_svg_img_text_no_cta_svg__ = __webpack_require__("./media/svg/img-text-no-cta.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_svg_img_text_no_cta_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__media_svg_img_text_no_cta_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_svg_block_image_svg__ = __webpack_require__("./media/svg/block-image.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_svg_block_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_svg_block_image_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_svg_block_infothek_svg__ = __webpack_require__("./media/svg/block-infothek.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_svg_block_infothek_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__media_svg_block_infothek_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__media_svg_block_text_svg__ = __webpack_require__("./media/svg/block-text.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__media_svg_block_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__media_svg_block_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__media_svg_block_text_cta_svg__ = __webpack_require__("./media/svg/block-text-cta.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__media_svg_block_text_cta_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__media_svg_block_text_cta_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_svg_close_svg__ = __webpack_require__("./media/svg/close.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__media_svg_close_svg__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__media_svg_close_svg___default.a, { fill: 'currentColor', width: '40', height: '40' });

var addContent = function (_Component) {
  _inherits(addContent, _Component);

  function addContent() {
    var _temp, _this, _ret;

    _classCallCheck(this, addContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      selected: []
    }, _this.select = function (item) {
      var selected = Array.from(_this.state.selected);
      if (selected.includes(item)) {
        selected.splice(selected.indexOf(item), 1);
      } else {
        selected.push(item);
      }
      _this.setState({ selected: selected });
    }, _this.addNew = function () {
      _this.props.addNew(_this.state.selected);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  addContent.prototype.render = function render() {
    var _this2 = this;

    var theme = this.props.theme;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__ui_Element__["b" /* Column */],
      { classes: ['flex', 'add-component'] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["e" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse-item') },
            'Select items'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse-item', 'left-margin-auto') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__ui_Button__["a" /* Button */],
              {
                classes: 'success',
                styles: ['va-middle', 'right-margin-24'],
                onClick: this.addNew
              },
              'Add Selected'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__ui_Button__["a" /* Button */],
              { classes: 'clean', styles: 'va-middle', onClick: this.props.goBuild },
              _ref
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__ui_Element__["e" /* Row */],
        {
          classes: ['flex-wrap', 'narrow-container', 'margin-0-auto', 'padding-top-80', 'text-center']
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__media_svg_block_text_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Text only')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Text only');
            }
          }),
          'Card / Text only'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__media_svg_block_text_cta_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Text only + CTA')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Text only + CTA');
            }
          }),
          'Card / Text only + CTA'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__media_svg_block_img_text_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Image + Text')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Image + Text');
            }
          }),
          'Card / Image + Text'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__media_svg_img_text_no_cta_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Image + Text (no CTA)')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Image + Text (no CTA)');
            }
          }),
          'Card / Image + Text (no CTA)'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__media_svg_block_image_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Image')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Image');
            }
          }),
          'Card / Image'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__media_svg_block_akademie_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Akademie')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Akademie');
            }
          }),
          'Card / Akademie'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__media_svg_block_akademie_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Akademie custom')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Akademie custom');
            }
          }),
          'Card / Akademie custom'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__media_svg_block_akademie_header_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Akademie + header')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Akademie + header');
            }
          }),
          'Card / Akademie + header'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__media_svg_block_infothek_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Infothek')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Infothek');
            }
          }),
          'Card / Infothek'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__ui_Element__["a" /* Cell */],
          { size: '33', classes: ['flex-middle', 'flex-column', 'margin-bottom-48'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__media_svg_block_infothek_svg___default.a, {
            fill: 'currentColor',
            width: '210',
            height: '250',
            className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'new-content', {
              'new-content-selected': this.state.selected.includes('Card / Infothek + Icons')
            }),
            onClick: function onClick(e) {
              return _this2.select('Card / Infothek + Icons');
            }
          }),
          'Card / Infothek + Icons'
        )
      )
    );
  };

  return addContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (addContent);

/***/ }),

/***/ "./view/Dashboard/buildLayout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__ = __webpack_require__("../node_modules/react-beautiful-dnd/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Blocks__ = __webpack_require__("./ui/Blocks/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_svg_icon_add_svg__ = __webpack_require__("./media/svg/icon-add.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_svg_icon_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__media_svg_icon_add_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var getListStyle = function getListStyle(isDraggingOver) {
  return {};
};
var getItemStyle = function getItemStyle(draggableStyle, isDragging) {
  return _extends({
    userSelect: 'none'

  }, draggableStyle);
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  'Start by adding the first contenct block'
);

var buildLayout = function (_Component) {
  _inherits(buildLayout, _Component);

  function buildLayout() {
    _classCallCheck(this, buildLayout);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  buildLayout.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        items = _props.items,
        addNew = _props.addNew,
        newsletterId = _props.newsletterId,
        onChange = _props.onChange,
        onDragEnd = _props.onDragEnd,
        onDragStart = _props.onDragStart,
        onSelect = _props.onSelect,
        selected = _props.selected,
        duplicateBlock = _props.duplicateBlock,
        removeBlock = _props.removeBlock;


    if (items.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'card', 'block-card') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'card-body', 'with-header') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'card-content', 'text-center'),
                onClick: function onClick(e) {
                  return addNew();
                },
                style: { cursor: 'pointer' }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__media_svg_icon_add_svg___default.a, { fill: 'currentColor', width: '70', height: '70', className: theme['add-icon'] }),
              _ref
            )
          )
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["DragDropContext"],
      { onDragStart: onDragStart, onDragEnd: onDragEnd },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["Droppable"],
        { droppableId: 'droppable' },
        function (provided, snapshot) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { ref: provided.innerRef, style: getListStyle(snapshot.isDraggingOver) },
            items.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["Draggable"],
                { key: item.id, draggableId: item.id },
                function (provided, snapshot) {
                  var onMouseDown = function onMouseDown(event) {
                    if (event.target.nodeName !== 'INPUT') {
                      provided.dragHandleProps.onMouseDown(event);
                    }
                  };

                  var onKeyDown = function onKeyDown(event) {
                    if (event.target.nodeName !== 'INPUT') {
                      provided.dragHandleProps.onKeyDown(event);
                    }
                  };

                  var patched = _extends({}, provided.dragHandleProps, {
                    onMouseDown: onMouseDown,
                    onKeyDown: onKeyDown
                  });
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      {
                        ref: provided.innerRef,
                        className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'block-wraper'),
                        style: getItemStyle(provided.draggableStyle, snapshot.isDragging)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ui_Blocks__["a" /* Block */], {
                        item: item,
                        active: selected && item && selected.id === item.id,
                        header: item.header,
                        onChange: onChange,
                        onRemove: removeBlock,
                        onDuplicate: duplicateBlock,
                        onClick: onSelect,
                        newsletterId: newsletterId,
                        theme: theme,
                        handle: patched
                      })
                    ),
                    provided.placeholder
                  );
                }
              );
            }),
            provided.placeholder
          );
        }
      )
    );
  };

  return buildLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__i18n_translate__["a" /* default */])(buildLayout));

/***/ }),

/***/ "./view/Dashboard/editNewsletter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_classNames__ = __webpack_require__("./helpers/classNames.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router_link__ = __webpack_require__("../node_modules/redux-first-router-link/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_first_router_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_first_router_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_types_routes__ = __webpack_require__("./state/types/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__setupNewsletter__ = __webpack_require__("./view/Dashboard/setupNewsletter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buildLayout__ = __webpack_require__("./view/Dashboard/buildLayout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__addContent__ = __webpack_require__("./view/Dashboard/addContent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_generateUUID__ = __webpack_require__("./helpers/generateUUID.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_Blocks_Edit__ = __webpack_require__("./ui/Blocks/Edit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__icons_AddCircle__ = __webpack_require__("./icons/AddCircle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__ = __webpack_require__("./state/types/defaultLabel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__icons_TriangleRight__ = __webpack_require__("./icons/TriangleRight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__media_svg_mail_setup_svg__ = __webpack_require__("./media/svg/mail-setup.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__media_svg_mail_setup_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__media_svg_mail_setup_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__media_svg_mail_layout_svg__ = __webpack_require__("./media/svg/mail-layout.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__media_svg_mail_layout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__media_svg_mail_layout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__media_svg_close_svg__ = __webpack_require__("./media/svg/close.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__media_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__media_svg_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_fastDeepEqual__ = __webpack_require__("./helpers/fastDeepEqual.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































var reorder = function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);

  var _result$splice = result.splice(startIndex, 1),
      removed = _result$splice[0];

  result.splice(endIndex, 0, removed);

  return result;
};

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__media_svg_mail_setup_svg___default.a, { fill: 'currentColor', width: '40', height: '40' }),
  'Setup newsletter'
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__media_svg_mail_layout_svg___default.a, { fill: 'currentColor', width: '40', height: '40' }),
  'Build layout'
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__media_svg_mail_setup_svg___default.a, { fill: 'currentColor', width: '40', height: '40' }),
  'Setup newsletter'
);

var _ref6 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__media_svg_mail_layout_svg___default.a, { fill: 'currentColor', width: '40', height: '40' }),
  'Build layout'
);

var _ref7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_5_redux_first_router_link___default.a,
  { to: '/' },
  'Newsletters'
);

var _ref8 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__icons_TriangleRight__["a" /* default */], { size: '.6em' });

var _ref9 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__media_svg_close_svg___default.a, { fill: 'currentColor', width: '40', height: '40' });

var _ref11 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__icons_AddCircle__["a" /* default */], null);

var _ref12 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);

var EditNewsletter = function (_Component) {
  _inherits(EditNewsletter, _Component);

  function EditNewsletter() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditNewsletter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      items: _this.props.data,
      editedItem: 0,
      images: {},
      selected: null
    }, _this.dragging = false, _this.formRef = null, _this.emptyListState = false, _this.onEditBlock = function (item, type, value) {
      var additionalStates = {};
      if (type === 'current') {
        _this.setState({ editedItem: value });
        return;
      } else if (type === 'numItems' && _this.state.editedItem >= value) {
        additionalStates.editedItem = value - 1;
      }

      var images = Object.assign({}, _this.state.images);
      var items = _this.state.items.reduce(function (acc, val) {
        var _ref2;

        if (['Card / Akademie', 'Card / Akademie custom', 'Card / Akademie + header'].includes(item.type)) {
          var _ref;

          var data = [];
          if (type === 'numItems') {
            if (item.data && Array.isArray(item.data)) {
              if (item.data.length > value) {
                data = item.data.slice(0, value);
              } else {
                data = item.data.slice(0);

                for (var i = item.data.length; i < value; i++) {
                  data.push({
                    header: '',
                    text: '',
                    buttontext: '',
                    buttonurl: ''
                  });
                }
              }
            } else {
              for (var _i = 0; _i < value; _i++) {
                data.push({
                  header: '',
                  text: '',
                  buttontext: '',
                  buttonurl: ''
                });
              }
            }
            return [].concat(acc, [_extends({}, val, item.id === val.id && { data: data })]);
          } else {
            if (Array.isArray(type)) {
              var index = type[0],
                  field = type[1];

              data = item.data.slice(0);
              data[index][field] = value;
              return [].concat(acc, [_extends({}, val, item.id === val.id && { data: data })]);
            }
          }
          return [].concat(acc, [_extends({}, val, item.id === val.id && (_ref = {}, _ref[type] = value, _ref))]);
        } else if (item.type === 'Card / Infothek' || item.type === 'Card / Infothek + Icons') {
          var _data = [];
          if (type === 'numItems') {
            if (item.data && Array.isArray(item.data)) {
              if (item.data.length > value) {
                _data = item.data.slice(0, value);
              } else {
                _data = item.data.slice(0);

                for (var _i2 = item.data.length; _i2 < value; _i2++) {
                  var dummyObj = { linkurl: '', linktext: '' };
                  if (item.type === 'Card / Infothek + Icons') {
                    dummyObj.linktext = '';
                    dummyObj.linktype = 'play';
                    dummyObj.linkurl = '';
                  }
                  _data.push(dummyObj);
                }
              }
            } else {
              for (var _i3 = 0; _i3 < value; _i3++) {
                var _dummyObj = { linkurl: '', linktext: '' };
                if (item.type === 'Card / Infothek + Icons') {
                  _dummyObj.linktext = '';
                  _dummyObj.linktype = 'play';
                  _dummyObj.linkurl = '';
                }
                _data.push(_dummyObj);
              }
            }
            return [].concat(acc, [_extends({}, val, item.id === val.id && { data: _data })]);
          } else if (Array.isArray(type)) {
            var _index = type[0],
                _field = type[1];

            _data = item.data.slice(0);
            _data[_index][_field] = value;
            return [].concat(acc, [_extends({}, val, item.id === val.id && { data: _data })]);
          }
        }
        return [].concat(acc, [_extends({}, val, item.id === val.id && (_ref2 = {}, _ref2[type] = value, _ref2))]);
      }, []);

      _this.setState(_extends({
        items: items,
        selected: items.find(function (i) {
          return i.id === item.id;
        }),
        images: images
      }, additionalStates));
    }, _this.onSelectBlock = function (item, e) {
      if (_this.dragging) {
        return false;
      }
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      _this.setState({
        selected: item,
        editedItem: 0
      });
    }, _this.removeBlock = function (e, id) {
      e.preventDefault();
      e.stopPropagation();

      var items = Array.from(_this.state.items).filter(function (item) {
        return item.id !== id;
      });
      var additionalState = {};
      if (_this.state.selected && _this.state.selected.id === id) {
        additionalState.selected = null;
      }
      if (!items.length) {
        _this.emptyListState = true;
      }
      _this.setState(_extends({ items: items }, additionalState));
    }, _this.addNew = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.pageType, null, { id: _this.props.id, step: 'add' }));
    }, _this.newBlock = function (types) {
      var items = Array.from(_this.state.items);
      types.forEach(function (type) {
        var item = { id: Object(__WEBPACK_IMPORTED_MODULE_15__helpers_generateUUID__["a" /* default */])(), type: type };
        if (item.type === 'Card / Text only') {
          item.header = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["b" /* HEADER */];
          item.text = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["e" /* RTE */];
        } else if (item.type === 'Card / Image') {
          item.buttonlink = '';
          item.buttontext = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["a" /* BUTTON */];
        } else if (item.type === 'Card / Image + Text (no CTA)') {
          item.header = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["b" /* HEADER */];
          item.text = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["e" /* RTE */];
        } else if (item.type === 'Card / Image + Text') {
          item.header = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["b" /* HEADER */];
          item.text = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["e" /* RTE */];
          item.buttonlink = '';
          item.buttontext = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["a" /* BUTTON */];
        } else if (item.type === 'Card / Infothek') {
          item.header = __WEBPACK_IMPORTED_MODULE_19__state_types_defaultLabel__["b" /* HEADER */];
        }
        items.push(item);
      });
      _this.emptyListState = false;

      _this.setState(_extends({ items: items }, types.length === 1 && { selected: [].concat(items).pop() }));
      _this.goBuild();
    }, _this.duplicateBlock = function (id) {
      var items = Array.from(_this.state.items);
      var item = items.find(function (item) {
        return item.id === id;
      });
      items.splice(items.indexOf(item) + 1, 0, _extends({}, item, { id: Object(__WEBPACK_IMPORTED_MODULE_15__helpers_generateUUID__["a" /* default */])() }));
      _this.emptyListState = false;
      _this.setState({ items: items });
    }, _this.onDragStart = function (result) {
      _this.dragging = true;
    }, _this.onDragEnd = function (result) {
      _this.dragging = false;

      if (!result.destination) {
        return;
      }

      _this.setState({
        items: reorder(_this.state.items, result.source.index, result.destination.index)
      });
    }, _this.closeModal = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["a" /* hideModal */])());
      _this.goBack(true);
    }, _this.goBack = function (force) {
      if (force || (!Object.keys(_this.props.currentValues).length || JSON.stringify(_this.props.currentValues) === JSON.stringify(_this.props.initialValues)) && JSON.stringify(_this.props.data) === JSON.stringify(_this.state.items)) {
        _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
      } else {
        _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["b" /* showModal */])({
          title: 'Save before closing?',
          record: _this.props.currentValues,
          content: 'You can choose to save or cancel all the changes made on the $title newsletter.',
          buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
            {
              theme: _this.props.theme,
              classes: 'inverted',
              key: 'cancel',
              onClick: _this.closeModal
            },
            'Cancel changes & close'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
            {
              theme: _this.props.theme,
              classes: 'success',
              key: 'save',
              onClick: function onClick() {
                _this.saveNewsletter(false);
                _this.closeModal(true);
              }
            },
            'Save and close'
          )]
        }));
      }
    }, _this.goBuild = function (save) {
      _this.props.dispatch(_this.props.goToPage(_this.props.pageType, null, { id: _this.props.id, step: 'build' }));
    }, _this.getMenu = function () {
      var view = _this.props.step;
      var pageType = _this.props.pageType;
      var goToPage = _this.props.goToPage;
      var dispatch = _this.props.dispatch;
      var id = _this.props.id;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__ui_Element__["b" /* Column */],
        { classes: 'newsletter-edit-sidebar' },
        view === 'build' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: _this.props.theme['sidebar-inactive'],
              onClick: function onClick() {
                return dispatch(goToPage(pageType, null, { id: id }));
              }
            },
            _ref3
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: _this.props.theme['sidebar-active'] },
            _ref4
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: _this.props.theme['sidebar-active'],
              onClick: function onClick() {
                return dispatch(goToPage(pageType, null, { id: id }));
              }
            },
            _ref5
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: _this.props.theme['sidebar-inactive'],
              onClick: function onClick() {
                return _this.saveNewsletter(false, {
                  redirectTo: { type: __WEBPACK_IMPORTED_MODULE_6__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */], step: 'build' },
                  buildLayout: true
                });
              }
            },
            _ref6
          )
        )
      );
    }, _this.saveNewsletter = function (preview, meta) {
      if (_this.props.id) {
        if (JSON.stringify(_this.props.currentValues) === JSON.stringify(_this.props.initialValues) && JSON.stringify(_this.props.data) === JSON.stringify(_this.state.items)) {
          if (!preview) {
            if (meta) {
              _this.goBuild();
            }

            if (!meta.buildLayout) {
              _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__state_actions_notification__["b" /* showNotification */])(_this.props.id, 'Nothing to save, there were no changes'));
            }
          }
        } else {
          if (meta && meta.buildLayout) {
            delete meta.buildLayout;
          }

          _this.props.crudUpdate('newsletters', _this.props.id, _extends({ data: _this.state.items }, _this.props.currentValues), _extends({ data: _this.props.data }, _this.props.initialValues), null, _extends({}, meta, {
            message: (_this.props.currentValues.title || _this.props.initialValues.title) + ' saved.'
          }, preview && { message: false }));
        }
      } else {
        var _this$props;

        (_this$props = _this.props).crudCreate.apply(_this$props, ['newsletters', _extends({ data: _this.state.items }, _this.props.currentValues), null, _extends({}, meta, {
          message: (_this.props.currentValues.title || _this.props.initialValues.title) + ' created.'
        })].concat(preview && { message: false }));
      }
      if (preview) {
        setTimeout(function () {
          fetch("https://newsletter.elovade.com" + '/api/build/check/' + _this.props.id).then(function (response) {
            if (response.status >= 200 && response.status < 300) {
              return response.text();
            }
            return Promise.reject();
          }).then(function (data) {
            window.open("https://newsletter.elovade.com" + '/newsletters/' + String(_this.props.id).padStart(4, '0') + '/' + data, 'preview');
          });
        }, 500);
      }
    }, _this.runSubmit = function (values) {
      _this.saveNewsletter(false, { redirectTo: { type: __WEBPACK_IMPORTED_MODULE_6__state_types_routes__["i" /* ROUTE_NEWSLETTERS_EDIT */], step: 'build' } });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EditNewsletter.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data && !this.state.items.length && nextProps.data.length && !this.emptyListState) {
      this.setState({ items: nextProps.data });
    }
  };

  EditNewsletter.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.selected) {
      var active = document.querySelector('.block-active[data-id="' + this.state.selected.id + '"]');
      if (active !== this.active) {
        this.active = active;
        if (active) {
          this.active.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          });
        }
      }
    }
  };

  EditNewsletter.prototype.render = function render() {
    var _this2 = this,
        _ref10;

    var _props = this.props,
        theme = _props.theme,
        title = _props.title,
        step = _props.step,
        saving = _props.saving,
        initialValues = _props.initialValues,
        currentValues = _props.currentValues,
        props = _objectWithoutProperties(_props, ['theme', 'title', 'step', 'saving', 'initialValues', 'currentValues']);

    var values = _extends({}, initialValues, currentValues);
    var saveDisabled = !(values.contact_id && values.title && values.product_id && values.scheduled_at);
    if (step === 'add') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__addContent__["a" /* default */], _extends({}, this.props, { goBuild: this.goBuild, addNew: this.newBlock }));
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: theme['newsletter-edit'] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__ui_Element__["e" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse-item', 'app-bar-inverse-active') },
            _ref7
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse-item') },
            _ref8,
            title || 'New'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: Object(__WEBPACK_IMPORTED_MODULE_3__helpers_classNames__["a" /* default */])(theme, 'app-bar-inverse-item', 'left-margin-auto') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                classes: 'primary',
                styles: ['va-middle', 'right-margin-8'],
                disabled: saveDisabled || !(this.state.items && this.state.items.length),
                onClick: function onClick(e) {
                  return _this2.saveNewsletter(true);
                }
              },
              'Preview'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                classes: 'success',
                styles: ['va-middle', 'right-margin-24'],
                disabled: saveDisabled,
                onClick: function onClick(e) {
                  return _this2.saveNewsletter(false);
                }
              },
              'Save'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                classes: 'clean',
                styles: 'va-middle',
                style: { width: 'auto' },
                onClick: function onClick(e) {
                  return _this2.goBack();
                }
              },
              _ref9
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__ui_Element__["c" /* Container */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__ui_Element__["e" /* Row */],
          null,
          this.getMenu(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__ui_Element__["b" /* Column */],
            {
              classes: ['newsletter-edit-content', (_ref10 = {}, _ref10[theme['with-aside']] = step === 'build', _ref10[theme['newsletter-selected']] = !!this.state.selected, _ref10)]
            },
            step === 'build' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__buildLayout__["a" /* default */], _extends({
              theme: theme,
              newsletterId: this.props.id,
              items: this.state.items,
              images: this.state.images,
              addNew: this.addNew,
              selected: this.state.selected,
              onDragStart: this.onDragStart,
              onDragEnd: this.onDragEnd,
              onSelect: this.onSelectBlock,
              duplicateBlock: this.duplicateBlock,
              removeBlock: this.removeBlock,
              onChange: this.onEditBlock
            }, props)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__setupNewsletter__["a" /* default */], _extends({
              formRef: function formRef(ref) {
                _this2.formRef = ref;
              },
              initialValues: this.props.initialValues,
              theme: theme,
              runSubmit: this.runSubmit,
              goBack: function goBack(e) {
                return _this2.goBack();
              }
            }, props))
          ),
          step ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__ui_Element__["b" /* Column */],
            { classes: ['newsletter-edit-sidebar', 'newsletter-edit-aside'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.state.items && this.state.items.length ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__ui_Button_Button__["a" /* default */],
                {
                  theme: theme,
                  classes: 'secondary',
                  styles: 'va-middle',
                  onClick: this.addNew,
                  key: '0'
                },
                _ref11,
                '\xA0 New content block'
              ), this.state.selected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ui_Blocks_Edit__["a" /* default */], {
                newsletterId: this.props.id,
                item: this.state.selected,
                images: this.state.images,
                theme: theme,
                current: this.state.editedItem,
                onChange: this.onEditBlock,
                key: '1'
              }) : null] : _ref12
            )
          ) : null
        )
      )
    );
  };

  return EditNewsletter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  var id = state.location.payload.id;
  var newsletter = state.rest.newsletters.data[id];
  var initialValues = {};

  if (newsletter) {
    initialValues.id = newsletter.id;
    initialValues.title = newsletter.title;
    initialValues.location = newsletter.location;
    initialValues.product_id = newsletter.product_id;
    initialValues.contact_id = newsletter.contact_id;
    initialValues.scheduled_at = newsletter.scheduled_at;
    initialValues.status = newsletter.status === 'processed';
  }

  return {
    id: id,
    initialValues: initialValues,
    currentValues: state.form.setupNewsletter && state.form.setupNewsletter.values || {},
    step: state.location.payload.step,
    saving: state.rest.saving,
    pageType: state.location.type,
    title: newsletter && newsletter.title || '',
    data: newsletter && newsletter.data || []
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["a" /* goToPage */],
  crudUpdate: __WEBPACK_IMPORTED_MODULE_8__state_actions_data__["g" /* crudUpdate */],
  crudCreate: __WEBPACK_IMPORTED_MODULE_8__state_actions_data__["b" /* crudCreate */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (enhance(EditNewsletter));

/***/ }),

/***/ "./view/Dashboard/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard__ = __webpack_require__("./view/Dashboard/Dashboard.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dashboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__("./view/Dashboard/Search.js");
/* unused harmony reexport Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editNewsletter__ = __webpack_require__("./view/Dashboard/editNewsletter.js");
/* unused harmony reexport editNewsletter */







/***/ }),

/***/ "./view/Dashboard/setupNewsletter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_DatePicker__ = __webpack_require__("./ui/DatePicker/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Data_AutoCompleteField__ = __webpack_require__("./ui/Data/AutoCompleteField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var required = function required(value) {
  return value ? undefined : 'Required';
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  'Company location:'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], { name: 'location', component: 'input', type: 'radio', value: 'de' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'label',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], { name: 'location', component: 'input', type: 'radio', value: 'ch' }),
  'Switzerland'
);

var setupNewsletter = function (_Component) {
  _inherits(setupNewsletter, _Component);

  function setupNewsletter() {
    _classCallCheck(this, setupNewsletter);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  setupNewsletter.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        runSubmit = _props.runSubmit,
        formRef = _props.formRef,
        goBack = _props.goBack,
        submitting = _props.submitting,
        onChange = _props.onChange;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { className: 'form', onSubmit: handleSubmit(runSubmit) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ui_Card__["a" /* Card */],
        { classes: ['t-padding-large', 'colored-card'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: theme['card-content'] },
          _ref,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: theme['flex'] + ' ' + theme['flex-row'] + ' ' + theme['bottom-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              { className: theme['right-margin'] },
              _ref2,
              'Germany'
            ),
            _ref3
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
            name: 'title',
            labelText: 'Newsletter title:',
            component: __WEBPACK_IMPORTED_MODULE_5__ui_Input__["c" /* InputField */],
            placeholder: 'Title',
            id: 'title',
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
            name: 'product_id',
            labelText: 'Product:',
            titleProperty: 'title',
            src: 'products',
            component: __WEBPACK_IMPORTED_MODULE_7__ui_Data_AutoCompleteField__["a" /* default */],
            placeholder: 'Product',
            id: 'product_id',
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
            name: 'contact_id',
            labelText: 'Contact person:',
            titleProperty: 'full_name',
            src: 'contacts',
            filter: function filter(c) {
              return c.disabled;
            },
            component: __WEBPACK_IMPORTED_MODULE_7__ui_Data_AutoCompleteField__["a" /* default */],
            sort: true,
            placeholder: 'Contact person',
            id: 'contact_id',
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
            name: 'scheduled_at',
            labelText: 'Scheduled date:',
            component: __WEBPACK_IMPORTED_MODULE_6__ui_DatePicker__["a" /* DatePicker */],
            closeOnSelect: true,
            placeholder: 'DD-MM-YYYY',
            id: 'scheduled_at',
            validate: [required]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], {
            name: 'status',
            labelText: 'Completed:',
            component: __WEBPACK_IMPORTED_MODULE_5__ui_Input__["a" /* CheckBox */],
            theme: theme,
            id: 'status',
            values: { processed: true, 'in-progress': false }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__ui_Element__["d" /* Flex */],
        { horz: 'right', classes: ['top-margin-24'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
          { theme: theme, styles: 'right-margin', disabled: submitting, onClick: goBack },
          'Cancel'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
          {
            theme: theme,
            type: 'submit',
            classes: ['secondary'],
            styles: 'h-padding-large',
            disabled: submitting,
            getRef: formRef
          },
          'Continue'
        )
      )
    );
  };

  return setupNewsletter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var enhance = __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_2__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["e" /* reduxForm */])({
  enableReinitialize: true,
  form: 'setupNewsletter',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['title', 'product_id', 'contact_id', 'scheduled_at'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(setupNewsletter));

/***/ }),

/***/ "./view/Login/Login.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Card_Card__ = __webpack_require__("./ui/Card/Card.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Input_InputField__ = __webpack_require__("./ui/Input/InputField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png__ = __webpack_require__("./media/el-logo.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_el_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_auth__ = __webpack_require__("./state/actions/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















var renderInput = function renderInput(_ref) {
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      inputProps = _objectWithoutProperties(_ref.input, []),
      props = _objectWithoutProperties(_ref, ['meta', 'input']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Input_InputField__["a" /* default */], _extends({ errorText: touched && error }, inputProps, props, { fullWidth: true }));
};

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png___default.a, alt: '' });

var Login = function Login(props) {
  var login = function login(_ref2) {
    var email = _ref2.email,
        password = _ref2.password;
    var userLogin = props.userLogin;

    userLogin({ email: email, password: password });
  };
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      translate = props.translate,
      theme = props.theme;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__ui_Element__["f" /* default */],
    { classes: 'flex-center', theme: theme },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ui_Element__["f" /* default */],
      { classes: 'login-box', theme: theme },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Card_Card__["a" /* default */],
        { header: _ref3, theme: theme, classes: 'card-dark-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: handleSubmit(login), className: theme['form'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
              name: 'email',
              labelText: 'E-mail:',
              component: renderInput,
              style: { width: '100%' },
              placeholder: 'you@elovade.com',
              id: 'email'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
              name: 'password',
              labelText: 'Password:',
              component: renderInput,
              style: { width: '100%' },
              placeholder: translate('i18n.auth.password'),
              id: 'password',
              type: 'password'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__["a" /* default */],
            {
              theme: theme,
              type: 'submit',
              classes: ['success', 'block'],
              disabled: submitting
            },
            'Login'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['text-center'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__["a" /* default */],
          {
            theme: theme,
            styles: 'forgot-button',
            classes: 'clean',
            onClick: function onClick() {
              return props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__state_actions_routes__["i" /* routeReset */])());
            }
          },
          'Forgot Password ?'
        )
      )
    )
  );
};

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, { userLogin: __WEBPACK_IMPORTED_MODULE_10__state_actions_auth__["c" /* userLogin */] }), __WEBPACK_IMPORTED_MODULE_9__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* reduxForm */])({
  form: 'signIn',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;

    if (!values.email) errors.email = translate('i18n.validation.required');
    if (!values.password) errors.password = translate('i18n.validation.required');
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(Login));

/***/ }),

/***/ "./view/Login/Reset.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Card_Card__ = __webpack_require__("./ui/Card/Card.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Input_InputField__ = __webpack_require__("./ui/Input/InputField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png__ = __webpack_require__("./media/el-logo.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_el_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_auth__ = __webpack_require__("./state/actions/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















var renderInput = function renderInput(_ref) {
  var _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      inputProps = _objectWithoutProperties(_ref.input, []),
      props = _objectWithoutProperties(_ref, ['meta', 'input']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Input_InputField__["a" /* default */], _extends({ errorText: touched && error }, inputProps, props, { fullWidth: true }));
};

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8__media_el_logo_png___default.a, alt: '' });

var Login = function Login(props) {
  var login = function login(_ref2) {
    var username = _ref2.username,
        password = _ref2.password;
    var userLogin = props.userLogin;

    userLogin({ username: username, password: password });
  };
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      theme = props.theme;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__ui_Element__["f" /* default */],
    { classes: ['flex-center'], theme: theme },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ui_Element__["f" /* default */],
      { classes: 'login-box', theme: theme },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Card_Card__["a" /* default */],
        { header: _ref3, theme: theme, classes: 'card-dark-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: handleSubmit(login), className: theme['form'] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], {
              name: 'usernameforgot',
              labelText: 'E-mail:',
              component: renderInput,
              style: { width: '100%' },
              placeholder: 'you@elovade.com',
              id: 'usernameforgot'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__["a" /* default */],
            {
              theme: theme,
              type: 'submit',
              classes: ['success', 'block'],
              disabled: submitting
            },
            'Reset your password'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: theme['text-center'] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button_Button__["a" /* default */],
          {
            theme: theme,
            styles: 'forgot-button',
            classes: 'clean',
            onClick: function onClick() {
              return props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__state_actions_routes__["e" /* routeLogin */])());
            }
          },
          'Back to login'
        )
      )
    )
  );
};

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, { userLogin: __WEBPACK_IMPORTED_MODULE_10__state_actions_auth__["c" /* userLogin */] }), __WEBPACK_IMPORTED_MODULE_9__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* reduxForm */])({
  form: 'reset',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;

    if (!values.usernameforgot) errors.usernameforgot = translate('i18n.validation.required');
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(Login));

/***/ }),

/***/ "./view/Login/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__("./view/Login/Login.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reset__ = __webpack_require__("./view/Login/Reset.js");
/* unused harmony reexport Reset */





/***/ }),

/***/ "./view/Main/Main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("../node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_first_router__ = __webpack_require__("../node_modules/redux-first-router/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Notification__ = __webpack_require__("./ui/Notification/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Modal__ = __webpack_require__("./ui/Modal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_AppBar__ = __webpack_require__("./ui/AppBar/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Breadcrumb_Breadcrumbs__ = __webpack_require__("./ui/Breadcrumb/Breadcrumbs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions_pageflip__ = __webpack_require__("./state/actions/pageflip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state_selectors__ = __webpack_require__("./state/selectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_Theme_themed__ = __webpack_require__("./ui/Theme/themed.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_TranslationProvider__ = __webpack_require__("./i18n/TranslationProvider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_messages__ = __webpack_require__("./i18n/messages.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var messages = {
  en: _extends({}, __WEBPACK_IMPORTED_MODULE_15__i18n_messages__["a" /* default */])
};

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onEnter = function () {}, _this.onLeave = function () {
      var dispatch = _this.props.dispatch;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__state_actions_pageflip__["a" /* pageFlipStop */])());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Container.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.pageflip.animated === this.props.pageflip.animated && nextProps.location.pathname === this.props.location.pathname && nextState === this.state) {
      return false;
    }
    return true;
  };

  Container.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        route = _props.route,
        routesMap = _props.routesMap,
        locale = _props.locale,
        user = _props.user,
        theme = _props.theme,
        _props$pageflip = _props.pageflip,
        animated = _props$pageflip.animated,
        dir = _props$pageflip.dir;

    var curRouteData = routesMap[route];
    var Route = !!(curRouteData && curRouteData.view) ? curRouteData.view : routesMap[routesMap[__WEBPACK_IMPORTED_MODULE_3_redux_first_router__["NOT_FOUND"]]].view;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__i18n_TranslationProvider__["a" /* default */],
      { messages: messages },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'main',
        { className: theme.app },
        !curRouteData.hidden ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_AppBar__["a" /* default */], {
          routesMap: routesMap,
          currentRouteType: route,
          user: user,
          theme: theme,
          dispatch: this.props.dispatch
        }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(theme.body, (_classNames = {}, _classNames[theme['no-scroll']] = animated, _classNames)) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: theme.wrap },
            !curRouteData.hidden ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ui_Breadcrumb_Breadcrumbs__["a" /* default */], {
              theme: theme,
              routesMap: routesMap,
              route: route,
              goToPage: this.props.goToPage
            }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: theme.switcher },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Route, {
                currentRouteType: route,
                currentRouteData: curRouteData,
                routesMap: routesMap,
                dispatch: this.props.dispatch,
                locale: locale,
                theme: theme
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ui_Modal__["a" /* default */], { theme: theme }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ui_Notification__["a" /* default */], { theme: theme })
      )
    );
  };

  return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.auth.user,
    locale: state.locale,
    location: state.location,
    route: Object(__WEBPACK_IMPORTED_MODULE_12__state_selectors__["f" /* getRouteType */])(state),
    routesMap: Object(__WEBPACK_IMPORTED_MODULE_12__state_selectors__["g" /* getRoutesMap */])(state),
    pageflip: state.ui.pageflip
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    goToPage: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_10__state_actions_routes__["a" /* goToPage */], dispatch),
    dispatch: dispatch
  };
};

var enhance = __WEBPACK_IMPORTED_MODULE_5_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_13__ui_Theme_themed__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (enhance(Container));

/***/ }),

/***/ "./view/Main/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Main__ = __webpack_require__("./view/Main/Main.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Main__["a"]; });



/***/ }),

/***/ "./view/Products/Products.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__ = __webpack_require__("./ui/DataTable/Datagrid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__ = __webpack_require__("./ui/DataTable/List.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Data__ = __webpack_require__("./ui/Data/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_Delete__ = __webpack_require__("./icons/Delete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_Edit__ = __webpack_require__("./icons/Edit.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_svg_mail_use_svg__ = __webpack_require__("./media/svg/mail-use.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_svg_mail_use_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__media_svg_mail_use_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__state_actions_notification__ = __webpack_require__("./state/actions/notification.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["a" /* AvatarField */], { source: false, fallback: 'abbrevetation', square: true, letter: true });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["g" /* TextField */], { source: 'vendor', tag: 'div' });

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Select Template' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__media_svg_mail_use_svg___default.a, { fill: 'currentColor', width: '40', height: '40' })
);

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Edit product' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icons_Edit__["a" /* default */], { size: '2.5em' })
);

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Delete product' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_Delete__["a" /* default */], { size: '2.5em' })
);

var Products = function (_Component) {
  _inherits(Products, _Component);

  function Products() {
    var _temp, _this, _ret;

    _classCallCheck(this, Products);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.close = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["a" /* hideModal */])());
    }, _this.delete = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_data__["c" /* crudDelete */])('products', record.id, false, { message: record.title + ' deleted.' }));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["a" /* hideModal */])());
    }, _this.edit = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["h" /* routeProductsEdit */])(record.id));
    }, _this.remove = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["b" /* showModal */])({
        title: 'Permanently delete $title?',
        record: record,
        content: 'This will permanently delete $title from the product list and ' + 'it will no logner be accessible to anyone. All related items will ' + 'remain. This action is irreversible.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'danger', key: 'delete', onClick: function onClick() {
              return _this.delete(record);
            } },
          'Delete'
        )]
      }));
    }, _this.select = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__state_actions_notification__["b" /* showNotification */])(record.id, 'Selecting template for: ' + record.id));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Products.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        props = _objectWithoutProperties(_props, ['theme']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ui_Element__["e" /* Row */],
        { spacing: 'double' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__["a" /* default */],
            _extends({}, props, { resource: 'products', title: false }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__["a" /* default */],
              { sortable: false },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__ui_Data__["d" /* CombinedField */],
                {
                  label: 'Product name',
                  cellName: 'product',
                  className: theme['product-col']
                },
                _ref,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["d" /* CombinedField */],
                  {
                    className: theme['flex-vertical'] + ' ' + theme['flex-grow'] + ' ' + theme['text-left']
                  },
                  _ref2,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Button__["c" /* EditButton */], { source: 'title', title: false, click: this.edit, theme: theme })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__ui_Button__["b" /* ButtonGroup */],
                { width: '12rem', label: 'Manage' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', click: this.select },
                  _ref3
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', click: this.edit },
                  _ref4
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', click: this.remove },
                  _ref5
                )
              )
            )
          )
        )
      )
    );
  };

  return Products;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Products);

/***/ }),

/***/ "./view/Products/editProduct.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'p',
  null,
  'Drop your image here'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'abbrevetation',
  labelText: 'Abbrevetation:',
  component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
  placeholder: 'Abbrevetation (two letters)',
  id: 'abbrevetation'
});

var EditProduct = function (_Component) {
  _inherits(EditProduct, _Component);

  function EditProduct() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditProduct);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveProduct = function (record) {
      _this.props.crudUpdate('products', _this.props.id, record, _this.props.initialValues, false, {
        message: (record.title || _this.props.initialValues.title) + ' updated.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EditProduct.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting,
        color = _props.color,
        _props$initialValues = _props.initialValues,
        data = _props$initialValues === undefined ? {} : _props$initialValues;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form product', onSubmit: handleSubmit(this.saveProduct) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
                  { size: '50' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'vendor',
                    labelText: 'Vendor:',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    placeholder: 'Vendor name',
                    id: 'vendor',
                    value: data.vendor
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'title',
                    labelText: 'Product:',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    placeholder: 'Product',
                    id: 'title',
                    value: data.title
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                      name: 'color',
                      labelText: 'Color:',
                      component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                      placeholder: 'Default color (HEX value)',
                      id: 'color',
                      onFocus: this.handleClick,
                      value: color
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
                      className: theme['color-field'],
                      style: { backgroundColor: '#' + color }
                    })
                  ),
                  _ref2,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'url',
                    labelText: 'URL (DE):',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    style: { marginBottom: 0 },
                    placeholder: 'Product url',
                    id: 'url'
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'url_ch',
                    labelText: 'URL (CH):',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    style: { marginBottom: 0 },
                    placeholder: 'Product url (switzerland - ch)',
                    id: 'url_ch'
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
                  { size: '50', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: theme['product-logo-label'] },
                    'Product logo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'logo',
                    component: this.renderImage,
                    classes: theme['drop-wrapper'] + ' ' + theme['flex-cell'],
                    id: 'logo'
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return EditProduct;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  var productId = state.location.payload.id;
  return {
    id: productId,
    initialValues: state.rest.products.data[productId],
    color: state.form.editProduct && state.form.editProduct.values && state.form.editProduct.values.color || state.rest.products.data[productId] && state.rest.products.data[productId].color || 'fff',
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__["a" /* goToPage */],
  crudUpdate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["g" /* crudUpdate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'editProduct',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['vendor', 'title', 'color', 'abbrevetation'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(EditProduct));

/***/ }),

/***/ "./view/Products/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Products__ = __webpack_require__("./view/Products/Products.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Products__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editProduct__ = __webpack_require__("./view/Products/editProduct.js");
/* unused harmony reexport editProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__newProduct__ = __webpack_require__("./view/Products/newProduct.js");
/* unused harmony reexport newProduct */







/***/ }),

/***/ "./view/Products/newProduct.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_translate__ = __webpack_require__("./i18n/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'p',
  null,
  'Drop your image here'
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'abbrevetation',
  labelText: 'Abbrevetation:',
  component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
  placeholder: 'Abbrevetation (two letters)',
  id: 'abbrevetation'
});

var newProduct = function (_Component) {
  _inherits(newProduct, _Component);

  function newProduct() {
    var _temp, _this, _ret;

    _classCallCheck(this, newProduct);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveProduct = function (record) {
      _this.props.crudCreate('products', record, false, {
        message: (record.title || _this.props.initialValues.title) + ' created.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  newProduct.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting,
        _props$data = _props.data,
        data = _props$data === undefined ? {} : _props$data;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form product', onSubmit: handleSubmit(this.saveProduct) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
                  { size: '50' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'vendor',
                    labelText: 'Vendor:',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    placeholder: 'Vendor name',
                    id: 'vendor',
                    value: data.vendor
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'title',
                    labelText: 'Product:',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    placeholder: 'Product',
                    id: 'title',
                    value: data.title
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { position: 'relative' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                      name: 'color',
                      labelText: 'Color:',
                      component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                      placeholder: 'Default color (HEX value)',
                      id: 'color',
                      onFocus: this.handleClick,
                      value: data.color
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
                      className: theme['color-field'],
                      style: { background: '#' + data.color }
                    })
                  ),
                  _ref2,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'url',
                    labelText: 'Url:',
                    component: __WEBPACK_IMPORTED_MODULE_10__ui_Input__["c" /* InputField */],
                    style: { marginBottom: 0 },
                    placeholder: 'Product url',
                    id: 'url'
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__ui_Element__["a" /* Cell */],
                  { size: '50', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: theme['product-logo-label'] },
                    'Product logo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'logo',
                    component: this.renderImage,
                    classes: theme['drop-wrapper'] + ' ' + theme['flex-cell'],
                    id: 'logo'
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return newProduct;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  return {
    isLoading: state.rest.loading > 0,
    data: state.form.newProduct && state.form.newProduct.values || {}
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_5__state_actions_routes__["a" /* goToPage */],
  crudCreate: __WEBPACK_IMPORTED_MODULE_6__state_actions_data__["b" /* crudCreate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_4__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'newProduct',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['vendor', 'title', 'color', 'abbrevetation'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(newProduct));

/***/ }),

/***/ "./view/Users/Users.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__ = __webpack_require__("./ui/DataTable/Datagrid.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__ = __webpack_require__("./ui/DataTable/List.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Data__ = __webpack_require__("./ui/Data/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Button__ = __webpack_require__("./ui/Button/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__ = __webpack_require__("./ui/Tooltip/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions_modal__ = __webpack_require__("./state/actions/modal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_Delete__ = __webpack_require__("./icons/Delete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_Edit__ = __webpack_require__("./icons/Edit.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ui_Data__["a" /* AvatarField */], { source: 'picture', fallback: 'full_name', letter: true });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Edit user' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icons_Edit__["a" /* default */], { size: '2.5em' })
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_6__ui_Tooltip__["a" /* Tooltip */],
  { content: 'Delete user' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_Delete__["a" /* default */], { size: '2.5em' })
);

var Users = function (_Component) {
  _inherits(Users, _Component);

  function Users() {
    var _temp, _this, _ret;

    _classCallCheck(this, Users);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.close = function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["a" /* hideModal */])());
    }, _this.delete = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__state_actions_data__["c" /* crudDelete */])('users', record.id, false, { message: record.full_name + ' deleted.' }));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["a" /* hideModal */])());
    }, _this.edit = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["j" /* routeUsersEdit */])(record.id));
    }, _this.remove = function (record) {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__state_actions_modal__["b" /* showModal */])({
        title: 'Permanently delete $full_name?',
        record: record,
        content: 'This will permanently delete $full_name from the team list. ' + 'All related items will remain. This action is irreversible.',
        buttons: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'inverted', key: 'cancel', onClick: _this.close },
          'Cancel'
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__ui_Button__["a" /* Button */],
          { classes: 'danger', key: 'delete', onClick: function onClick() {
              return _this.delete(record);
            } },
          'Delete'
        )]
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Users.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        props = _objectWithoutProperties(_props, ['theme']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__ui_Element__["e" /* Row */],
        { spacing: 'double' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__ui_Element__["a" /* Cell */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ui_DataTable_List__["a" /* default */],
            _extends({}, props, { resource: 'users', title: false }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__ui_DataTable_Datagrid__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__ui_Data__["d" /* CombinedField */],
                { label: 'Team members', cellName: 'user', className: theme['user-col'] },
                _ref,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ui_Button__["c" /* EditButton */], { source: 'full_name', title: false, click: this.edit, theme: theme })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__ui_Button__["b" /* ButtonGroup */],
                { width: '10rem', label: 'Manage' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  {
                    tag: 'div',
                    sortable: false,
                    click: this.edit,
                    classes: ['flex-center', 'flex-middle']
                  },
                  _ref2
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__ui_Data__["c" /* ButtonField */],
                  { tag: 'div', sortable: false, click: this.remove },
                  _ref3
                )
              )
            )
          )
        )
      )
    );
  };

  return Users;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Users);

/***/ }),

/***/ "./view/Users/editUser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Image, JPG, PNG',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    'min. size 360 x 360 px'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'DROP IMAGE TO UPLOAD'
  )
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'full_name',
  labelText: 'Full name:',
  component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
  placeholder: 'Full name',
  id: 'full_name'
});

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'phone',
  labelText: 'Phone:',
  component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
  placeholder: 'Phone',
  id: 'phone'
});

var _ref4 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'email',
  labelText: 'E-Mail address:',
  component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
  placeholder: 'you@elovade.com',
  id: 'email'
});

var _ref5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
  name: 'password',
  type: 'password',
  labelText: 'Password (min. 6 characters):',
  component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
  id: 'password'
});

var EditUser = function (_Component) {
  _inherits(EditUser, _Component);

  function EditUser() {
    var _temp, _this, _ret;

    _classCallCheck(this, EditUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveUser = function (record) {
      _this.props.crudUpdate('users', _this.props.id, record, _this.props.initialValues, false, {
        message: (record.full_name || _this.props.initialValues.full_name) + ' updated.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EditUser.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.me === this.props.me && nextProps.id === undefined) {
      return false;
    }
    return true;
  };

  EditUser.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting,
        me = _props.me,
        _props$initialValues = _props.initialValues,
        data = _props$initialValues === undefined ? {} : _props$initialValues;

    var boxClass = me !== data.id ? [theme['square-box'], theme['edit-user']].join(' ') : theme['square-box'];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: handleSubmit(this.saveUser) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
                  { size: '33', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'picture',
                    component: this.renderImage,
                    classes: boxClass,
                    id: 'picture'
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
                  { size: '66' },
                  _ref2,
                  _ref3,
                  _ref4,
                  me === data.id ? _ref5 : null
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return EditUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  var userId = state.location.payload.id;
  return {
    id: userId,
    me: state.auth.user.id,
    initialValues: state.rest.users.data[userId],
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["a" /* goToPage */],
  crudUpdate: __WEBPACK_IMPORTED_MODULE_10__state_actions_data__["g" /* crudUpdate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_11__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'editUser',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['full_name', 'email', 'phone'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(EditUser));

/***/ }),

/***/ "./view/Users/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users__ = __webpack_require__("./view/Users/Users.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Users__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editUser__ = __webpack_require__("./view/Users/editUser.js");
/* unused harmony reexport editUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__newUser__ = __webpack_require__("./view/Users/newUser.js");
/* unused harmony reexport newUser */







/***/ }),

/***/ "./view/Users/newUser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("../node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__("../node_modules/redux-form/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("../node_modules/recompose/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Card__ = __webpack_require__("./ui/Card/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Element__ = __webpack_require__("./ui/Element/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_Input__ = __webpack_require__("./ui/Input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__ = __webpack_require__("./ui/Button/Button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_Data_ImageField__ = __webpack_require__("./ui/Data/ImageField.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__ = __webpack_require__("./state/actions/routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions_data__ = __webpack_require__("./state/actions/data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_translate__ = __webpack_require__("./i18n/translate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Image, JPG, PNG',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
    'min. size 360 x 360 px'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'DROP IMAGE TO UPLOAD'
  )
);

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
  { size: '66' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'full_name',
    labelText: 'Full name:',
    component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
    placeholder: 'Full name',
    id: 'full_name'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'phone',
    labelText: 'Phone:',
    component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
    placeholder: 'Phone',
    id: 'phone'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'email',
    labelText: 'E-Mail address:',
    component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
    placeholder: 'you@elovade.com',
    id: 'email'
  }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
    name: 'password',
    type: 'password',
    labelText: 'Password (min. 6 characters):',
    component: __WEBPACK_IMPORTED_MODULE_6__ui_Input__["c" /* InputField */],
    id: 'password'
  })
);

var NewUser = function (_Component) {
  _inherits(NewUser, _Component);

  function NewUser() {
    var _temp, _this, _ret;

    _classCallCheck(this, NewUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderImage = function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__ui_Input__["b" /* ImageInput */],
        _extends({}, props, {
          theme: _this.props.theme,
          source: 'image',
          label: 'Image',
          accept: 'image/*',
          placeholder: _ref
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ui_Data_ImageField__["a" /* default */], { source: 'src', title: 'title', theme: _this.props.theme })
      );
    }, _this.saveUser = function (record) {
      _this.props.crudCreate('users', record, false, {
        message: (record.full_name || _this.props.initialValues.full_name) + ' created.'
      });
    }, _this.goBack = function () {
      _this.props.dispatch(_this.props.goToPage(_this.props.currentRouteData.parent));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  NewUser.prototype.render = function render() {
    var _props = this.props,
        theme = _props.theme,
        handleSubmit = _props.handleSubmit,
        submitting = _props.submitting;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ui_Element__["c" /* Container */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ui_Element__["b" /* Column */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { className: 'form', onSubmit: handleSubmit(this.saveUser) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__ui_Card__["a" /* Card */],
              { classes: ['v-padding-large', 'colored-card'] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__ui_Element__["e" /* Row */],
                { gutter: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__ui_Element__["a" /* Cell */],
                  { size: '33', dir: 'vertical' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
                    name: 'picture',
                    component: this.renderImage,
                    classes: theme['square-box'],
                    id: 'picture'
                  })
                ),
                _ref2
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__ui_Element__["d" /* Flex */],
            { horz: 'right', classes: ['top-margin'] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                styles: 'right-margin',
                disabled: submitting,
                onClick: this.goBack
              },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__ui_Button_Button__["a" /* default */],
              {
                theme: theme,
                type: 'submit',
                classes: ['secondary'],
                styles: 'h-padding-large',
                disabled: submitting
              },
              'Save'
            )
          )
        )
      )
    );
  };

  return NewUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, props) {
  return {
    data: state.form.newUser && state.form.newUser.values || {},
    isLoading: state.rest.loading > 0
  };
}

var enhance = __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, {
  goToPage: __WEBPACK_IMPORTED_MODULE_9__state_actions_routes__["a" /* goToPage */],
  crudCreate: __WEBPACK_IMPORTED_MODULE_10__state_actions_data__["b" /* crudCreate */],
  change: __WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */]
}), __WEBPACK_IMPORTED_MODULE_11__i18n_translate__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({
  form: 'newUser',
  validate: function validate(values, props) {
    var errors = {};
    var translate = props.translate;
    ['full_name', 'email', 'phone', 'password'].forEach(function (field) {
      if (!values[field]) errors[field] = translate('i18n.validation.required');
    });
    return errors;
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (enhance(NewUser));

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/babel-regenerator-runtime/runtime.js");
__webpack_require__("../config/polyfills.js");
module.exports = __webpack_require__("./index.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// app.a2565d97cb76f6f2a69d.js